const CONSENT_PEP = `<p style="text-align:center;">
<strong>Oświadczenie PEP</strong>
</p>
<p>&nbsp;</p>
<p style="text-align:justify;">Oświadczam, że zapoznałam/em się z poniższa informacja dotyczącą przynależności do grupy PEP*. W przypadku stwierdzenia przynależności do grupy PEP zobowiązuje się do kontaktu telefonicznego z serwisem pożyczkowym. W przypadku niestwierdzenia przynależności do grupy PEP, kontynuuje składanie wniosku o pożyczkę.</p>
<p style="text-align:justify;">Jestem świadoma/y odpowiedzialności karnej za złożenie fałszywego oświadczenia. Przez PEP, członków rodziny PEP oraz osoby znane jako bliscy współpracownicy PEP rozumie się:</p>
<ol>
<li>szefów państw, szefów rządów, ministrów, wiceministrów, sekretarzy stanu, podsekretarzy stanu, w tym Prezydenta Rzeczypospolitej Polskiej, Prezesa Rady Ministrów i wiceprezesa Rady Ministrów;</li>
<li>członków parlamentu lub podobnych organów ustawodawczych, w tym posłów i senatorów;</li>
<li>członków organów zarządzających partii politycznych;</li>
<li>członków sądów najwyższych, trybunałów konstytucyjnych oraz innych organów sądowych wysokiego szczebla, których decyzje nie podlegają zaskarżeniu, z wyjątkiem trybów nadzwyczajnych, w tym sędziów Sądu Najwyższego, Trybunału Konstytucyjnego, Naczelnego Sądu Administracyjnego, wojewódzkich sądów administracyjnych oraz sędziów sądów apelacyjnych;</li>
<li>członków trybunałów obrachunkowych lub zarządów banków centralnych, w tym Prezesa oraz członków Zarządu NBP;</li>
<li>ambasadorów, chargé d'affaires oraz wyższych oficerów sił zbrojnych;</li>
<li>członków organów administracyjnych, zarządczych lub nadzorczych przedsiębiorstw państwowych, w tym dyrektorów przedsiębiorstw państwowych oraz członków zarządów i rad nadzorczych spółek z udziałem Skarbu Państwa, w których ponad połowa akcji albo udziałów należy do Skarbu Państwa lub innych państwowych osób prawnych;</li>
<li>dyrektorów, zastępców dyrektorów oraz członków organów organizacji międzynarodowych lub osoby pełniące równoważne funkcje w tych organizacjach;</li>
<li>dyrektorów generalnych w urzędach naczelnych i centralnych organów państwowych, dyrektorów generalnych urzędów wojewódzkich oraz kierowników urzędów terenowych organów rządowej administracji specjalnej;<br>&nbsp;</li>
</ol>
<p>Przez członków rodziny osoby zajmującej eksponowane stanowisko polityczne – rozumie się:</p>
<ol>
<li>małżonka lub osobę pozostającą we wspólnym pożyciu z osobą zajmującą eksponowane stanowisko polityczne;</li>
<li>dziecko osoby zajmującej eksponowane stanowisko polityczne i jego małżonka lub osoby pozostającej we wspólnym pożyciu;</li>
<li>rodziców osoby zajmującej eksponowane stanowisko polityczne;</li>
</ol>
<p>Przez osoby znane jako bliscy współpracownicy osoby zajmującej eksponowane stanowisko polityczne – rozumie się:</p>
<ol>
<li style="text-align:justify;">osoby fizyczne będące beneficjentami rzeczywistymi osób prawnych, jednostek organizacyjnych nieposiadających osobowości prawnej lub trustów wspólnie z osobą zajmującą eksponowane stanowisko polityczne lub utrzymujące z taką osobą inne bliskie stosunki związane z prowadzoną działalnością gospodarczą;</li>
<li style="text-align:justify;">osoby fizyczne będące jedynym beneficjentem rzeczywistym osób prawnych, jednostek organizacyjnych nieposiadających osobowości prawnej lub trustu, o których wiadomo, że zostały utworzone w celu uzyskania faktycznej korzyści przez osobę zajmującą eksponowane stanowisko polityczne.</li>
</ol>`;


const CONSENT_INFO_CLAUSE = ``;


const CONSENT_RULES = `<p style="text-align:center;">
<strong>Regulamin świadczenia usług drogą elektroniczną</strong>
</p>
<p style="text-align:center;">
<br>
<strong>§1. REGULAMIN</strong>
</p>
<p style="text-align:justify;">
<br>Regulamin świadczenia usług drogą elektroniczną, zwany dalej Regulaminem, określa zasady świadczenia przez Minicredit Sp. z o.o. z siedzibą w Warszawie, ul. Migdałowa 4, 02-796 Warszawa, wpisaną do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st. Warszawy w Warszawie, XIII Wydział Gospodarczy KRS pod numerem KRS 0000371165, NIP 5252494263, REGON 142694604, RIP: RIP000616, o kapitale zakładowym w wysokości 5 225 000,00 zł zwanej dalej Spółką, usług drogą elektroniczną, udostępnianych w ramach Portalu internetowego Spółki pod adresem internetowym&nbsp;<a href="http://www.minicredit.pl/">www.minicredit.pl</a>.</p>
<p style="text-align:center;">
<br>
<strong>§2. DEFINICJE</strong>
</p>
<p style="text-align:justify;">
<br>
<span class="text-small">Pojęcia użyte w niniejszym Regulaminie otrzymują znaczenia nadane im poniżej:</span>
</p>
<ol>
<li style="text-align:justify;">
<strong>Dział Obsługi Klienta/Użytkownika</strong> – zespół pracowników lub współpracowników Spółki, uprawnionych do kontaktu i obsługi Klienta/Użytkownika w imieniu Spółki;</li>
<li style="text-align:justify;">
<strong>Hasło</strong> – Ciąg znaków alfa-numerycznych ustanowionych przez Użytkownika/Klienta, umożliwiający jednoznaczną identyfikację i weryfikację tożsamości Użytkownika/Klienta w Systemie teleinformatycznym Spółki;</li>
<li style="text-align:justify;">
<strong>Login</strong> – adres e-mail Użytkownika/Klienta, wskazany w Koncie Klienta/Użytkownika za pomocą którego Użytkownik/Klient loguje się do Konta Użytkownika/Klienta, który podlegał wcześniejszej autoryzacji w zakresie czynności dokonanych przez Użytkownika/Klienta;</li>
<li style="text-align:justify;">
<strong>Spółka</strong> - Minicredit spółka z ograniczoną odpowiedzialnością z siedzibą w Warszawie mieszcząca się pod adresem ul. Migdałowa 4, 02-796 Warszawa, wpisaną do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st. Warszawy w Warszawie, XIII Wydział Gospodarczy KRS pod numerem KRS 0000371165, NIP 5252494263, REGON 142694604, RIP: RIP000616, o kapitale zakładowym w wysokości 5 225 000,00 zł.</li>
<li style="text-align:justify;">
<strong>Strona internetowa</strong> – strona&nbsp;<a href="http://www.minicredit.pl">www.minicredit.pl</a>
</li>
<li style="text-align:justify;">
<strong>RODO</strong> – Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE</li>
<li style="text-align:justify;">
<strong>Wniosek o Pożyczkę</strong> – wniosek o zawarcie umowy pożyczki, złożony przez Klienta/Użytkownika za pośrednictwem Systemu teleinformatycznego Spółki, po zalogowaniu do Konta Użytkownika/Klienta;</li>
<li style="text-align:justify;">
<strong>Umowa Pożyczki</strong> - umowa o kredyt konsumencki zawierana w oparciu o wzorzec Umowy Pożyczki Minicredit.pl, pomiędzy Klientem/Użytkownikiem a Spółką na wniosek Klienta/Użytkownika złożony w Systemie teleinformatycznym Spółki.</li>
<li style="text-align:justify;">
<strong>Usługa</strong> – usługa świadczona przez Spółkę drogą elektroniczną, bez jednoczesnej obecności stron (na odległość), poprzez przekaz danych na<br>indywidualne żądanie usługobiorcy, przesyłanej i otrzymywanej za pomocą urządzeń do elektronicznego przetwarzania, włącznie z kompresją cyfrową, i przechowywania danych, która jest w całości nadawana, odbierana lub transmitowana za pomocą sieci telekomunikacyjnej w rozumieniu ustawy z dnia 16 lipca 2004 r. – Prawo telekomunikacyjne, określona w pkt. IV Regulaminu, polegająca m.in. na zapewnieniu Użytkownikowi/Klientowi dostępu do Konta Użytkownika/Klienta i możliwości złożenia Dyspozycji za pośrednictwem systemu teleinformatycznego Spółki.</li>
<li style="text-align:justify;">
<strong>Ustawa</strong> - ustawa z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną (tj. Dz.U. z 2017 r. poz. 1219 ze zm.)</li>
<li style="text-align:justify;">
<strong>Osoba fizyczna</strong> – konsument w rozumieniu przepisów ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny.</li>
<li style="text-align:justify;">
<strong>Użytkownik/Klient</strong> – osoba fizyczna, która skutecznie założyła Konto Użytkownika w Systemie teleinformatycznym Pożyczkodawcy.</li>
<li style="text-align:justify;">
<strong>Konto Użytkownika/Klienta</strong> – wydzielona przestrzeń w Systemie teleinformatycznym Pożyczkodawcy, z ograniczonym dostępem, zastrzeżonym dla innych Użytkowników, do której Użytkownik posiada dostęp za pośrednictwem Strony Internetowej, po prawidłowej identyfikacji adresu poczty elektronicznej i podaniu prawidłowego hasła dostępu, umożliwiająca Użytkownikowi składanie Dyspozycji.</li>
<li style="text-align:justify;">
<strong>Dyspozycje</strong> – oświadczenia woli składane przez Użytkownika w Systemie Teleinformatycznym Pożyczkodawcy, na wydzielonym koncie Użytkownika, dokumentowane przez Pożyczkodawcę w formie Logów.</li>
<li style="text-align:justify;">
<strong>Log</strong> – zdarzenie, czynność odnotowana w rejestrze zdarzeń lub dzienniku zdarzeń, prowadzonych w strukturach Systemu teleinformatycznego Pożyczkodawcy.</li>
<li style="text-align:justify;">
<strong>System teleinformatyczny/Serwis</strong> – zespół współpracujących ze sobą urządzeń informatycznych i oprogramowania, zapewniający przetwarzanie i przechowywanie, a także wysyłanie i odbieranie danych poprzez sieci telekomunikacyjne za pomocą właściwego dla danego rodzaju sieci urządzenia końcowego w rozumieniu Ustawy z dnia 16 lipca 2004 r. – Prawo telekomunikacyjne</li>
</ol>
<p style="text-align:center;">
<br>
<strong>§3. CEL REGULAMINU</strong>
</p>
<ol>
<li style="text-align:justify;">Regulamin określa rodzaje, zakres oraz warunki świadczenia Usług przez Spółkę, za pośrednictwem Strony internetowej, która współtworzy system teleinformatyczny Spółki, warunki zawierania i rozwiązywania umów o świadczenie takich Usług, a także tryb postępowania reklamacyjnego.</li>
<li style="text-align:justify;">W sprawach nieuregulowanych w Regulaminie, w szczególności do składania oświadczeń woli w postaci elektronicznej, stosuje się przepisy Kodeksu cywilnego oraz innych ustaw.</li>
<li style="text-align:justify;">Użytkownik przyjmuje do wiadomości i w całości akceptuje, że zakazane jest dostarczanie do Spółki treści o charakterze bezprawnym, obraźliwym, treści mogących wprowadzić w błąd oraz treści zawierających wirusy lub mogących wywołać zakłócenia lub uszkodzenia systemów teleinformatycznych.</li>
<li style="text-align:justify;">Regulamin nie ma zastosowania do innych usług świadczonych przez Spółkę w zakresie, w jakim zasady korzystania z usług są uregulowane odrębnymi umowami, regulaminami i uzgodnieniami poczynionymi między Spółką a Użytkownikiem.</li>
</ol>
<p style="text-align:center;">
<br>
<strong>§4. POSTANOWIENIA OGÓLNE</strong>
</p>
<ol>
<li style="text-align:justify;">Regulamin został opracowany na podstawie przepisów Ustawy.</li>
<li style="text-align:justify;">Regulamin jest każdorazowo udostępniony Użytkownikom Systemu Teleinformatycznego, nieodpłatnie, za pośrednictwem Strony Internetowej w formie, która umożliwia jego pobranie, utrwalenie i wydrukowanie. Udostępnienie Regulaminu nie podlega żadnym ograniczeniom wobec Użytkownika. Jednocześnie treść Regulaminu udostępniana jest Użytkownikowi na trwałym nośniku danych poprzez wiadomość e-mail skierowaną na podany w Koncie adres poczty elektronicznej.</li>
<li style="text-align:justify;">Użytkownik rozpoczyna korzystanie z Usług MiniCredit Sp. z o.o. poprzez wypełnienie formularza rejestracyjnego i pozytywne zweryfikowanie, wskazanego przez Użytkownika numeru telefonu oraz wskazanego przez Użytkownika adresu mailowego.</li>
<li style="text-align:justify;">Wypełnienie formularza rejestracyjnego i pozytywne zakończenie procesu weryfikacji numeru telefonu oraz adresu mailowego jest równoznaczne ze skutecznym utworzeniem przez Użytkownika Konta Użytkownika w Serwisie, za pośrednictwem którego Użytkownik uprawniony jest do składania Dyspozycji stanowiących wyrażenie przez niego oświadczenia woli objętego Dyspozycją.</li>
<li style="text-align:justify;">Decyzja w sprawie przyznania bądź nie Pożyczki, nie ma wpływu na skuteczność utworzenia Konta Użytkownika w Serwisie.</li>
<li style="text-align:justify;">Obowiązkiem Użytkownika jest zapoznanie się z treścią Regulaminu i zaakceptowanie jego postanowień, przed rozpoczęciem korzystania z Usług.</li>
<li style="text-align:justify;">Rozpoczęcie korzystania z Usług, objętych Regulaminem jest równoznaczne z zapoznaniem się z jego treścią, zrozumienie oraz pełną akceptacją jego warunków.</li>
<li style="text-align:justify;">Użytkownik zobowiązany jest do korzystania z Serwisu, w tym z udostępnianiem w nim informacji, wyłącznie na własny użytek osobisty, zgodnie z przeznaczeniem Serwisu, przepisami prawa, postanowieniami Regulaminu oraz dobrymi obyczajami, począwszy od momentu rozpoczęcia korzystania z Serwisu.</li>
<li style="text-align:justify;">Korzystanie z Serwisu jest nieodpłatne.</li>
<li style="text-align:justify;">Zalogowanie do Konta Klienta wymaga pozytywnej weryfikacji tożsamości Użytkownika za pośrednictwem danych dostępowych do Konta znanych wyłącznie Użytkownikowi.</li>
</ol>
<p style="text-align:center;">
<br>
<strong>§5. ZAKRES USŁUG</strong>
</p>
<p style="text-align:justify;">
<span class="text-small">Spółką świadczy drogą elektroniczną usługi za pośrednictwem Serwisu o następującej treści:</span>
</p>
<ol>
<li style="text-align:justify;">Utworzenie Konta Użytkownika, w profilu Klienta/Użytkownika;</li>
<li style="text-align:justify;">Możliwość złożenia Dyspozycji za pośrednictwem Konta Klienta;</li>
<li style="text-align:justify;">Weryfikacja i prowadzenie profilu Klienta;</li>
<li style="text-align:justify;">Prowadzenie rejestru zdarzeń w formie elektronicznej, przechowywanych w formie logów;</li>
<li style="text-align:justify;">Składanie Wniosków o Pożyczkę;</li>
<li style="text-align:justify;">Aktualizacje danych osobowych w profilu Klienta, na wyraźne zlecenie Klienta, w zakresie podanych przez niego aktualizacyjnych danych osobowych;</li>
<li style="text-align:justify;">Dostęp do aktualnego stanu zobowiązania Użytkownika, wynikającego z zawartej za pośrednictwem Serwisu Umowy;</li>
<li style="text-align:justify;">Szybki dostęp do informacji o spłacie zobowiązania, w tym w szczególności o terminie spłaty zobowiązania, rachunku bankowym do spłaty, na który ma zostać dokonana spłata zobowiązania, wynikającego z zawartej za pośrednictwem Serwisu Umowy Pożyczki;</li>
<li style="text-align:justify;">W przypadku wyrażenia przez Użytkownika zgody – informowanie Użytkownika o przysługujących mu promocjach, rabatach oraz o oferowanych przez Spółkę lub jej partnerów biznesowych produktach i usługach;</li>
</ol>
<p style="text-align:justify;">&nbsp;</p>
<p style="text-align:center;">
<strong>§6. WYMAGANIA TECHNICZNE</strong>
</p>
<ol style="list-style-type:decimal;">
<li style="text-align:justify;">W celu prawidłowego korzystania Serwisu, dostarczanego przez Spółkę, z pośrednictwem Konta Klienta, konieczne jest spełnienie wskazanych poniżej wymagań technicznych, w postaci:<ul style="list-style-type:disc;">
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">komputer (PC, Mac, inny) lub inne urządzenie multimedialne z dostępem do Internetu;</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">korzystanie z przeglądarki internetowej Internet Explorer 7.0 (lub nowszej) albo Mozilla Firefox 3.6 (lub nowszej) obsługującej pliki Cookies, JavaScript oraz Adobe Flash Player (dla niektórych treści);</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">dostęp do poczty elektronicznej (e-mail);</span>
<br>&nbsp;</li>
</ul>
</li>
<li style="text-align:justify;">Użytkownik zobowiązany jest do:<ul style="list-style-type:disc;">
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">korzystania ze Strony Internetowej i Konta Klienta w sposób zgodny z Regulaminem, prawem powszechnie obowiązującym oraz dobrymi obyczajami, obejmującym między innymi poszanowaniem praw osób trzecich takich jak dobra osobiste czy prawo własności intelektualnej;</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">podania wyłącznie prawdziwych, prawidłowych, dokładnych, kompletnych i nie wprowadzających w błąd danych osobowych odnoszących się wyłącznie do jego osoby;</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">nieprzekazywania treści o charakterze bezprawnym, czy w jakikolwiek sposób naruszający prawa osób trzecich lub Spółki;</span>
<br>&nbsp;</li>
</ul>
</li>
</ol>
<ol>
<li style="text-align:justify;">Użytkownik korzystający z Serwisu powinien używać legalnego oprogramowania, posiadać na bieżąco aktualizowane oprogramowanie antywirusowe oraz firewall.</li>
<li style="text-align:justify;">W celu prawidłowego działania Serwisu przeglądarka powinna mieć ustawienia bezpieczeństwa na poziomie przynajmniej średnim.</li>
<li style="text-align:justify;">Wyłączenie funkcji obsługi Cookies nie blokuje możliwości korzystania z Usług, jednakże może w niektórych sytuacjach prowadzić do utrudnień w połączeniu ze Stroną Internetową. Tym samym Spółka nie ponosi odpowiedzialności za utrudnienia w korzystaniu ze Strony Internetowej lub Konta Klienta wynikające z wyłączenia przez Klienta obsługi Cookies w jakimkolwiek zakresie.</li>
</ol>
<p style="text-align:center;">
<br>
<strong>§7. INFORMACJE O PROCESIE ZAWARCIA UMOWY POŻYCZKI, W TYM O CZYNNOŚCIACH TECHNICZNYCH SKŁADAJĄCYCH SIĘ NA PROCEDURĘ ZAWARCIA UMOWY POŻYCZKI</strong>
</p>
<ol>
<li style="text-align:justify;">Świadczone przez Spółkę usługi elektroniczne, na podstawie niniejszego Regulaminu oraz założenie przez Użytkownika aktywnego Konta Użytkownika, ma na celu stworzenie Serwisu, umożliwiającego Spółce i Użytkownikowi składanie oświadczeń woli w formie elektronicznej w postaci Dyspozycji, umożliwiających skuteczne zawarcie Umów Pożyczek w formie dokumentowej.</li>
<li style="text-align:justify;">Zawarcie Umowy pożyczki na odległość możliwie jest jedynie dla Użytkowników posiadających aktywne Konto Klienta.</li>
<li style="text-align:justify;">Zasady zawarcia i rozwiązania Umowy pożyczki, warunki, okres na jaki Umowa pożyczki może zostać zawarta, prawa i obowiązki obu stron Umowy pożyczki oraz warunki jej wykonywania, są określone w Umowie pożyczki, której wzór udostępniany jest w Serwisie.</li>
<li style="text-align:justify;">Umowa pożyczki jest zawierana na okres wskazany we Wniosku o Pożyczkę. Minimalny i maksymalny okres na jaki można zawrzeć Umowę pożyczki są określone we Wniosku o pożyczkę.</li>
<li style="text-align:justify;">Wniosek o Pożyczkę można wypełnić wyłącznie w serwisie, dostępnym w domenie&nbsp;<a href="http://www.minicredit.pl">www.minicredit.pl</a>, po zalogowaniu do aktywnego i zweryfikowanego Konta Klienta. Po wybraniu wniosku o zawarcie Umowy pożyczki, Użytkownik wprowadza samodzielne wedle własnego uznania do systemu informatycznego dane potrzebne do określenia wysokości kwoty do spłaty i zawarcia Umowy. Na podstawie informacji podanych przez Użytkownika, system informatyczny wylicza koszty związane z zawarciem Umowy pożyczki o czym informowany jest Użytkownik za pośrednictwem systemu teleinformatycznego w domenie.</li>
<li style="text-align:justify;">W trakcie wypełniania Wniosku o pożyczkę dane podlegają bieżącej walidacji (Użytkownik jest na bieżąco informowany o nieprawidłowościach, które są możliwe do zidentyfikowania przez system informatyczny w wypełnianiu pól wniosku poprzez stosowne komunikaty).</li>
<li style="text-align:justify;">Użytkownik jest zobowiązany przedstawić we Wniosku o pożyczkę wyłącznie prawidłowe dane, o które zapytywała Spółka. Za niewłaściwe, błędne, nieprawdziwe bądź niekompletne wypełnienie danych odpowiedzialność ponosi wyłącznie Użytkownik we własnym zakresie.</li>
<li style="text-align:justify;">Po wskazaniu parametrów finansowych Umowy pożyczki, na procedurę zawarcia Umowy pożyczki, składają się łącznie następujące czynności:<ol>
<li style="text-align:justify;">wypełnienie danymi Użytkownika formularzy udostępnionych na stronie&nbsp;<a href="http://www.minicredit.pl">www.minicredit.pl</a>,</li>
<li style="text-align:justify;">akceptacja wymaganych przez Minicredit Sp. z o.o. oświadczeń dotyczących w szczególności: zapoznania się i akceptacji treści niniejszego Regulaminu, zapoznania się i akceptacji treści Wzoru Umowy pożyczki,</li>
<li style="text-align:justify;">udzielenie wymaganych przez Minicredit Sp z.o.o. zgód niezbędnych w celu przeprowadzenia procesu zawarcia Umowy pożyczki i realizacji Umowy pożyczki,</li>
<li style="text-align:justify;">przejście przez kolejne etapy składania Wniosku o pożyczkę online na stronie&nbsp;<a href="http://www.minicredit.pl">www.minicredit.pl</a>, w tym:<ul style="list-style-type:disc;">
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">podanie prawdziwych danych osobowych, w tym: imię, nazwisko, numer PESEL, numer telefonu, adres e-mail;</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">wpisanie kodu SMS przesłanego na podany w formularzu numer telefonu, w celu weryfikacji prawdziwości podanych we Wniosku danych;</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">wpisanie kodu EMAIL przesłanego na podany w formularzu adres email, w celu weryfikacji prawdziwości podanych we Wniosku danych;</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">zweryfikowanie zdolności kredytowej,</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">podanie na dalszych etapach systemu teleinformatycznego wyłącznie prawdziwych danych osobowych, w tym, w szczególności danych w zakresie numer i seria dokumentu tożsamości, data ważności dokumentu tożsamości, numer konta, miesięczny dochód (netto), źródło przychodu, data pierwszego przychodu z tego źródła, cel pożyczki, stan cywilny, wykształcenie, dane, adresowe: kod pocztowy, miasto, ulica, numer ulicy, numer lokalu;</span>
</li>
<li style="text-align:justify;">
<span class="text-small" style="color:hsl(0, 0%, 0%);">weryfikacji danych konta bankowego za pośrednictwem usługi Transactionlink.</span>
</li>
</ul>
</li>
</ol>
</li>
<li style="text-align:justify;">Zawarcie Umowy pożyczki następuje poprzez złożenie zgodnych oświadczeń woli przez Użytkownika i Minicredit Sp z o.o. Za oświadczenie woli Użytkownika uznaje się złożenie w formie elektronicznej Dyspozycji zatwierdzającej kwotę przyznanej Pożyczki, za oświadczenie woli Minicredit uznaje się złożenie dyspozycji wypłaty Pożyczki.</li>
<li style="text-align:justify;">Wykonanie wskazanych w powyższych zapisach Regulaminu czynności skutkuje skutecznym zawarciem Umowy pożyczki.</li>
<li style="text-align:justify;">Umowa potwierdzająca zawarcie Umowy pożyczki jest wysyłana za pośrednictwem poczty elektronicznej na adres podany przez Użytkownika we Wniosku o pożyczkę, a także dostępna jest każdorazowo po zalogowaniu się Użytkownika w Koncie Klienta.</li>
</ol>
<p style="text-align:center;">
<br>
<strong>§8. ELEMENTY BEZPIECZEŃSTWA</strong>
</p>
<ol>
<li style="text-align:justify;">Korzystanie z Konta Klienta możliwe jest jedynie po uzyskaniu przez Użytkownika pozytywnej weryfikacji tożsamości na podstawie wprowadzonego przez niego indywidualnego Loginu i przypisanego do niego Hasła.</li>
<li style="text-align:justify;">Indywidualne hasło ustalone przez Użytkownika jest ciągiem znaków numerycznych lub alfa-numerycznych i składa się z co najmniej 6 znaków, małej litery, dużej litery i cyfry lub znaku specjalnego.</li>
<li style="text-align:justify;">Świadczenie Usług odbywa się każdorazowo z wykorzystaniem bezpiecznego protokołu SSL.</li>
<li style="text-align:justify;">Spółka nie ponosi odpowiedzialności za szkody powstałe z tytułu udostępnienia przez Użytkownika osobom trzecim Loginu lub Hasła. Klient ponosi pełną odpowiedzialność za działania osób trzecich, którym udostępnił Login i Hasło do Serwisu.</li>
<li style="text-align:justify;">Użytkownik ponosi wyłączną odpowiedzialność za prawidłowość podanych przez niego danych.</li>
</ol>
<p style="text-align:center;">
<br>
<strong>§9. PRZETWARZANIE DANYCH OSOBOWYCH</strong>
</p>
<ol>
<li style="text-align:justify;">Spółka przetwarza dane osobowe zgodnie z obowiązującymi przepisami prawa, w szczególności z Rozporządzeniem Parlamentu Europejskiego o Rady (UE) 2016/679 z dnia 27 kwietnia 2016r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( ogólne rozporządzenie o ochronie danych) i Ustawą.</li>
<li style="text-align:justify;">Administratorem danych jest Spółka tj. Minicredit Sp. z o.o. z siedzibą w Warszawie przy ul. Migdałowej 4, 02-795 Warszawa.</li>
<li style="text-align:justify;">Dane osobowe są przetwarzane w celu realizacji Umowy o Konto Klienta. Podanie danych jest dobrowolne, jednakże konieczne do zawarcia Umowy o Konto Klienta. W przypadku niepodania danych nie ma możliwości założenia Konta Klienta i korzystania z usług w tym przesyłania Dyspozycji. Użytkownikom przysługuje prawo dostępu do treści swoich danych oraz ich poprawiania. W przypadku wyrażenia przez Użytkownika dobrowolnej zgody np. na przetwarzanie jego danych osobowych w celach marketingowych, Użytkownikowi przysługuje uprawnienie do odwołania zgody w każdym czasie</li>
<li style="text-align:justify;">Spółce przysługuje prawo do przesyłania Użytkownikowi ofert zawarcia Umów Pożyczek. Użytkownik może w każdym czasie cofnąć zgodę na przesyłanie przez Spółkę ofert zawarcia umów pożyczek.</li>
<li style="text-align:justify;">Aby cofnąć zgodę marketingową Użytkownik może wysłać wiadomość e-mail zawierającą oświadczenie o treści „Wycofuję zgodę na przesyłanie ofert marketingowych” lub o podobnej treści na adres poczty elektronicznej: info@minicredit.pl</li>
<li style="text-align:justify;">Dane Użytkownika będą przetwarzane, w celu realizacji Umowy o Konto Klienta przez okres jej trwania.</li>
</ol>
<p style="text-align:justify;">&nbsp;</p>
<p style="text-align:center;">
<strong>§10. REKLAMACJE</strong>
</p>
<ol>
<li style="text-align:justify;">Użytkownik ma prawo składać reklamacje w sprawach dotyczących Usług.</li>
<li style="text-align:justify;">Reklamacje Użytkownik może składać:<ol style="list-style-type:lower-alpha;">
<li style="text-align:justify;">Pisemnie, wysyłając przesyłkę pocztową na adres siedziby Spółki</li>
<li style="text-align:justify;">Ustnie, składając telefonicznie za pośrednictwem Działu Obsługi Klienta pod numerem telefonu +48 888 444&nbsp;852.</li>
<li style="text-align:justify;">Elektronicznie, z wykorzystaniem środków komunikacji elektronicznej na adres&nbsp;<a href="mailto:info@minicredit.pl">info@minicredit.pl</a>.</li>
</ol>
</li>
<li style="text-align:justify;">Prawidłowo złożona reklamacja powinna zawierać dane:<ol style="list-style-type:lower-alpha;">
<li style="text-align:justify;">Pełne i jednoznaczne oznaczenie Użytkownika (imię, nazwisko, adres e-mail, adres do korespondencji, numer telefonu, numer PESEL lub numer pożyczki), celem umożliwienia Spółce identyfikacji przedmiotu reklamacji;</li>
<li style="text-align:justify;">Opis problemu będącego podstawą złożenia reklamacji, dokonany w miarę szczegółowo celem umożliwienia Spółce wyjaśnienie wszelkich okoliczności wskazanych w reklamacji;</li>
<li style="text-align:justify;">Żądanie Użytkownika w zakresie sposobu rozpatrzenia reklamacji</li>
<li style="text-align:justify;">Określenie sposobu w jaki Użytkownik chce uzyskać odpowiedź na reklamację</li>
<li style="text-align:justify;">Podpis Użytkownika – w przypadku składania reklamacji w formie pisemnej lub ustnej do protokołu.</li>
</ol>
</li>
<li style="text-align:justify;">Zgłoszenia, w których Użytkownik nie jest możliwy do zidentyfikowania nie podlegają rozpatrzeniu wobec braku możliwości prawidłowej identyfikacji zgłoszenia.</li>
<li style="text-align:justify;">Spółka dochowa wszelkich starań, aby udzielić odpowiedzi na zgłoszenie reklamacyjne bezzwłocznie, jednak nie później niż w terminie 30 dni od dnia wpływu zgłoszenia obejmującego wszystkie informacje niezbędne do jego rozpatrzenia.</li>
<li style="text-align:justify;">W szczególnie skomplikowanych przypadkach, uniemożliwiających rozpatrzenie zgłoszenia reklamacyjnego i udzielenie odpowiedzi w terminie 30 dni, Spółka w informacji przekazywanej Klientowi, który wystąpił ze zgłoszeniem reklamacyjnym:<ol style="list-style-type:lower-alpha;">
<li style="text-align:justify;">wyjaśnia przyczynę opóźnienia</li>
<li style="text-align:justify;">wskazuje okoliczności, które muszą zostać ustalone dla rozpatrzenia sprawy</li>
<li style="text-align:justify;">określa przewidywany termin rozpatrzenia reklamacji i udziela odpowiedzi, termin ten nie może jednak przekroczyć 60 dni od dnia otrzymania reklamacji</li>
</ol>
</li>
<li style="text-align:justify;">W rezultacie rozpatrzenia zgłoszenia reklamacyjnego Spółka udziela Użytkownikowi odpowiedzi w formie:<ol style="list-style-type:lower-alpha;">
<li style="text-align:justify;">pisemnej – przesyłką pocztową wysłaną na adres Użytkownika wskazany w zgłoszeniu (domyślnie);</li>
<li style="text-align:justify;">elektronicznej – e-mailem na adres Użytkownika wskazany w zgłoszeniu (wyłącznie na wniosek Użytkownika).</li>
</ol>
</li>
<li style="text-align:justify;">Zgłoszenie reklamacji nie zwalnia Klienta z obowiązku terminowego realizowania zobowiązań wobec Spółki.</li>
</ol>
<p style="text-align:center;">
<br>
<strong>§11. POSTANOWIENIA KOŃCOWE</strong>
</p>
<ol>
<li style="text-align:justify;">Spółka nie ponosi odpowiedzialności za błędy w transmisji danych, w szczególności spowodowane awarią systemów teleinformatycznych, systemów telekomunikacyjnych, systemów zasilania oraz z powodu opóźnień w działaniu zewnętrznego operatora zapewniającego transmisję danych.</li>
<li style="text-align:justify;">Spółka nie ponosi odpowiedzialności za brak dostępu do Strony Internetowej z przyczyn niezależnych od Spółki. Ze względów bezpieczeństwa oraz jakichkolwiek innych przyczyn niezależnych od Spółki, Spółka ma prawo zablokować lub czasowo zawiesić dostęp do Strony Internetowej na okres konieczny do usunięcia zaistniałych zagrożeń lub nieprawidłowości.</li>
<li style="text-align:justify;">Z zastrzeżeniem ograniczeń wynikających z bezwzględnie obowiązujących przepisów prawa, Spółka nie odpowiada za szkody powstałe w związku z Serwisem lub jego użytkowaniem bądź niemożnością użytkowania przez Użytkownika lub w związku z niewłaściwym działaniem, błędami, brakami, zakłóceniami, defektami, opóźnieniami w operacji lub transmisji danych, wirusami komputerowymi, awarią linii lub systemu informatycznego.</li>
<li style="text-align:justify;">Spółka zastrzega sobie prawo do wprowadzenia zmian Regulaminu w dowolnym terminie.</li>
<li style="text-align:justify;">W przypadku zmiany Regulaminu, Spółka powiadamia zarejestrowanych Użytkowników za pomocą wiadomości email. Regulamin po zmianach również jest zamieszczamy na Stronie Internetowej&nbsp;<a href="http://www.minicredit.pl">www.minicredit.pl</a>
</li>
<li style="text-align:justify;">Korzystanie przez Użytkownika z Serwisu po wprowadzeniu zmian do Regulaminu równoznaczne jest z wyrażeniem ich akceptacji. Użytkownik może wypowiedzieć umowę o Konto Klienta w terminie 14 dni od daty powiadomienia o zmianie Regulaminu.</li>
<li style="text-align:justify;">Sądem właściwym do rozstrzygania sporów związanych z wykonaniem Regulaminu jest Sąd właściwy miejscowo dla Spółki.</li>
<li style="text-align:justify;">Regulamin wchodzi w życie z dniem 02-09-2022.</li>
</ol>`;








const CONSENT_MARKETING = `<p>Wyrażam zgodę na przetwarzanie moich danych osobowych, w celu przesyłania informacji handlowych za pomocą środk&oacute;w komunikacji elektronicznej zgodnie z art. 10 ust. 2 Ustawy o świadczeniu usług drogą elektroniczną z dnia 18 lipca 2002r. (t.j. Dz.U.2019 poz. 123 z p&oacute;ź. Zm.) od MiniCredit Sp. z o.o. na wskazany przeze mnie adres e-mail, w trakcie trwania umowy, a także po jej zakończeniu.<br />Potwierdzam, że zostałam/-em poinformowana/-y o prawie do odwołania powyższych zg&oacute;d. Przyjmuję do wiadomości, że odwołanie zgody nie wpływa na zgodność z prawem przetwarzania danych przed jej odwołaniem.<br />Administratorem danych osobowych jest MiniCredit Sp. z o.o. z siedzibą w Warszawie przy ul. Migdałowej 4, 02-796 Warszawa. Szczeg&oacute;ły dotyczące przetwarzania danych osobowych znajdują się w Klauzuli informacyjnej oraz Polityka Prywatności i Wykorzystania Plik&oacute;w Cookies.</p>`;


const CONSENT_PHONE = `<p>Wyrażam zgodę na przetwarzanie moich danych osobowych, w celu przekazywania mi dopasowanych do moich potrzeb informacji handlowych przy użyciu telekomunikacyjnych urządzeń końcowych (telefon, Internet) oraz automatycznych system&oacute;w wywołujących, zgodnie z art. 172 ust. 3 ustawy Prawo telekomunikacyjne z dnia 16 lipca 2004 r. (t. j. Dz.U. 2018 poz. 1954 z p&oacute;ź.zm.) od MiniCredit Sp. z o.o. w postaci kontaktu telefonicznego oraz wysyłanych wiadomości SMS w trakcie trwania umowy, a także po jej zakończeniu.<br />Potwierdzam, że zostałam/-em poinformowana/-y o prawie do odwołania powyższych zg&oacute;d. Przyjmuję do wiadomości, że odwołanie zgody nie wpływa na zgodność z prawem przetwarzania danych przed jej odwołaniem.<br />Administratorem danych osobowych jest MiniCredit Sp. z o.o. z siedzibą w Warszawie przy ul. Migdałowej 4, 02-796 Warszawa. Szczeg&oacute;ły dotyczące przetwarzania danych osobowych znajdują się w Klauzuli informacyjnej oraz Polityka Prywatności i Wykorzystania Plik&oacute;w Cookies.</p>`;


const CONSENT_CRIF = `<p style="text-align: center;">Zgody na przetwarzanie i udostępnienie danych osobowych w celach związanych ze świadczeniem usług, weryfikacją tożsamości oraz oceną zdolności kredytowej</p>
<ol>
<li><strong>Zgoda na weryfikację u Uczestnik&oacute;w Platformy Wymiany Informacji Pożyczkowe</strong></li>
</ol>
<p>W celu oceny zdolności kredytowej oraz możliwości weryfikacji prawidłowości wykonania tej oceny, zgadzam się na udostępnienie przez Minicredit sp. z o.o. z siedzibą w Warszawie (02-796) ul. Migdałowa 4. (dokładny adres + ewentualnie dodatkowe dane kontaktowe oraz dane kontaktowe inspektora ochrony danych) w terminie 30 dni mojego numeru PESEL oraz moich danych zebranych w procesie wnioskowania o pożyczkę Uczestnikom Platformy Wymiany Informacji Pożyczkowej* w celu uzyskania od nich przetwarzanych w ich zbiorach danych informacji o historii moich pożyczek oraz wynik&oacute;w analiz statystycznych, zestawienie tych informacji oraz wynik&oacute;w analiz statystycznych przez Minicredit sp. z o.o. i ich przetwarzanie przez Minicredit sp. z o.o. przez 3 lata od ich udostępnienia.</p>
<p>&nbsp;</p>
<ol start="2">
<li><strong>Zgoda na udostępnienie danych przez uczestnik&oacute;w Platformy Wymiany Informacji Pożyczkowej </strong></li>
</ol>
<p>W celu oceny zdolności kredytowej, w tym analiz zmierzających do przeciwdziałania wyłudzeniom, stanowiących część procesu oceny zdolności kredytowej,&nbsp; oraz możliwości weryfikacji prawidłowości wykonania tej oceny zgadzam się na udostępnienie Minicredit sp. z o.o. z siedzibą w Warszawie (02-796) ul. Migdałowa 4 (dane kontaktowe inspektora ochrony danych <a href="mailto:IODO@LEVANTA.PL">IODO@LEVANTA.PL</a> ) przez Uczestnik&oacute;w Platformy Wymiany Informacji Pożyczkowej* w terminie 30 dni przetwarzanych w ich zbiorach danych informacji o historii moich pożyczek oraz wynik&oacute;w analiz statystycznych.</p>
<p>&nbsp;</p>
<ol start="3">
<li><strong>Zgoda na przetwarzanie danych</strong></li>
</ol>
<p>W celu przeprowadzania oceny zdolności kredytowej, w tym analiz zmierzających do przeciwdziałania wyłudzeniom, stanowiących część procesu oceny zdolności kredytowej, wyrażam zgodę na przetwarzanie przez Minicredit sp. z o.o. z siedzibą w Warszawie (02-796) ul. Migdałowa 4 (dane kontaktowe inspektora ochrony danych <a href="mailto:IODO@LEVANTA.PL">IODO@LEVANTA.PL</a>), nie dłużej jednak niż przez okres trzech lat odpowiednio po wykonaniu zobowiązań wobec Minicredit sp. z o.o. wynikających z zawartej umowy o kredyt konsumencki, zbyciu przez Minicredit sp. z o.o. wierzytelności wynikających z umowy o kredyt konsumencki lub rozwiązaniu umowy o kredyt konsumencki, moich danych osobowych zawartych w umowie o kredyt konsumencki z Minicredit sp. z o.o. oraz informacji dotyczących wykonywania zobowiązań wynikających z tej umowy, a także na przetwarzanie przez Minicredit sp. z o.o. w analizach statystycznych przez 3 lata moich danych zebranych w procesie wnioskowania o pożyczkę.</p>
<p>Potwierdzam, że zostałem poinformowany:</p>
<ul>
<li>o prawie do żądania od administratora dostępu do swoich danych osobowych, ich sprostowania, usunięcia lub ograniczenia przetwarzania, a także o prawie do przenoszenia danych;</li>
<li>o prawie o cofnięcia zgody na przetwarzanie danych w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania, kt&oacute;rego dokonano na podstawie zgody przed jej cofnięciem;</li>
<li>o prawie do wniesienia skargi do organu nadzorczego jeżeli sądzę, że przetwarzanie danych mnie dotyczące narusza Rozporządzenie Parlamentu Europejskiego i Rady (UE) nr 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (og&oacute;lne rozporządzenie o ochronie danych);</li>
<li>o dobrowolności udzielenia powyższych zg&oacute;d;</li>
<li>o tym, że przetwarzanie moich danych osobowych na podstawie powyższych zg&oacute;d stanowi profilowanie w rozumieniu art. 22 Rozporządzenia Parlamentu Europejskiego i Rady (UE) nr 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (og&oacute;lne rozporządzenie o ochronie danych), polegające na zautomatyzowanym podejmowaniu decyzji odnośnie mojej zdolności kredytowej w oparciu o informacje pozyskane ze zbior&oacute;w danych Uczestnik&oacute;w Platformy Wymiany Informacji Pożyczkowej o historii moich pożyczek oraz wynikach analiz statystycznych;</li>
<li>o tym, że wynik profilowania ma znaczenie dla decyzji w przedmiocie zawarcia ze mną umowy kredytu, z zastrzeżeniem, że przysługuje mi w każdym przypadku prawo do uzyskania interwencji ludzkiej ze strony administratora, wyrażenia własnego stanowiska i do zakwestionowania tej decyzji.</li>
</ul>
<p>&nbsp;</p>`;



const CONSENT_INFO_FORM = `
<div class=WordSection1>

<p class=MsoNormal align=center style='text-align:center;line-height:normal'><b><span
style='font-size:12.0pt'>FORMULARZ INFORMACYJNY DOTYCZĄCY KREDYTU
KONSUMENCKIEGO</span></b></p>

<p class=MsoNormal style='line-height:normal'>&nbsp;</p>

<div align=center>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 width="100%">
 <tr>
  <td colspan=2 style='padding:15px;'>
  <ol start=1 type=1>
   <li class=MsoNormal style='line-height:normal'><b>Dane identyfikacyjne i
       kontaktowe dotyczące kredytodawcy</b></li>
  </ol>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Kredytodawca:</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal align=center style='text-align:center;line-height:normal'>Minicredit
  Sp. z o.o.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Adres:<br>
  </b>(Siedziba)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal align=center style='text-align:center;line-height:normal'>ul.
  Migdałowa 4, 02-796 Warszawa</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Numer telefonu:<br>
  </b>(Informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal align=center style='text-align:center;line-height:normal'>+48&nbsp;888&nbsp;444
  852</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Adres poczty elektronicznej:<br>
  </b>(Informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal align=center style='text-align:center;line-height:normal'>info@minicredit.pl</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Numer faxu:<br>
  </b>(Informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal align=center style='text-align:center;line-height:normal'>Nie
  dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Adres strony internetowej:<br>
  </b>(Informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal align=center style='text-align:center;line-height:normal'>www.minicredit.pl</p>
  </td>
 </tr>
 <tr>
  <td colspan=2 style='padding:15px;'>
  <ol start=2 type=1>
   <li class=MsoNormal style='line-height:normal'><b>Opis głównych cech kredytu</b></li>
  </ol>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Rodzaj kredytu:</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Pożyczka gotówkowa</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Całkowita kwota kredytu:</b></p>
  <p class=MsoNormal style='line-height:normal'>(Suma wszystkich środków
  pieniężnych, które zostaną&nbsp;Panu/Pani udostępnione)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>{m%POZYCZKA.KAPITAL} zł<br>
  Ostateczna wysokość całkowitej kwoty pożyczki zależeć będzie od oceny Klienta
  przez Pożyczkodawcę oraz wyborów Klienta w zakresie opłat opcjonalnych.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Terminy i sposób wypłaty
  kredytu:</b></p>
  <p class=MsoNormal style='line-height:normal'>(W jaki sposób i w jakim
  terminie otrzyma Pan/Pani środki pieniężne)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Wypłata środków pieniężnych
  następuje niezwłocznie, w terminie nie dłuższym niż 14 dni od wydania
  pozytywnej decyzji o udzieleniu pożyczki, w formie przelewu na rachunek
  bankowy Pożyczkobiorcy (wskazany przez Pożyczkobiorcę). Moment wpłynięcia
  kwoty pożyczki na konto bankowe Pożyczkobiorcy zależny jest od sesji
  bankowych banku, w którym Pożyczkobiorca posiada rachunek.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Czas obowiązywania umowy:</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Umowa pożyczki zawierana jest
  na czas określony do dnia terminu spłaty wskazanego w zapisach umowy pożyczki
  stanowiący ilość dni kalendarzowych: 30 dni.</p>
  <p class=MsoNormal style='line-height:normal'>Termin spłaty pożyczki
  to&nbsp;{POZYCZKA.LICZBA_DNI} dni od dnia wypłaty całkowitej kwoty pożyczki.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Zasady i terminy spłaty
  kredytu:</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Pełna spłata całkowitej kwoty
  pożyczki wraz z wszystkimi dodatkowymi kosztami będzie następowała w terminie
  30 dni od dnia wypłaty całkowitej kwoty pożyczki.</p>
  <p class=MsoNormal style='line-height:normal'>Otrzymywane środki pieniężne
  będą&nbsp;zaliczane przez Pożyczkodawcę&nbsp;według następującej kolejności: <br>
  1. Koszty związane z postępowaniem sądowym i egzekucyjnym, jeśli takie
  powstały zgodnie z Umową&nbsp;Pożyczki.<br>
  2. Odsetki za opóźnienie, jeśli takie powstały zgodnie z Umowa.<br>
  3. Odsetki kapitałowe.<br>
  4. Prowizja.<br>
  5. Opłata za przygotowanie pożyczki.<br>
  6. Kwota Pożyczki.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Całkowita kwota do zapłaty
  przez konsumenta:<br>
  </b>(Jest to suma wszystkich środków pieniężnych, które kredytodawca
  udostępnia Panu/Pani oraz wszelkie koszty, które zobowiązany/a będzie
  Pan/Pani ponieść&nbsp;w związku z umową&nbsp;o kredyt)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>&nbsp;{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}
  zł</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Kredyt wiązany lub w formie
  odroczonej płatności*</b></p>
  <p class=MsoNormal style='line-height:normal'>- opis towaru lub usługi:</p>
  <p class=MsoNormal style='line-height:normal'>- cena:</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Wymagane zabezpieczenia
  kredytu*<br>
  </b>(Zabezpieczenie, jakie będzie Pan/Pani musiał/a przedstawić&nbsp;w
  związku z umową&nbsp;o kredyt)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Informacja czy umowa o
  kredyt przewiduje gwarancje spłaty całkowitej kwoty kredytu wypłaconej na jej
  podstawie*<br>
  </b>(Jeżeli zgodnie z postanowieniami umowy o kredyt, płatności dokonywane
  przez Pana/Panią&nbsp;nie są&nbsp;zaliczane do spłaty całkowitej kwoty
  kredytu, ale będą&nbsp;wykorzystywane do zgromadzenia kapitału przez okresy i
  na zasadach określonych w umowie dodatkowej, to umowa o kredyt nie przewiduje
  gwarancji spłaty całkowitej kwoty kredytu wypłaconej na jej podstawie)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td colspan=2 style='padding:15px;'>
  <p class=MsoListParagraph style='text-indent:-18.0pt;line-height:normal'>3.<span
  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><b>Koszty
  kredytu</b></p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Stopa oprocentowania kredytu
  oraz warunki jej zmiany:</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Roczna stopa oprocentowania
  Pożyczki („RSO&quot;) jest zmienna i wynosi na dzień&nbsp;sporządzenia
  niniejszego formularza 17,50% w skali roku.</p>
  <p class=MsoNormal style='line-height:normal'>Roczna stopa procentowa jest
  jako dwukrotność&nbsp;sumy stopy referencyjnej Narodowego Banku Polskiego i
  3,5 punktów procentowych, (odsetki maksymalne- dwukrotności wysokości odsetek
  ustawowych zgodnie z art. 359 § 2(1)&nbsp;Kodeksu cywilnego).</p>
  <p class=MsoNormal style='line-height:normal'>Wysokość&nbsp;RSO Pożyczki
  ulega obniżeniu do aktualnej wysokości stopy odsetek maksymalnych w przypadku
  obniżenia wysokości stopy referencyjnej Narodowego Banku Polskiego.&nbsp;</p>
  <p class=MsoNormal style='line-height:normal'>W przypadku późniejszego
  podwyższenia wysokości stopy odsetek maksymalnych wysokość&nbsp;RSO Pożyczki
  niezwłocznie powraca do swej pierwotnej wysokości, jednakże nie więcej
  niż&nbsp;do aktualnej wysokości stopy odsetek maksymalnych.</p>
  <p class=MsoNormal>Reprezentatywny przykład: Pożyczka 2500 zł na 30 dni, RRSO
  wynosi 306,4%; całkowita kwota pożyczki: 2500 zł; oprocentowanie zmienne:
  17,50%; całkowity koszt pożyczki: 306,51 zł, w tym: Prowizja 250,00 zł,
  Prowizja za obsługę 20,55 zł, Odsetki 35,96 zł; okres obowiązywania umowy: 30
  dni; całkowita kwota do spłaty: 2806,51 zł.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Rzeczywista roczna stopa
  oprocentowania:<br>
  </b>(Jest to całkowity koszt kredytu ponoszony przez konsumenta, wyrażony
  jako wartość&nbsp;procentowa całkowitej kwoty kredytu w stosunku rocznym
  przedstawiona, aby pomóc Panu/Pani w porównaniu oferowanych kredytów)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Rzeczywista roczna stopa
  oprocentowania - {POZYCZKA.RRSO}%</p>
  <p class=MsoListParagraphCxSpFirst style='line-height:normal'>Reprezentatywny
  przykład:</p>
  <p class=MsoListParagraphCxSpMiddle style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Całkowita kwota pożyczki: 2500 zł</p>
  <p class=MsoListParagraphCxSpMiddle style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Czas obowiązywania umowy: 30 dni</p>
  <p class=MsoListParagraphCxSpMiddle style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Prowizja: 250 zł</p>
  <p class=MsoListParagraphCxSpMiddle style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Stopa oprocentowania zmienna: 17,50 %</p>
  <p class=MsoListParagraphCxSpMiddle style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Odsetki: 35,96 zł</p>
  <p class=MsoListParagraphCxSpMiddle style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Opłata za przygotowanie pożyczki: 20,55 zł</p>
  <p class=MsoListParagraphCxSpMiddle style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Całkowita kwota do zapłaty: 2806,51 zł</p>
  <p class=MsoListParagraphCxSpLast style='text-indent:-18.0pt;line-height:
  normal'><span style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>RRSO: 308,4 %</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Obowiązek zawarcia umowy
  dodatkowej:<br>
  </b>(Do uzyskania kredytu konieczne jest zawarcie przez Pana/Panią umowy
  dodatkowej w szczególności umowy ubezpieczenia lub innej umowy)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Koszty, które zobowiązany/a
  będzie Pan/Pani ponieść&nbsp;w związku z umową&nbsp;o kredyt*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Na koszty jakie będzie&nbsp;Pan/
  Pani zobowiązany/a ponieść&nbsp;w związku z Umowa Pożyczki składają&nbsp;się:</p>
  <p class=MsoNormal style='line-height:normal'>Odsetki zgodnie ze wskazana
  powyżej stopą&nbsp;oprocentowania pożyczki</p>
  <p class=MsoNormal style='line-height:normal'>Prowizja
  {m%POZYCZKA.OPLATA_POCZATKOWA} zł</p>
  <p class=MsoNormal style='line-height:normal'>Opłata za przygotowanie
  pożyczki {m%POZYCZKA.OPLATA_ZA_OBSLUGE} zł</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Koszty prowadzenia jednego
  lub kilku rachunków w celu dokonywania wpłat i wypłat środków pieniężnych*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Koszty korzystania z
  instrumentów płatniczych (np. karty kredytowej)*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Inne koszty, które konsument
  zobowiązany jest ponieść&nbsp;w związku z umową*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Warunki, na jakich koszty
  związane z umową&nbsp;o kredyt mogą&nbsp;ulegać&nbsp;zmianie*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Zmiana lub wprowadzenia nowych
  przepisów prawa, rekomendacji, zaleceń&nbsp;lub wytycznych organów
  państwowych odnoszących się&nbsp;do wykonywania umowy.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Opłaty notarialne*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Skutek braku płatności:</b></p>
  <p class=MsoNormal style='line-height:normal'>(Skutki braku płatności
  mogą&nbsp;być&nbsp;dla Pana/Pani następujące)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>W przypadku braku lub opóźnienia
  w płatności możesz zostać&nbsp;obciążony odsetkami za opóźnienie w wysokości
  odsetek maksymalnych, określonych art. 481 § 2<sup>1</sup>&nbsp;Kodeksu
  cywilnego, tj. równymi dwukrotności sumy aktualnej stopy referencyjnej
  Narodowego Banku Polskiego i 5,5 punktów procentowych (w stosunku rocznym).
  Na dzień 05.10.2023 roku odsetki maksymalne za opóźnienie wynoszą&nbsp;22,50
  % w stosunku rocznym.</p>
  <p class=MsoNormal style='line-height:normal'>Zmiana stopy odsetek
  maksymalnych za opóźnienie następuje w przypadku zmiany stopy referencyjnej
  Narodowego Banku Polskiego, odpowiednio do zmiany tej stopy. W przypadku
  zmiany stopy odsetek maksymalnych za opóźnienie, Pożyczkobiorca otrzymuje od
  Pożyczkodawcy niezwłocznie, informacje o tej zmianie ze wskazaniem nowej
  wysokości stopy odsetek maksymalnych za opóźnienie.</p>
  <p class=MsoNormal style='line-height:normal'>W przypadku zmiany stopy
  odsetek maksymalnych za opóźnienie Pożyczkodawca nalicza odsetki według nowej
  stopy od dnia zmiany stopy referencyjnej Narodowego Banku Polskiego.</p>
  <p class=MsoNormal style='line-height:normal'>Pożyczkodawca ma
  również&nbsp;prawo do podjęcia działań&nbsp;mających na celu odzyskanie
  swojej wierzytelności, w tym w szczególności do przekazania tej
  wierzytelności do obsługi przez zewnętrzny podmiot, jak również&nbsp;ma prawo
  do dochodzenia zwrotu pożyczki na drodze postępowania sądowego. Na podstawie
  prawomocnego wyroku zasądzającego kwotę&nbsp;Pożyczki wraz z innymi
  wymagalnymi należnościami, Pożyczkobiorca może być&nbsp;obciążony kosztami
  procesu na podstawie powszechnie obowiązującego prawa.</p>
  <p class=MsoNormal style='line-height:normal'>Pożyczkodawca ma prawo
  przekazać&nbsp;informacje o zobowiązaniach Pożyczkobiorcy do Biur Informacji
  Gospodarczej, co może mieć&nbsp;negatywny wpływ na zdolność&nbsp;kredytową&nbsp;Pożyczkobiorcy.</p>
  </td>
 </tr>
 <tr>
  <td colspan=2 style='padding:15px;'>
  <ol start=4 type=1>
   <li class=MsoNormal style='line-height:normal'><b>Inne ważne informacje</b></li>
  </ol>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Odstąpienie od umowy<br>
  </b>(W terminie 14 dni od dnia zawarcia umowy ma Pan/Pani prawo do
  odstąpienia od umowy)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Tak</p>
  <p class=MsoNormal style='line-height:normal'>W terminie 14 dni od zawarcia
  umowy Pożyczkobiorca ma prawo skorzystać&nbsp;z odstąpienia od umowy
  pożyczki.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Spłata kredytu przed
  terminem określonym w umowie:<br>
  </b>(Ma Pan/Pani prawo w każdym czasie do spłaty całości lub części kredytu
  przed terminem określonym w umowie)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Jest Pan/ Pani uprawniony/a do
  częściowej lub całkowitej spłaty pożyczki przed terminem spłaty pożyczki bez
  ponoszenia opłat lub kosztów z tego tytułu. W takim wypadku całkowity koszt
  pożyczki ulegnie obniżeniu o te koszty, które dotyczą&nbsp;okresu, o który
  skrócono udostępnienie pożyczki chociażby poniósł&nbsp;je Pan /Pani przed
  spłatą.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Uprawnienie kredytodawcy do
  zastrzeżenia prowizji za spłatę&nbsp;kredytu przed terminem*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Sprawdzenie w bazie danych:<br>
  </b>(Jeżeli kredytodawca odmówi Panu/Pani udzielenia kredytu konsumenckiego
  na podstawie informacji zawartych w bazie danych kredytodawcy niezwłocznie
  zobowiązany jest przekazać&nbsp;Panu/Pani bezpłatną&nbsp;informację&nbsp;o
  wynikach tego sprawdzenia oraz wskazać&nbsp;bazę&nbsp;danych, w której tego
  sprawdzenia dokonano)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Zostanie Pan/Pani sprawdzony/a
  w następującej bazie danych:</p>
  <p class=MsoNormal style='line-height:normal'>Wewnętrzna baza danych
  Pożyczkodawcy.</p>
  <p class=MsoNormal style='line-height:normal'>Bazy danych uczestników
  Platformy Wymiany Informacji Pożyczkowej (Lista współpracujących
  kredytodawców: <a href="http://www.credit-check.pl/uczestnicy/"><span
  style='color:windowtext'>http://www.credit-check.pl/uczestnicy/</span></a>)</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Prawo do otrzymania projektu
  umowy o kredyt:<br>
  </b>(Ma Pan/Pani prawo do otrzymania, na wniosek, bezpłatnego projektu umowy
  o kredyt konsumencki, jeżeli w ocenie kredytodawcy spełnia Pan/Pani warunki
  do udzielenia kredytu konsumenckiego)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Ma Pan/Pani prawo do
  bezpłatnego otrzymania egzemplarza projektu umowy o kredyt.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Czas obowiązywania
  formularza:</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Niniejsza informacja zachowuje
  ważność&nbsp;30 dni od daty wystawienia formularza.</p>
  </td>
 </tr>
 <tr>
  <td colspan=2 style='padding:15px;'>
  <p class=MsoNormal style='margin-left:36.0pt;line-height:normal'><b><br>
  Dodatkowe informacje podawane w przypadku sprzedaży usług finansowych na
  odległość<br>
  <br>
  </b></p>
  </td>
 </tr>
 <tr>
  <td colspan=2 style='padding:15px;'>
  <ol start=1 type=1>
   <li class=MsoNormal style='line-height:normal'><b>Informacje dotyczące
       kredytodawcy</b></li>
  </ol>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Kredytodawca</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>&nbsp; Minicredit Sp. z o.o.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Adres:<br>
  </b>(Siedziba)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>&nbsp;ul. Migdałowa 4, 02-796
  Warszawa</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Numer telefonu:<br>
  </b>(Informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'> +48&nbsp;888&nbsp;444 852</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Numer faxu:<br>
  </b>(informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'> Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Adres poczty elektronicznej:<br>
  </b>(informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'> info@minicredit.pl</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Adres strony internetowej:<br>
  </b>(informacja ta ma charakter opcjonalny)</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'> www.minicredit.pl</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Rejestr*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Rejestr Przedsiębiorców
  Krajowego Rejestru Sądowego prowadzony przez Sąd Rejonowy dla m.st. Warszawy,
  XIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS
  0000371165.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Organ nadzoru*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Urząd Ochrony Konkurencji i
  Konsumentów, Plac Powstańców Warszawy 1, 00-950 Warszawa<br>
  Urząd Komisji Nadzoru Finansowego, ul. Piękna 20, 00-549 Warszawa</p>
  </td>
 </tr>
 <tr>
  <td colspan=2 style='padding:15px;'>
  <ol start=2 type=1>
   <li class=MsoNormal style='line-height:normal'><b>Dane dotyczące umowy</b></li>
  </ol>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Odstąpienie od umowy*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Ma Pan/Pani prawo do
  odstąpienia od umowy pożyczki w terminie 14 dni od daty zawarcia umowy
  poprzez wysłanie wiadomości e-mail z wypełnionym i podpisanym własnoręcznie
  oświadczeniem we wzorze stanowiącym załącznik do umowy pożyczki zawierającym
  Imię&nbsp;i Nazwisko na adres: <a href="mailto:info@minicredit.pl"><span
  style='color:windowtext'>info@minicredit.pl</span></a> lub wysłanie pisma na
  adres korespondencyjny: ul. Migdałowa 4, 02-796 Warszawa Zaniechanie
  którejkolwiek ze wskazanych powyżej czynności nie stanowi złożenia
  skutecznego oświadczenia o odstąpieniu. Roszczenie Pożyczkodawcy o zwrot
  wypłaconej kwoty pożyczki staje się wymagalne w całości w dniu złożenia
  skutecznego oświadczenia o odstąpieniu wraz z należnościami ubocznymi
  wskazanymi powyżej. </p>
  <p class=MsoNormal style='line-height:normal'>W przypadku odstąpienia od
  Umowy Pożyczkobiorca ma obowiązek/zobowiązuje się&nbsp;do zwrotu wypłaconej
  kwoty Pożyczki wraz z odsetkami kapitałowymi za okres od dnia wypłaty
  Pożyczki do dnia faktycznej spłaty Pożyczki w terminie 30 dni od dnia
  złożenia Pożyczkodawcy skutecznego oświadczenia o odstąpieniu.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Wybór prawa właściwego*<br>
  </b>Do zawartej z Panem/Panią&nbsp;umowy o kredyt będzie
  miało&nbsp;zastosowanie prawo:</p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Prawo polskie</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Postanowienie umowy
  dotyczące wyboru prawa właściwego lub właściwego sądu*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>W kwestiach nieuregulowanych
  Umowy&nbsp;zastosowanie mają&nbsp;przepisy prawa polskiego. Prawem właściwym
  jest prawo polskie. Prawo właściwe dla Umowy zostało określone w § 19 ust. 1
  Umowy.</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Prawo właściwe dla
  zobowiązań pozaumownych wynikających z kontaktów handlowych mających miejsce
  przed zawarciem umowy:</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Nie dotyczy</p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Język umowy/język
  komunikacji*</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Informacje i warunki Umowy będą
  podawane w języku polskim. W okresie obowiązywania Umowy o pożyczkę
  zamierzamy się z Panem/Panią porozumiewać w języku polskim.</p>
  </td>
 </tr>
 <tr>
  <td colspan=2 style='padding:15px;'>
  <p class=MsoListParagraphCxSpFirst style='margin-bottom:0cm;text-indent:-18.0pt;
  line-height:normal'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span><b>Informacje dotyczące odwołań<br>
  <br>
  </b></p>
  </td>
 </tr>
 <tr>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'><b>Pozasądowe rozstrzyganie
  sporów</b></p>
  </td>
  <td style='padding:15px;'>
  <p class=MsoNormal style='line-height:normal'>Przysługuje Panu/ Pani prawo
  złożenia reklamacji do Pożyczkodawcy w trybie opisanym w Umowie Pożyczki.
  Przysługuje Panu/ Pani prawo korzystania z pozasądowego rozstrzygania sporów.</p>
  <p class=MsoNormal style='line-height:normal'>Spór między
  Pożyczkodawcą&nbsp;a Pożyczkobiorcą&nbsp;może być&nbsp;rozstrzygnięty w
  drodze pozasądowego postępowania przeprowadzonego na wniosek Pożyczkobiorcy
  przez Rzecznika Finansowego na zasadach określonych w ustawie z dnia 5
  sierpnia 2015 r o rozpatrywaniu reklamacji przez podmioty rynku finansowego i
  o Rzeczniku Finansowym.</p>
  <p class=MsoNormal style='line-height:normal'>W przypadku, gdy Strony nie
  będą&nbsp;w stanie rozwiązać&nbsp;sporu polubownie, zostanie poddany on pod
  rozstrzygnięcie właściwemu sądowi powszechnemu.</p>
  </td>
 </tr>
</table>

</div>

<p class=MsoNormal>&nbsp;</p>

</div>`;





const to_remove_CONSENT_INFO_FORM = `<p>&nbsp;</p>
<p style="text-align: center;">FORMULARZ INFORMACYJNY DOTYCZĄCY KREDYTU KONSUMENCKIEGO</p>
<p>&nbsp;</p>
<table width="100%">
<tbody>
<tr>
<td colspan="2">
<ol>
<li><strong>Dane identyfikacyjne i kontaktowe dotyczące kredytodawcy</strong></li>
</ol>
</td>
</tr>
<tr>
<td>
<p><strong>Kredytodawca:</strong></p>
</td>
<td>
<p>&nbsp;</p>
<p>Minicredit sp. z o.o.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Adres:</strong></p>
<p>(siedziba)</p>
</td>
<td>
<p>ul. Migdałowa 4, 02-796 Warszawa</p>
</td>
</tr>
<tr>
<td>
<p><strong>Numer telefonu:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>+48&nbsp;888&nbsp;444 852</p>
</td>
</tr>
<tr>
<td>
<p><strong>Adres poczty elektronicznej:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>info@minicredit.pl</p>
</td>
</tr>
<tr>
<td>
<p><strong>Numer faxu:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Adres strony internetowej:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>www.minicredit.pl</p>
</td>
</tr>
<tr>
<td colspan="2">
<ol>
<li><strong>Opis gł&oacute;wnych cech kredytu</strong></li>
</ol>
</td>
</tr>
<tr>
<td>
<p>Rodzaj kredytu:</p>
</td>
<td>
<p>Pożyczka got&oacute;wkowa</p>
</td>
</tr>
<tr>
<td>
<p><strong>Całkowita kwota kredytu:</strong></p>
<p>(suma wszystkich środk&oacute;w pieniężnych, kt&oacute;re zostaną&nbsp;Panu/Pani udostępnione)</p>
</td>
<td>
<p>{m%POZYCZKA.KAPITAL} PLN<br />Ostateczna wysokość całkowitej kwoty pożyczki zależeć będzie od oceny Klienta przez Pożyczkodawcę oraz wybor&oacute;w Klienta w zakresie opłat opcjonalnych</p>
</td>
</tr>
<tr>
<td>
<p><strong>Terminy i spos&oacute;b wypłaty kredytu:</strong></p>
<p>( w jaki spos&oacute;b i w jakim terminie otrzyma Pan/Pani środki pieniężne)</p>
</td>
<td>
<p>Wypłata środk&oacute;w pieniężnych następuje niezwłocznie, w terminie nie dłuższym niż 14 dni od wydania pozytywnej decyzji o udzieleniu pożyczki, w formie przelewu na rachunek bankowy Pożyczkobiorcy (wskazany przez Pożyczkobiorcę). Moment wpłynięcia kwoty pożyczki na konto bankowe Pożyczkobiorcy zależny jest od sesji bankowych banku, w kt&oacute;rym Pożyczkobiorca posiada rachunek.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Czas obowiązywania umowy:</strong></p>
</td>
<td>
<p>&nbsp;</p>
<p>Umowa pożyczki zawierana jest na czas określony do dnia terminu spłaty wskazanego w zapisach umowy pożyczki stanowiący ilość dni kalendarzowych: 30 dni.</p>
<p>&nbsp;</p>
<p>Termin spłaty pożyczki to&nbsp;{POZYCZKA.LICZBA_DNI} dni od dnia wypłaty całkowitej kwoty pożyczki.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Zasady i terminy spłaty kredytu:</strong></p>
</td>
<td>
<p>Pełna spłata całkowitej kwoty pożyczki wraz z wszystkimi dodatkowymi kosztami będzie następowała w terminie 30 dni od dnia wypłaty całkowitej kwoty pożyczki.</p>
<p>Otrzymywane środki pieniężne będą&nbsp;zaliczane przez Pożyczkodawcę&nbsp;według następującej kolejności: koszty związane z postępowaniem sądowym i egzekucyjnym, jeśli takie powstały zgodnie z Umową&nbsp;Pożyczki; Odsetki za op&oacute;źnienie, jeśli takie powstały zgodnie z Umowa; Odsetki kapitałowe; Prowizja, Opłata za przygotowanie pożyczki, kwota Pożyczki.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Całkowita kwota do zapłaty przez konsumenta: </strong></p>
<p>Jest to suma wszystkich środk&oacute;w pieniężnych, kt&oacute;re kredytodawca udostępnia Panu/Pani oraz wszelkie koszty, kt&oacute;re zobowiązany/a będzie Pan/Pani ponieść&nbsp;w związku z umową&nbsp;o kredyt</p>
</td>
<td>
<p>&nbsp;</p>
<p>&nbsp;{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY} zł</p>
</td>
</tr>
<tr>
<td>
<p><strong>Kredyt wiązany lub w formie odroczonej płatności*</strong></p>
<p>- opis towaru lub usługi:</p>
<p>- cena:</p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Wymagane zabezpieczenia kredytu*</strong></p>
<p>Zabezpieczenie, jakie będzie Pan/Pani musiał/a przedstawić&nbsp;w związku z umową&nbsp;o kredyt</p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Informacja czy umowa o kredyt przewiduje gwarancje spłaty całkowitej kwoty kredytu wypłaconej na jej podstawie*</strong></p>
<p>Jeżeli zgodnie z postanowieniami umowy o kredyt, płatności dokonywane przez Pana/Panią&nbsp;nie są&nbsp;zaliczane do spłaty całkowitej kwoty kredytu, ale będą&nbsp;wykorzystywane do zgromadzenia kapitału przez okresy i na zasadach określonych w umowie dodatkowej, to umowa o kredyt nie przewiduje gwarancji spłaty całkowitej kwoty kredytu wypłaconej na jej podstawie</p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td colspan="2">
<p><strong>3. Koszty kredytu</strong></p>
</td>
</tr>
<tr>
<td>
<p><strong>Stopa oprocentowania kredytu oraz warunki jej zmiany</strong></p>
</td>
<td>
<p>Roczna stopa oprocentowania Pożyczki (&bdquo;RSO") jest zmienna i wynosi na dzień&nbsp;sporządzenia niniejszego formularza {POZYCZKA.OPROCENTOWANIE_STOPA}% w skali roku.</p>
<p>Roczna stopa procentowa jest jako dwukrotność&nbsp;sumy stopy referencyjnej Narodowego Banku Polskiego i 3,5 punkt&oacute;w procentowych, (odsetki maksymalne- dwukrotności wysokości odsetek ustawowych zgodnie z art. 359 &sect; 2(1)&nbsp;Kodeksu cywilnego).</p>
<p>Wysokość&nbsp;RSO Pożyczki ulega obniżeniu do aktualnej wysokości stopy odsetek maksymalnych w przypadku obniżenia wysokości stopy referencyjnej Narodowego Banku Polskiego.&nbsp;</p>
<p>W przypadku p&oacute;źniejszego podwyższenia wysokości stopy odsetek maksymalnych wysokość&nbsp;RSO Pożyczki niezwłocznie powraca do swej pierwotnej wysokości, jednakże nie więcej niż&nbsp;do aktualnej wysokości stopy odsetek maksymalnych</p>
<p>reprezentatywny przykład: Pożyczka 2500 zł na 30 dni, RRSO wynosi 308,4%; całkowita kwota pożyczki: 2500 zł; oprocentowanie zmienne: 17,50%; całkowity koszt pożyczki: 306,51 zł, w tym: Prowizja 250,00 zł, Prowizja za obsługę 20,55 zł, Odsetki 35,96 zł; okres obowiązywania umowy: 30 dni; całkowita kwota do spłaty: 2806,51 zł.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Rzeczywista roczna stopa oprocentowania</strong></p>
<p>Jest to całkowity koszt kredytu ponoszony przez konsumenta, wyrażony jako wartość&nbsp;procentowa całkowitej kwoty kredytu w stosunku rocznym przedstawiona, aby pom&oacute;c Panu/Pani w por&oacute;wnaniu oferowanych kredyt&oacute;w</p>
</td>
<td>
<p>Rzeczywista roczna stopa oprocentowania - <strong>{POZYCZKA.RRSO}%</strong></p>
<p>Reprezentatywny przykład</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Całkowita kwota pożyczki: 2500 zł</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Czas obowiązywania umowy: 30 dni</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Prowizja: 250 zł</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Stopa oprocentowania zmienna: 17,50 %</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Odsetki: 35,96 zł</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Opłata za przygotowanie pożyczki: 20,55 zł</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Całkowita kwota do zapłaty: 2806,51 zł</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; RRSO: 308,4 %</p>
</td>
</tr>
<tr>
<td>
<p><strong>Obowiązek zawarcia umowy dodatkowej:</strong></p>
<p>Do uzyskania kredytu konieczne jest zawarcie przez Pana/Panią umowy dodatkowej w szczeg&oacute;lności umowy ubezpieczenia lub innej umowy</p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Koszty, kt&oacute;re zobowiązany/a będzie Pan/Pani ponieść&nbsp;w związku z umową&nbsp;o kredyt*</strong></p>
</td>
<td>
<p>Na koszty będzie&nbsp;Pan/ Pani zobowiązany/a ponieść&nbsp;w związku z Umowa Pożyczki składają&nbsp;się:</p>
<p>Odsetki zgodnie ze wskazana powyżej stopą&nbsp;oprocentowania pożyczki</p>
<p>Prowizja {m%POZYCZKA.OPLATA_POCZATKOWA} złotych</p>
<p>Opłata za przygotowanie pożyczki {POZYCZKA.OPLATA_ZA_OBSLUGE} złotych</p>
</td>
</tr>
<tr>
<td>
<p><strong>Koszty prowadzenia jednego lub kilku rachunk&oacute;w w celu dokonywania wpłat i wypłat środk&oacute;w pieniężnych*</strong></p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Koszty korzystania z kart kredytowych*</strong></p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Inne koszty, kt&oacute;re konsument zobowiązany jest ponieść&nbsp;w związku z umową*</strong></p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Warunki, na jakich koszty związane z umową&nbsp;o kredyt mogą&nbsp;ulegać&nbsp;zmianie*</strong></p>
</td>
<td>
<p>Zmiana lub wprowadzenia nowych przepis&oacute;w prawa, rekomendacji, zaleceń&nbsp;lub wytycznych organ&oacute;w państwowych odnoszących się&nbsp;do wykonywania umowy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Opłaty notarialne*</strong></p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Skutek braku płatności</strong></p>
<p>Skutki braku płatności mogą&nbsp;być&nbsp;dla Pana/Pani następujące</p>
</td>
<td>
<p>W braku lub w przypadku op&oacute;źnienia w płatności możesz zostać&nbsp;obciążony odsetkami za op&oacute;źnienie w wysokości odsetek maksymalnych, określonych art. 481 &sect; 2<sup>1</sup>&nbsp;Kodeksu cywilnego, tj. r&oacute;wnymi dwukrotności sumy aktualnej stopy referencyjnej Narodowego Banku Polskiego i 5,5 punkt&oacute;w procentowych (w stosunku rocznym). Na dzień 05.10.2023 roku odsetki maksymalne za op&oacute;źnienie wynoszą&nbsp;22,50 % w stosunku rocznym.</p>
<p>Zmiana stopy odsetek maksymalnych za op&oacute;źnienie następuje w przypadku zmiany stopy referencyjnej Narodowego Banku Polskiego, odpowiednio do zmiany tej stopy. W przypadku zmiany stopy odsetek maksymalnych za op&oacute;źnienie, Pożyczkobiorca otrzymuje od Pożyczkodawcy niezwłocznie, informacje o tej zmianie ze wskazaniem nowej wysokości stopy odsetek maksymalnych za op&oacute;źnienie.</p>
<p>W przypadku zmiany stopy odsetek maksymalnych za op&oacute;źnienie Pożyczkodawca nalicza odsetki według nowej stopy od dnia zmiany stopy referencyjnej Narodowego Banku Polskiego.</p>
<p>Pożyczkodawca ma r&oacute;wnież&nbsp;prawo do podjęcia działań&nbsp;mających na celu odzyskanie swojej wierzytelności, w tym w szczeg&oacute;lności do przekazania tej wierzytelności do obsługi przez zewnętrzny podmiot, jak r&oacute;wnież&nbsp;ma prawo do dochodzenia zwrotu pożyczki na drodze postępowania sądowego. Na podstawie prawomocnego wyroku zasądzającego kwotę&nbsp;Pożyczki wraz z innymi wymagalnymi należnościami, Pożyczkobiorca może być&nbsp;obciążony kosztami procesu na podstawie powszechnie obowiązującego prawa.</p>
<p>Pożyczkodawca ma prawo przekazać&nbsp;informacje o zobowiązaniach Pożyczkobiorcy do Biur Informacji Gospodarczej, co może mieć&nbsp;negatywny wpływ na zdolność&nbsp;kredytową&nbsp;Pożyczkobiorcy.</p>
</td>
</tr>
<tr>
<td colspan="2">
<ol>
<li><strong>Inne ważne informacje</strong></li>
</ol>
</td>
</tr>
<tr>
<td>
<p><strong>Odstąpienie od umowy </strong></p>
<p>W terminie 14 dni od dnia zawarcia umowy ma Pan/Pani prawo do odstąpienia od umowy:</p>
</td>
<td>
<p>Tak</p>
<p>W terminie 14 dni od zawarcia umowy Pożyczkobiorca ma prawo skorzystać&nbsp;z odstąpienia od umowy pożyczki.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Spłata kredytu przed terminem określonym w umowie</strong></p>
<p>Ma Pan/Pani prawo w każdym czasie do spłaty całości lub części kredytu przed terminem określonym w umowie</p>
</td>
<td>
<p>Jest Pan/ Pani uprawniony/a do częściowej lub całkowitej spłaty pożyczki przed terminem spłaty pożyczki bez ponoszenia opłat lub koszt&oacute;w z tego tytułu. W takim wypadku całkowity koszt pożyczki ulegnie obniżeniu o te koszty, kt&oacute;re dotyczą&nbsp;okresu, o kt&oacute;ry skr&oacute;cono udostępnienie pożyczki chociażby poni&oacute;sł&nbsp;je Pan /Pani przed spłatą.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Uprawnienie kredytodawcy do zastrzeżenia prowizji za spłatę&nbsp;kredytu przed terminem*</strong></p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Sprawdzenie w bazie danych</strong></p>
<p>Jeżeli kredytodawca odm&oacute;wi Panu/Pani udzielenia kredytu konsumenckiego na podstawie informacji zawartych w bazie danych kredytodawcy niezwłocznie zobowiązany jest przekazać&nbsp;Panu/Pani bezpłatną&nbsp;informację&nbsp;o wynikach tego sprawdzenia oraz wskazać&nbsp;bazę&nbsp;danych, w kt&oacute;rej tego sprawdzenia dokonano</p>
</td>
<td>
<p>Zostanie Pan/Pani sprawdzony/a w następującej bazie danych:</p>
<p>Wewnętrzna baza danych Pożyczkodawcy</p>
<p>Bazy danych uczestnik&oacute;w Platformy Wymiany Informacji Pożyczkowej (Lista wsp&oacute;łpracujących kredytodawc&oacute;w: <a href="http://www.credit-check.pl/uczestnicy/">http://www.credit-check.pl/uczestnicy/</a>)</p>
</td>
</tr>
<tr>
<td>
<p><strong>Prawo do otrzymania projektu umowy o kredyt</strong></p>
<p>Ma Pan/Pani prawo do otrzymania, na wniosek, bezpłatnego projektu umowy o kredyt konsumencki, jeżeli w ocenie kredytodawcy spełnia Pan/Pani warunki do udzielenia kredytu konsumenckiego</p>
</td>
<td>
<p>Ma Pan/Pani prawo do bezpłatnego otrzymania egzemplarza projektu umowy o kredyt.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Czas obowiązywania formularza</strong></p>
</td>
<td>
<p>Niniejsza informacja zachowuje ważność&nbsp;30 dni od daty wystawienia formularza.</p>
</td>
</tr>
<tr>
<td colspan="2">
<ol>
<li><strong>Dodatkowe informacje podawane w przypadku sprzedaży usług finansowych na odległość</strong></li>
</ol>
</td>
</tr>
<tr>
<td colspan="2">
<ol>
<li><strong>Informacje dotyczące kredytodawcy</strong></li>
</ol>
</td>
</tr>
<tr>
<td>
<p><strong>Kredytodawca</strong></p>
</td>
<td>
<p>&nbsp; Minicredit sp. z o.o.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Adres:</strong></p>
<p>(siedziba)</p>
</td>
<td>
<p>&nbsp;ul. Migdałowa 4, 02-796 Warszawa</p>
</td>
</tr>
<tr>
<td>
<p><strong>Numer telefonu:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>+48&nbsp;888&nbsp;444 852</p>
</td>
</tr>
<tr>
<td>
<p><strong>Adres poczty elektronicznej:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>info@minicredit.pl</p>
</td>
</tr>
<tr>
<td>
<p><strong>Numer faxu:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Adres strony internetowej:</strong></p>
<p>(informacja opcjonalna)</p>
</td>
<td>
<p>www.minicredit.pl</p>
</td>
</tr>
<tr>
<td>
<p><strong>Rejestr*</strong></p>
</td>
<td>
<p>Nie dotyczy</p>
</td>
</tr>
<tr>
<td>
<p><strong>Organ nadzoru*</strong></p>
</td>
<td>
<p>Urząd Ochrony Konkurencji i Konsument&oacute;w Plac Powstańc&oacute;w Warszawy 1, 00-950 Warszawa</p>
</td>
</tr>
<tr>
<td colspan="2">
<ol>
<li><strong>Dane dotyczące umowy</strong></li>
</ol>
</td>
</tr>
<tr>
<td>
<p><strong>Odstąpienie od umowy*</strong></p>
</td>
<td>
<p>Ma Pan/Pani prawo do odstąpienia od umowy pożyczki w terminie 14 dni od daty zawarcia umowy poprzez wysłanie wiadomości e-mail z wypełnionym i podpisanym własnoręcznie oświadczeniem we wzorze stanowiącym załącznik do umowy pożyczki zawierającym Imię&nbsp;i Nazwisko na adres: <a href="mailto:info@minicredit.pl">info@minicredit.pl</a> lub wysłanie pisma na adres korespondencyjny: ul. Migdałowa 4, 02-796 Warszawa Zaniechanie kt&oacute;rejkolwiek ze wskazanych powyżej czynności nie stanowi złożenia skutecznego oświadczenia o odstąpieniu. Roszczenie Pożyczkodawcy o zwrot wypłaconej kwoty pożyczki staje się wymagalne w całości w dniu złożenia skutecznego oświadczenia o odstąpieniu wraz z należnościami ubocznymi wskazanymi powyżej.</p>
<p>W przypadku odstąpienia od Umowy Pożyczkobiorca ma obowiązek/zobowiązuje się&nbsp;do zwrotu wypłaconej kwoty Pożyczki wraz z odsetkami kapitałowymi za okres od dnia wypłaty Pożyczki do dnia faktycznej spłaty Pożyczki w terminie 30 dni od dnia złożenia Pożyczkodawcy skutecznego oświadczenia o odstąpieniu.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Wyb&oacute;r prawa właściwego*</strong></p>
<p>Do zawartej z Panem/Panią&nbsp;umowy o kredyt będzie miało&nbsp;zastosowanie prawo:</p>
</td>
<td>
<p>Prawo polskie</p>
</td>
</tr>
<tr>
<td>
<p><strong>Postanowienie umowy dotyczące wyboru prawa właściwego*</strong></p>
</td>
<td>
<p>W kwestiach nieuregulowanych Umowy&nbsp;zastosowanie mają&nbsp;przepisy prawa polskiego. Prawem właściwym jest prawo polskie. Prawo właściwe dla Umowy zostało określone w &sect; 19 ust. 1 Umowy.</p>
</td>
</tr>
<tr>
<td>
<p><strong>Język umowy*</strong></p>
</td>
<td>
<p>Informacje i warunki umowy będą&nbsp;podawane w języku polskim</p>
</td>
</tr>
<tr>
<td>
<ol>
<li><strong>Informacje dotyczące odwołań</strong></li>
</ol>
</td>
<td>&nbsp;</td>
</tr>
<tr>
<td>
<p><strong>Pozasądowe rozstrzyganie spor&oacute;w</strong></p>
</td>
<td>
<p>Przysługuje Panu/ Pani prawo złożenia reklamacji do Pożyczkodawcy w trybie opisanym w Umowie Pożyczki.</p>
<p>Przysługuje Panu/ Pani prawo korzystania z pozasądowego rozstrzygania spor&oacute;w.</p>
<p>Sp&oacute;r między Pożyczkodawcą&nbsp;a Pożyczkobiorcą&nbsp;może być&nbsp;rozstrzygnięty w drodze pozasądowego postępowania przeprowadzonego na wniosek Pożyczkobiorcy przez Rzecznika Finansowego na zasadach określonych w ustawie z dnia 5 sierpnia 2015 r o rozpatrywaniu reklamacji przez podmioty rynku finansowego i o Rzeczniku Finansowym.</p>
<p>W przypadku, gdy Strony nie będą&nbsp;w stanie rozwiązać&nbsp;sporu polubownie, zostanie poddany on pod rozstrzygnięcie właściwemu sądowi powszechnemu.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>`;

const CONSENT_PWIP = `<p style="text-align: left;"><strong>Udzielam wszystkich poniższych zg&oacute;d w celu dokonania oceny mojej zdolności kredytowej, oceny ryzyka kredytowego oraz umożliwienia weryfikacji prawidłowości wykonania oceny.</strong>&nbsp;(<em>udzielenie rzeczonych zg&oacute;d jest dobrowolne, przy czym brak zgody uniemożliwi dokonanie oceny zdolności kredytowej i rozpoznanie niniejszego wniosku</em>)</p>
<p>Wyrażam zgodę na przetwarzanie moich danych osobowych przez Mini Credit sp. z o. o. w celu oceny ryzyka kredytowego oraz mojej zdolności kredytowej, w tym na udostępnianie i pozyskiwanie danych osobowych dotyczących mojej osoby z biur informacji kredytowych oraz od innych kredytodawc&oacute;w.</p>
<p>Upoważniam Mini Credit sp. z o. o. do przekazania w terminie 60 dni do:</p>
<ol>
<li>ERIF Biura Informacji Gospodarczej S.A. (KRS: 182408)</li>
<li>Krajowego Biura Informacji Gospodarczej S.A. (KRS: 172726)</li>
<li>Biura Informacji Gospodarczej InfoMonitor S.A. (KRS: 201192)</li>
<li>Krajowego Rejestru Dług&oacute;w Biura Informacji Gospodarczej S. A. (KRS: 0000169851)</li>
</ol>
<p>moich danych osobowych i udzielam zgody na udostępnienie przez te podmioty Mini Credit, w odpowiedzi na złożone zapytanie:&nbsp;&nbsp;</p>
<ol>
<li>a) informacji gospodarczych dotyczących moich zobowiązań, w tym stanowiących tajemnicę bankową, stosownie do treści art. 24 ust. 1 ustawy z dnia 9 kwietnia 2010 roku o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych (dalej: u.i.g.),</li>
<li>b) dotyczących mnie informacji z rejestr&oacute;w wymienionych w art. 28 ust. 1 u.i.g.</li>
</ol>
<ul>
<li>Wyrażam zgodę na wystąpienie przez Mini Credit sp. z o. o. o ujawnienie moich danych dotyczących historii pożyczek oraz wynik&oacute;w analiz statystycznych oraz do przekazania tych danych Uczestnikom Platformy Wymiany Informacji Pożyczkowej*, w celu oceny mojej zdolności kredytowej i weryfikacji danych.&nbsp;</li>
<li>Wyrażam zgodę na: (i) udostępnienie przez Mini Credit sp. z o. o. moich danych osobowych zawartych każdorazowo we wniosku lub wnioskach o zawarcie umowy o pożyczki Uczestnikom Platformy Wymiany Informacji Pożyczkowej, w celu uzyskania od nich przetwarzanych w ich zbiorach danych informacji o historii moich pożyczek oraz wynik&oacute;w analiz statystycznych, (ii) zestawienie tych informacji oraz wynik&oacute;w analiz statystycznych przez Mini Credit sp. z o. o. i ich (iii) przetwarzanie przez Mini Credit sp. z o. o. przez 3 lata od udostępnienia.&nbsp;</li>
<li>Wyrażam zgodę na udostępnienie Mini Credit przez Uczestnik&oacute;w Platformy Wymiany Informacji Pożyczkowej*, przetwarzanych w ich zbiorach danych informacji o historii moich pożyczek oraz wynik&oacute;w analiz statystycznych i ich przetwarzanie przez Mini Credit sp. z o. o. przez 3 lata od udostępnienia.&nbsp;</li>
<li>Wyrażam zgodę na przetwarzanie moich danych osobowych zawartych każdorazowo we wniosku lub wnioskach o zawarcie umowy o kredyt konsumencki przez Mini Credit sp. z o. o. nie dłużej jednak niż przez 3 lata odpowiednio po wykonaniu zobowiązań wobec instytucji finansowej, wynikających z zawartej umowy o kredyt konsumencki, zbyciu przez instytucję finansową wierzytelności wynikających z umowy o kredyt konsumencki lub rozwiązaniu umowy o kredyt konsumencki moich danych osobowych zawartych w umowie o świadczenie usługi finansowej oraz informacji dotyczących wykonywania zobowiązań wynikających z tej umowy, a także na przetwarzanie przez instytucję finansową w analizach statystycznych przez 3 lata moich danych zebranych w procesie wnioskowania o udzielenie usługi finansowej.&nbsp;</li>
</ul>`;

const CONSENT_PASSTHRU = /*`<p><strong>Ujawnienie informacji o wywiązaniu się przeze mnie z wszelkich zobowiązań pieniężnych Biurom Informacji Gospodarczej.</strong></p>
<p><strong>&nbsp;</strong></p>
<p><strong>&nbsp;</strong></p>
<p>Upoważniam Mini Credit do wystąpienia o ujawnienie informacji o wywiązaniu się przeze mnie z wszelkich zobowiązań pieniężnych biurom informacji gospodarczej.</p>
<p>Na podstawie art. 18 ust. 1 pkt 2 u.i.g. udzielam Mini Credit sp. z o. o. zgody na przekazanie do:</p>
<ol>
<li>Krajowego Biura Informacji Gospodarczej S.A. (KRS: 172726),</li>
<li>ERIF Biura Informacji Gospodarczej S.A. (KRS: 0000182408)</li>
<li>Biura Informacji Gospodarczej InfoMonitor S.A. (KRS: 201192) oraz</li>
<li>Krajowego Rejestru Dług&oacute;w Biura Informacji Gospodarczej S. A. (KRS: 0000169851)</li>
</ol>
<p>informacji gospodarczych o wywiązywaniu się przeze mnie z wszelkich zobowiązań pieniężnych, zar&oacute;wno istniejących w chwili udzielenia zgody, jak r&oacute;wnież mogących powstać w przyszłości, a powstałych w związku z umową o kredyt konsumencki zawartą z Mini Credit sp. z o. o.</p>`;
*/
`<p><strong>KLAUZULA INFORMACYJNA Mini Credit</strong></p>
<p><strong>&nbsp;</strong></p>
<p>Przedstawiamy <strong>informacje o zasadach przetwarzania Pani/Pana danych osobowych przez Mini Credit</strong> <strong>Sp&oacute;łka Akcyjna</strong> (dalej r&oacute;wnież &bdquo;Mini Credit&rdquo; lub &bdquo;Administrator&rdquo;).</p>
<ol>
<li><strong>Podstawa prawna:</strong></li>
</ol>
<p>Informacja jest przekazywana na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 roku w sprawie ochrony os&oacute;b fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 94/46/WE (dalej &bdquo;Rozporządzenie&rdquo;)</p>
<p>&nbsp;</p>
<ol>
<li><strong>Administrator:</strong></li>
</ol>
<p>Administratorem w rozumieniu art. 4 pkt 7) Rozporządzenia, kt&oacute;ry samodzielnie ustala cele i sposoby przetwarzania danych osobowych jest <strong>Mini Credit</strong>z siedzibą przy ul. Wybrzeże Kościuszkowskie 31/33, 00-379 Warszawa.</p>
<p>&nbsp;</p>
<ol>
<li><strong>Dane kontaktowe:</strong></li>
</ol>
<p>Z Administratorem można się skontaktować poprzez adres e-mail: <a href="about:blank">pozyczki@minicredit.pl</a>&nbsp; lub telefoniczny (22) 584 10 08</p>
<p>&nbsp;</p>
<ol>
<li><strong>Cele przetwarzania oraz podstawa prawna przetwarzania:</strong></li>
</ol>
<p>Pani/Pana dane będą przetwarzane przez <strong>Mini Credit</strong> <strong>Sp&oacute;łka Akcyjna</strong> w celach gł&oacute;wnych:</p>
<ul>
<li>weryfikacji tożsamości klienta oraz spełnienia obowiązku identyfikacyjnego - podstawą prawną przetwarzania danych osobowych jest art. 6 ust. 1 lit. c RODO w zw. z art. 9 &ndash; 9a ustawy z dn. 16 listopada 2000r. o przeciwdziałaniu praniu pieniędzy i finansowaniu terroryzmu;</li>
<li>rozpatrywania wniosku o pożyczkę lub podejmowania czynności związanych z zawarciem umowy kredytu konsumenckiego &ndash; podstawą prawną przetwarzania danych osobowych jest w takim przypadku art. 6 ust. 1 lit. b Rozporządzenia; art. 3 Ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim, art. 9 Ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim;</li>
<li>ocena zdolności kredytowej i analiza ryzyka kredytowego, w tym z wykorzystaniem automatycznych system&oacute;w podejmujących decyzje kredytowe art. 6 ust. 1 lit. c) Rozporządzenia; art. 9 ustawy o kredycie konsumenckim;</li>
<li>w przypadku jeśli dojdzie do zawarcia umowy pożyczki &ndash; wykonywanie umowy oraz dokonywanie innych czynności związanych z umową takich jak: ocena zdolności kredytowej i analiza ryzyka kredytowego, w tym z wykorzystaniem automatycznych system&oacute;w podejmujących decyzje kredytowe &ndash; podstawą prawną przetwarzania danych osobowych jest w takim przypadku art. 6 ust. 1 lit. f) Rozporządzenia; art. 9 Ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim, art. 59b ust. 3 Ustawy z dnia 12 maja 2011 r.&nbsp; o kredycie konsumenckim, art. 105 ustawy z dnia 29 sierpnia 1997 r. Prawo bankowe;</li>
<li>marketingowych w trakcie obowiązywania umowy pożyczki podstawą prawną przetwarzania danych osobowych jest art. 6 ust. 1 lit. f) Rozporządzenia, polegający na prawie do prowadzenia marketingu produkt&oacute;w i usług własnych;</li>
<li>marketingu bezpośredniego (przekazywanie, wyświetlanie lub przesyłanie informacji handlowych drogą elektroniczną, telefoniczną) - podstawą prawną przetwarzania danych osobowych jest art. 6 ust. 1 lit. a) Rozporządzenia w zw. z art. 172 ustawy z dnia 16 lipca 2004 r. Prawo telekomunikacyjne i ustawa z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną;</li>
<li>związanych z przyjęciem Pani/Pana skargi, wniosku, reklamacji, ich rozpatrzeniem oraz skierowaniem odpowiedzi (art. 6 ust. pkt. 1 lit. c) Rozporządzenia w zw. z art. 6 ustawy z dn. 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego i o Rzeczniku Finansowym);</li>
<li>rozpatrywania Pani/Pana zgłoszonych roszczeń &ndash; podstawą prawną przetwarzania danych osobowych jest prawnie uzasadniony interes Administratora tj. art. 6 ust. 1 lit. f) Rozporządzenia, polegający na obronie przed potencjalnymi roszczeniami;</li>
<li>pozyskania informacji gospodarczych ze zbior&oacute;w danych biur informacji kredytowych oraz gospodarczych - art. 6 ust. pkt. 1 lit. c) Rozporządzenia&nbsp; w zw. z&nbsp; 105a ust 3 Prawa bankowego oraz art. 14 ust. 1 ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych;</li>
<li>raportowania Pani/Pana danych do instytucji finansowych tj. do Biura Informacji Kredytowej S.A. jak r&oacute;wnież do Biur informacji gospodarczych &ndash; podstawą prawną przetwarzania danych osobowych jest art. 6 ust. pkt. 1 lit. c) Rozporządzenia w zw. z&nbsp; 105a ust 3 Prawa bankowego oraz art. 14 ust. 1 ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych).</li>
</ul>
<p>&nbsp;</p>
<ol>
<li><strong>Kategorie przetwarzanych danych:</strong></li>
</ol>
<p><strong>Mini Credit</strong> przetwarza Pani/Pana dane osobowe w zakresie:</p>
<ul>
<li>dane identyfikujące osobę, w tym: PESEL, imiona, nazwiska, dane dotyczące dokumentu tożsamości, płeć, obywatelstwo; stan cywilny, liczbę dzieci na utrzymaniu, status zawodowy, branżę, w kt&oacute;rej Pan/ Pani pracuje, doch&oacute;d miesięczny, miejsce pracy;</li>
<li>dane adresowe i teleadresowe w tym adres e-mail i numer telefonu;</li>
<li>dane dotyczące zobowiązania w tym: cel i źr&oacute;dło zobowiązania, kwota i waluta, stan zadłużenia, okres i warunki spłaty zobowiązania, zabezpieczenie prawne, przebieg realizacji zobowiązania, dane dotyczące wniosk&oacute;w kredytowych.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol>
<li><strong>Źr&oacute;dło pochodzenia danych: </strong></li>
</ol>
<p>Dane osobowe zbieramy od os&oacute;b, kt&oacute;rych dane dotyczą (tj. od os&oacute;b składających wnioski o pożyczkę, os&oacute;b wyrażających zgodę na przetwarzanie danych osobowych, os&oacute;b składających reklamacje) lub od podmiot&oacute;w trzecich, kt&oacute;re przekazują nam informacje o Tobie na podstawie udzielonych przez Ciebie upoważnień lub w oparciu o powszechnie obowiązujące przepisy prawa.</p>
<p>&nbsp;</p>
<ol>
<li><strong>Dobrowolność lub obowiązek podania danych:</strong></li>
</ol>
<p>Pozyskanie od Pani/Pana danych osobowych wynika z obowiązku prawnego, kt&oacute;ry na nas spoczywa. Odmowa podania danych może stanowić przyczynę odmowy zawarcia przez Mini Credit umowy z Panią/Panem. Jeżeli podanie danych nie wynika z przepis&oacute;w prawa, Mini Credit może je przetwarzać wyłącznie na podstawie wyrażonej przez Panią/Pana zgody.</p>
<p><strong>&nbsp;</strong></p>
<ol>
<li><strong>Okres przez kt&oacute;ry dane będą przetwarzane:</strong></li>
</ol>
<p>Pani/Pana dane osobowe będą przetwarzane przez Mini Credit :</p>
<ul>
<li>dla cel&oacute;w dokonywania oceny zdolności kredytowej i analizy ryzyka kredytowego &ndash; przez okres 3 lat od (i) odmowy udzielenia pożyczki, lub (ii) rezygnacji klienta z zaciągnięcia pożyczki lub (iii) spłaty przez klienta całości kwot należnych Mini Credit z tytułu zawartej umowy pożyczki lub (iv) zbyciu przez Mini Credit wierzytelności wynikających z umowy pożyczki lub (v) wygaśnięcia umowy pożyczki zawartej między Stronami (w zależności, kt&oacute;re z powyższych, nastąpi najp&oacute;źniej);</li>
<li>dla cel&oacute;w realizacji umowy kredytu konsumenckiego&ndash; przez okres trwania umowy;</li>
<li>dla cel&oacute;w marketingowych w trakcie obowiązywania umowy o świadczenie usług drogą elektroniczną &ndash; do czasu rozwiązania tej umowy lub do czasu wniesienia sprzeciwu wobec przetwarzania danych;</li>
<li>dla cel&oacute;w marketingu bezpośredniego wykonywanego przy pomocy telekomunikacyjnych urządzeń końcowych i automatycznych system&oacute;w wywołujących, -do czasu cofnięcia przez Panią/ Pana stosownej zgody;</li>
<li>dla cel&oacute;w przesyłania informacji handlowych drogą elektroniczną, -do czasu cofnięcia przez Panią/ Pana stosownej zgody;</li>
<li>dla cel&oacute;w rozpatrywania Pani/Pana reklamacji i zgłoszonych roszczeń &ndash; do momentu przedawnienia Pani/Pana potencjalnych roszczeń z tytułu naruszenia przetwarzania danych;</li>
<li>dla cel&oacute;w windykacji i dochodzenia roszczeń przez Mini Credit &ndash; do momentu sprzedaży roszczeń firmom zewnętrznym lub przedawnienia roszczeń wynikających z umowy lub z innego tytułu zgodnie z obowiązującymi przepisami prawa cywilnego;</li>
<li>do cel&oacute;w związanych z prowadzeniem postępowań sądowych &ndash; dane mogą być przetwarzane do 10 lat od dnia wydania prawomocnego orzeczenia kończącego postępowanie;</li>
<li>dla cel&oacute;w wykrywania nadużyć i zapobiegania im &ndash; przez czas trwania umowy kredytu konsumenckiego, a następnie przez okres, po którym przedawnią się roszczenia wynikające z umowy, a w przypadku dochodzenia przez Mini Credit lub zawiadamiania właściwych organów &ndash; przez czas trwania takich postępowań;</li>
<li>dla cel&oacute;w tworzenia zestawień, analiz i statystyk&ndash; przez czas trwania umowy kredytu konsumenckiego, a następnie nie dłużej niż przez okres, po którym przedawnią się roszczenia wynikające z umowy;</li>
<li>dla cel&oacute;w prowadzenia obligatoryjnej sprawozdawczości finansowej, przez okres 5 lat liczonych od zakończenia roku obrachunkowego;</li>
<li>dla cel&oacute;w archiwalnych - po wygaśnięciu danej relacji prawnej (czyli np. umowy) dane osobowe dotyczące działania tych os&oacute;b w imieniu przedsiębiorcy, instytucji lub jednostek organizacyjnych są przetwarzane przez 6 lat, a pozostałe dane osobowe os&oacute;b fizycznych są przetwarzane przez okres do 10 lat, chyba że przepisy prawa przewidują kr&oacute;tszy okres. Jeśli toczy się sp&oacute;r, proces sądowy lub trwa inne postępowanie (szczeg&oacute;lnie karne), okres archiwizacyjny będzie liczony od dnia prawomocnego zakończenia sporu, a w przypadku wielu postępowań prawomocnego zakończenia ostatniego z nich, bez względu na spos&oacute;b jego zakończenia, chyba że przepisy prawa przewidują dłuższy okres przechowywania danych lub dłuższy okres przedawnienia dla roszczeń/prawa kt&oacute;rego dotyczy postępowanie;</li>
<li>dla cel&oacute;w dokonania weryfikacji zdolności kredytowej i analizy ryzyka kredytowego w związku z udostępnieniem danych do&nbsp; BIG Info Monitor SA oraz biur informacji gospodarczej przez okres nie dłuższy niż 2 lata od przekazania danych.</li>
</ul>
<p>W przypadkach pozyskania przez Mini Credit danych z baz prowadzonych przez inne podmioty lub danych przekazanych przez inne podmioty - okres przetwarzania zależny jest od celu przekazania lub odwołania zgody.</p>
<p>&nbsp;</p>
<ol>
<li><strong>Odbiorcy danych</strong></li>
</ol>
<ol>
<li>Pani/Pana dane osobowe mogą być udostępniane przez Mini Credit podmiotom uprawnionym do ich otrzymania na podstawie Pana/ Pani zgody w celu oceny zdolności kredytowej i analizy ryzyka kredytowego tj.</li>
<li>Biuro Informacji Kredytowej S. A., z siedzibą w Warszawie, ul. Zygmunta Modzelewskiego 77A;</li>
<li>BIG InfoMonitor S. A. z siedzibą w Warszawie, ul. Jacka Kaczmarskiego 77, 02-679 Warszawa;</li>
</ol>
<ul>
<li>Podmioty wspierające Mini Credit w oparciu o umowy zawierające odpowiednie klauzule chroniące dane osobowe w prowadzeniu działalności. Podmioty te należą do następujących podkategorii firmy windykacyjne, firmy pocztowe, firmy wspierające nas w świadczeniu usług drogą elektroniczną firmy, kt&oacute;re wykonują usługi księgowo-podatkowe oraz audytowe, firmy wspierające promocję naszych produkt&oacute;w i wsp&oacute;łpracują w ramach kampanii marketingowych, bank organy publiczne walczące z oszustwami i nadużyciami.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol>
<li><strong>Automatyczne podejmowanie decyzji:</strong></li>
</ol>
<p>Pani/Pana dane będą przetwarzane w spos&oacute;b zautomatyzowany. W procesie oceny zdolności kredytowej Mini Credit podejmuje decyzje w spos&oacute;b zautomatyzowany w oparciu o dane podane przez Panią/ Pana oraz dane pozyskane z baz zewnętrznych (podstawa prawna: art. 6 ust. 1 lit. f RODO). Decyzje te są podejmowane automatycznie w oparciu o stosowany przez Sp&oacute;łkę model scoringowy/wewnętrzne wytyczne polityki kredytowej firmy. Decyzje podejmowane w ten zautomatyzowany spos&oacute;b mają wpływ na decyzję o przyznaniu lub odmowie przyznania pożyczki lub na zaproponowanie Panu/ Pani określonego produktu finansowego. Podejmowanie decyzji w spos&oacute;b zautomatyzowany do cel&oacute;w oceny zdolności kredytowej jest niezbędne do celu zawarcia umowy kredytu konsumenckiego.</p>
<p>&nbsp;</p>
<ol>
<li><strong>Prawa osoby, kt&oacute;rej dane dotyczą</strong></li>
</ol>
<p>Przysługuje Pani/Panu prawo dostępu do Pani/Pana danych oraz prawo żądania ich sprostowania (gdy są niezgodne ze stanem rzeczywistym), usunięcia, ograniczenia przetwarzania (w przypadkach przewidzianych prawem).</p>
<p>W&nbsp;zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest przesłanka prawnie uzasadnionego interesu Administratora, przysługuje Pani/Panu prawo wniesienia sprzeciwu wobec przetwarzania Pani/Pana danych osobowych.</p>
<p>W zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest zgoda, ma Pani/Pan prawo wycofania zgody. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania, kt&oacute;rego dokonano na podstawie zgody przed jej wycofaniem.</p>
<p>Osobie, kt&oacute;ra wyraziła zgody na przesyłanie informacji handlowej drogą elektroniczną (np. za pośrednictwem poczty e-mail, SMS i inne), przysługuje prawo cofnięcia wyrażonej zgody.</p>
<p>Przysługuje Pani/Panu także prawo do przenoszenia danych osobowych, tj. do otrzymania od Administratora Pani/Pana danych osobowych, w&nbsp;ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego. Może Pani/Pan przesłać te dane innemu Administratorowi danych. Uprawnienie do przenoszenia danych nie dotyczy danych, kt&oacute;re stanowią tajemnicę przedsiębiorstwa.</p>
<p>Przysługuje Pani/Panu r&oacute;wnież prawo wniesienia skargi do Generalnego Inspektora Ochrony Danych Osobowych&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (w przyszłości do Prezesa Urzędu Ochrony Danych Osobowych) z siedzibą w Warszawie (00-923) przy ul. Stawki 2.</p>
<p>&nbsp;</p>`;

const CONSENT_BIK = `<p><strong>Zgoda na weryfikację w Biurze Informacji Kredytowej S.A.</strong></p>
<p>&nbsp;</p>
<p>W związku ze złożeniem przeze mnie wniosku o pożyczkę, niniejszym udzielam Pożyczkodawcy, tj. sp&oacute;łce Mini Credit sp. z o. o. &nbsp;pełnomocnictwa do wystąpienia w moim imieniu do Biura Informacji Kredytowej S.A. o udostępnienie informacji, w tym stanowiących tajemnicę bankową oraz do złożenia w moim imieniu oświadczenia dotyczącego przetwarzania moich danych osobowych o następującej treści:</p>
<p>&bdquo;W związku ze złożeniem przez mnie wniosku o pożyczkę:</p>
<p>Upoważniam Pożyczkodawcę, tj. Mini Credit sp. z o. o. do przekazania do Biura Informacji Kredytowej S.A. z siedzibą w Warszawie moich danych osobowych (zapytanie) i wyrażam zgodę na przetwarzanie przez Biuro Informacji Kredytowej S.A, w tym udostępnienie Mini Credit sp. z o. o. &nbsp;w odpowiedzi na złożone zapytanie informacji mnie dotyczących, w tym stanowiących tajemnicę bankową dla oceny zdolności kredytowej i analizy ryzyka kredytowego oraz na przetwarzanie w tym celu moich danych osobowych przekazanych przez Mini Credit sp. z o. o. w zapytaniu przez okres nie dłuższy niż 2 lata, w tym ich udostępnianie bankom, instytucjom ustawowo upoważnionym do udzielania kredyt&oacute;w, instytucjom kredytowym, instytucjom pożyczkowym i podmiotom, o kt&oacute;rych mowa w art. 59d ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim a także innym podmiotom na podstawie udzielonej im przeze mnie zgody.</p>
<p>Upoważniam Pożyczkodawcę, tj. Mini Credit sp. z o. o. do przekazania do Biura Informacji Kredytowej S.A. z siedzibą w Warszawie moich danych osobowych i informacji dotyczących mojego zobowiązania wynikającego z zawartej z Pożyczkodawcą umowy, w tym także zobowiązania po odstąpieniu od umowy, a także wyrażam zgodę na przetwarzanie przez Biuro Informacji Kredytowej, w tym udostępnianie informacji mnie dotyczących, w tym stanowiących tajemnicę bankową do Mini Credit sp. z o. o. dla cel&oacute;w dokonywanej przez ten podmiot oceny zdolności kredytowej i analizy ryzyka kredytowego w trakcie obowiązywania zawartej z Mini Credit sp. z o. o. umowy lub istnienia mojego zobowiązania po odstąpieniu od umowy oraz przetwarzanie przez Biuro Informacji Kredytowej S.A. moich danych osobowych i informacji dotyczących mojego zobowiązania wynikającego z zawartej z Mini Credit sp. z o. o. umowy, w tym odstąpienia od umowy, po wygaśnięciu zobowiązania w celu oceny zdolności kredytowej i analizy ryzyka kredytowego i udostępnianie w tym celu tych danych bankom, instytucjom ustawowo upoważnionym do udzielania kredyt&oacute;w, instytucjom kredytowym, instytucjom pożyczkowym i podmiotom, o kt&oacute;rych mowa w art. 59d ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim a także innym podmiotom na podstawie udzielonej im przeze mnie zgody.&rdquo;</p>
<p>Potwierdzam, że zostałam(em) poinformowana(y) o prawie do odwołania powyższych zg&oacute;d. Przyjmuję do wiadomości, że odwołanie zgody nie wpływa na zgodność z&nbsp;prawem przetwarzania danych przed jej odwołaniem.</p>
<p>Potwierdzam, że zostałem poinformowany:</p>
<p>prawie do żądania od administratora dostępu do swoich danych osobowych, ich sprostowania, usunięcia lub ograniczenia przetwarzania, a także o prawie do przenoszenia danych;</p>
<p>prawie do cofnięcia zgody na przetwarzanie danych w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania, kt&oacute;rego dokonano na podstawie zgody przed jej cofnięciem;</p>
<p>prawie do wniesienia skargi do organu nadzorczego jeżeli sądzę, że przetwarzanie danych mnie dotyczące narusza Rozporządzenie Parlamentu Europejskiego i Rady (UE) nr 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE;</p>
<p>dobrowolności udzielenia powyższych zg&oacute;d, z zastrzeżeniem, że ich udzielenie jest warunkiem zawarcia umowy o kredyt konsumencki;</p>
<p>o tym, że przetwarzanie moich danych osobowych na podstawie powyższych zg&oacute;d stanowi profilowanie w rozumieniu art. 22 Rozporządzenia Parlamentu Europejskiego i Rady (UE) nr 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony os&oacute;b fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE&nbsp; polegające na zautomatyzowanym podejmowaniu decyzji odnośnie mojej zdolności kredytowej w oparciu o informacje pozyskane ze zbior&oacute;w danych Uczestnik&oacute;w Platformy Wymiany Informacji Pożyczkowej o historii moich pożyczek oraz wynikach analiz statystycznych;</p>
<p>o tym, że wynik profilowania ma znaczenie dla decyzji w przedmiocie zawarcia ze mną umowy kredytu, z zastrzeżeniem, że przysługuje mi w każdym przypadku prawo do uzyskania interwencji ludzkiej ze strony administratora, wyrażenia własnego stanowiska i do zakwestionowania tej decyzji.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Klauzula informacyjna Biura Informacji Kredytowej S. A.</strong></p>
<p>&nbsp;</p>
<p>W wykonaniu obowiązku wynikającego z umowy zawartej z Biurem Informacji Kredytowej S. A. (dalej &bdquo;BIK&rdquo;) umowy informuję,&nbsp; że na podstawie wyrażonej przez Panią/Pana zgody Pani/Pana dane osobowe mogą zostać przekazane do Biura Informacji Kredytowej S.A. z siedzibą w Warszawie, ul. Jacka Kaczmarskiego 77a, w celu udostępnienia przez BIK do Mini Credit sp. z o. o. &nbsp;z siedzibą w Warszawie odpowiedzi na złożone zapytanie, informacji dotyczących Pani/Pana, w tym stanowiących tajemnicę bankową, dla oceny zdolności kredytowej i analizy ryzyka kredytowego, i/lub w celu przetwarzania przez BIK danych dotyczących Pani/Pana zobowiązania wynikającego z zawartej umowy kredytu konsumenckiego.</p>
<p>&nbsp;</p>
<p>Wyrażenie ww. zgody oznacza, że BIK &ndash; obok podmiotu składającego zapytanie&ndash; stanie się administratorem Pani/Pana danych osobowych.</p>
<p>Poniżej przedstawiamy informacje dotyczące przetwarzania Pani/Pana danych osobowych przez BIK:</p>
<p>&nbsp;</p>
<p><strong>Administrator danych</strong></p>
<p>Administratorem Pani/Pana danych osobowych jest Biuro Informacji Kredytowej S.A. z siedzibą w Warszawie, ul. Jacka Kaczmarskiego 77a, 02-679 Warszawa (BIK).</p>
<p>&nbsp;</p>
<p><strong>Dane kontaktowe</strong></p>
<p>Z BIK można się skontaktować poprzez adres e-mail: <u>kontakt@bik.pl</u>, lub pisemnie (Centrum Obsługi Klienta BIK S.A., 02-676 Warszawa, ul.&nbsp;Postępu 17A). W BIK wyznaczony jest inspektor ochrony danych, z&nbsp;kt&oacute;rym można się skontaktować poprzez e-mail: <u>iod@bik.pl</u> lub pisemnie (Inspektor Ochrony Danych, Centrum Obsługi Klienta BIK S.A., 02-676 Warszawa, ul. Postępu 17A). Z&nbsp;inspektorem ochrony danych można się kontaktować we wszystkich sprawach dotyczących przetwarzania danych osobowych oraz korzystania z&nbsp;praw związanych z przetwarzaniem danych.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Cele przetwarzania oraz podstawa prawna przetwarzania</strong></p>
<p>Pani/Pana dane będą przetwarzane przez BIK w celach:</p>
<p>&nbsp;</p>
<p>oceny zdolności kredytowej i analizy ryzyka kredytowego, w tym z wykorzystaniem profilowania, &ndash; podstawą prawną przetwarzania danych osobowych jest Pani/Pana zgoda;</p>
<p>statystycznych i analiz, kt&oacute;rych wynikiem nie są dane osobowe i wynik ten nie służy za podstawę podejmowania decyzji dotyczącej konkretnej osoby fizycznej &ndash; podstawą prawną przetwarzania danych osobowych jest prawnie uzasadniony interes polegający na przygotowywaniu dla potrzeb bank&oacute;w, instytucji pożyczkowych i innych instytucji upoważnionych (odbiorc&oacute;w danych) produkt&oacute;w oraz usług wspomagających i umożliwiających właściwe zarządzanie rachunkiem i portfelem kredytowym (pożyczkowym) klient&oacute;w.</p>
<p>w celu rozpatrywania Pani/Pana potencjalnych reklamacji i zgłoszonych roszczeń &ndash; podstawą prawną przetwarzania danych osobowych jest prawnie uzasadniony interes administratora danych, polegający na rozpatrzeniu zgłoszenia będącego przedmiotem reklamacji oraz obrony przez potencjalnymi roszczeniami.</p>
<p><strong>&nbsp;</strong></p>
<p><strong>Kategorie przetwarzanych danych</strong></p>
<p>BIK przetwarza Pani/Pana dane osobowe w zakresie:</p>
<p>dane identyfikujące osobę, w tym: PESEL, imiona, nazwiska, dane dotyczące dokument&oacute;w tożsamości, data i miejsce urodzenia, płeć, obywatelstwo; dane adresowe i teleadresowe; dane dotyczące zobowiązania w tym: cel i źr&oacute;dło zobowiązania, kwota i waluta, stan zadłużenia, okres i warunki spłaty zobowiązania, zabezpieczenie prawne, przebieg realizacji zobowiązania, dane dotyczące wniosk&oacute;w kredytowych.</p>
<p><strong>&nbsp;</strong></p>
<p><strong>Źr&oacute;dło pochodzenia danych</strong></p>
<p>BIK pozyskuje Pani/Pana dane osobowe ze Sp&oacute;łki.</p>
<p>&nbsp;</p>
<p><strong>Okres przez kt&oacute;ry dane będą przetwarzane</strong></p>
<p><strong>&nbsp;</strong></p>
<p>Pani/Pana dane osobowe będą przetwarzane przez BIK:</p>
<p>dla cel&oacute;w dokonywania oceny zdolności kredytowej i analizy ryzyka kredytowego, w tym profilowania &ndash; przez okres trwania Pani/Pana zobowiązania lub po jego wygaśnięciu &ndash;  w każdym przypadku w razie wyrażenia przez Panią/Pana zgody nie dłużej niż przez okres 5 lat po wygaśnięciu zobowiązania, a w zakresie danych wynikających z zapytania przekazanego do BIK &ndash; przez okres nie dłuższy niż 2 lata od jego przekazania;</p>
<p>dla cel&oacute;w statystycznych i analiz &ndash; przez okres nie dłuższy niż okres przetwarzania Pani/Pana danych osobowych w celu określonym w powyższym punkcie;</p>
<p>dla cel&oacute;w rozpatrywania Pani/Pana reklamacji i zgłoszonych roszczeń &ndash; do momentu przedawnienia Pani/Pana potencjalnych roszczeń z tytułu naruszenia przetwarzania danych</p>
<p><strong>&nbsp;</strong></p>
<p><strong>Odbiorcy danych</strong></p>
<p>Pani/Pana dane osobowe mogą być udostępniane przez BIK podmiotom uprawnionym do ich otrzymania na podstawie Pana/ Pani zgody tj. bankom, instytucjom ustawowo upoważnionym do udzielania kredyt&oacute;w, instytucjom kredytowym, instytucjom pożyczkowym i podmiotom,  o kt&oacute;rych mowa w art. 59d ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim a także do rejestru PESEL lub Rejestru Dowod&oacute;w Osobistych w celu weryfikacji poprawności przekazanych danych osobowych. Pani/Pana dane osobowe mogą być także przekazywane podmiotom przetwarzającym dane w imieniu BIK, takim jak dostawcy usług informatycznych &ndash; przy czym takie podmioty przetwarzają dane jako podwykonawcy, na podstawie umowy z BIK i wyłącznie zgodnie z poleceniami BIK.</p>
<p><strong>&nbsp;</strong></p>
<p><strong>Prawa osoby, kt&oacute;rej dane dotyczą</strong></p>
<p>Przysługuje Pani/Panu prawo dostępu do Pani/Pana danych oraz prawo żądania ich sprostowania, usunięcia, ograniczenia przetwarzania. W&nbsp;zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest przesłanka prawnie uzasadnionego interesu administratora, przysługuje Pani/Panu prawo wniesienia sprzeciwu wobec przetwarzania Pani/Pana danych osobowych.</p>
<p>&nbsp;</p>
<p>W zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest zgoda, ma Pani/Pan prawo wycofania zgody. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania, kt&oacute;rego dokonano na podstawie zgody przed jej wycofaniem.</p>
<p>&nbsp;</p>
<p>W zakresie, w jakim Pani/Pana dane są przetwarzane w celu zawarcia i&nbsp;wykonywania umowy lub przetwarzane na podstawie zgody &ndash; przysługuje Pani/Panu także prawo do przenoszenia danych osobowych, tj. do otrzymania od administratora Pani/Pana danych osobowych, w&nbsp;ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego. Może Pani/Pan przesłać te dane innemu administratorowi danych. Uprawnienie do przenoszenia danych nie dotyczy danych, kt&oacute;re stanowią tajemnicę przedsiębiorstwa.</p>
<p>&nbsp;</p>
<p>Przysługuje Pani/Panu r&oacute;wnież prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych.</p>
<p>&nbsp;</p>`;


const CONSENT_BIK2 = `<p style="text-align: center;"><strong>ZGODA NA UDOSTĘPNIANIE INFORMACJI GOSPODARCZYCH</strong></p>
<p><strong>&nbsp;</strong></p>
<p>W związku ze złożeniem przeze mnie wniosku o udzielenie pożyczki:</p>
<ol>
<li>Na podstawie art. 18 ust. 1 pkt 2 ustawy z dnia 9 kwietnia 2010 roku o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych, udzielam zgody Pożyczkodawcy <strong>Mini Credit </strong>z siedzibą w Warszawie (02-796) przy ul. Migdałowa 4, KRS: 00001234 (dalej jako: <strong>Pożyczkodawca</strong>), przekazanie do:
<ol>
<li>BIG InfoMonitor S.A.,</li>
<li>Krajowy Rejestr Dług&oacute;w Biuro Informacji Gospodarczej S.A.,</li>
<li>Krajowe Biuro Informacji Gospodarczej S.A.,</li>
</ol>
</li>
</ol>
<p>informacji gospodarczych o wywiązywaniu się ze wszelkich zobowiązań pieniężnych, zar&oacute;wno istniejących w chwili udzielenia zgody, jak r&oacute;wnież mogących powstać w przyszłości, a powstałych w związku z umową pożyczki zawartą z Pożyczkodawcą.</p>
<p>&nbsp;</p>
<ol start="2">
<li>Upoważniam Pożyczkodawcę do przekazania do Biura Informacji Kredytowej S.A. z siedzibą w Warszawie moich danych osobowych i informacji dotyczących mojego zobowiązania<a href="#_ftn1" name="_ftnref1">[1]</a> wynikającego z zawartej umowy pożyczki, w tym także zobowiązania po odstąpieniu od umowy, a także wyrażam zgodę na przetwarzanie przez Biuro Informacji Kredytowej S.A., w tym udostępnianie informacji mnie dotyczących, w tym stanowiących tajemnicę bankową do Pożyczkodawcy dla cel&oacute;w dokonywanej przez ten podmiot oceny zdolności kredytowej i analizy ryzyka kredytowego w trakcie obowiązywania zawartej umowy pożyczki, po odstąpieniu od umowy oraz przetwarzanie przez Biuro Informacji Kredytowej S.A. moich danych osobowych i informacji dotyczących mojego zobowiązania wynikającego z zawartej umowy pożyczki, w tym odstąpienia od umowy, po wygaśnięciu zobowiązania w celu oceny zdolności kredytowej i analizy ryzyka kredytowego i udostępnianie w tym celu tych danych bankom, instytucjom ustawowo upoważnionym do udzielania kredyt&oacute;w, instytucjom kredytowym, instytucjom pożyczkowym i podmiotom, o kt&oacute;rych mowa w art. 59d ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim a także innym podmiotom na podstawie udzielonej im przeze mnie zgody.</li>
</ol>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>Potwierdzam, że zostałam(em) poinformowana(y), iż powyższe upoważnienie może być odwołane w każdym czasie. Przyjmuję do wiadomości, że odwołanie zgody nie wpływa na zgodność z prawem przetwarzania danych przed jej odwołaniem.</p>
<p>&nbsp;</p>
<p><a href="#_ftnref1" name="_ftn1">[1]</a> <em>zakres danych określa rozporządzenie ministra finans&oacute;w z dnia 23 czerwca 2016 r. w sprawie szczeg&oacute;łowego zakresu danych podlegających wymianie pomiędzy instytucjami utworzonymi na podstawie przepis&oacute;w prawa bankowego a instytucjami pożyczkowymi i innymi podmiotami</em></p>`;


const CONSENT_RBOX = `<p style="text-align: center;"><strong>KLAUZULA INFORMACYJNA</strong></p>
<p>&nbsp;</p>
<p>Poniżej przedstawiamy informacje o zasadach przetwarzania Pani/Pana danych osobowych przez&nbsp;<strong>RiskBite&nbsp;</strong>Sp. z o.o. z siedzibą w Warszawie (KRS: 0000795549) (dalej &bdquo;RiskBite&rdquo;)</p>
<p>&nbsp;</p>
<p>Informacja jest przekazywana na postawie art. 14 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 roku w sprawie ochrony os&oacute;b fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 94/46/WE (dalej w skr&oacute;cie: &bdquo;<strong>RODO</strong>&rdquo;).</p>
<p><strong>&nbsp;</strong></p>
<table width="845">
<tbody>
<tr>
<td width="160">
<p><strong>ADMINISTRATOR DANYCH OSOBOWYCH&nbsp;&nbsp; I DANE KONTAKTOWE</strong></p>
</td>
<td width="440">
<p>Administratorem danych osobowych jest RiskBite&nbsp;Sp. z o.o. z siedzibą w Warszawie (02-672) przy ul. Domaniewskiej 39A, wpisanej do Rejestru Przedsiębiorc&oacute;w Krajowego Rejestru Sądowego, prowadzonego przez Sąd Rejonowy dla m.st. Warszawy w Warszawie, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS: 0000795549, NIP 5213871595, REGON 383911905, RIP: RIP000616.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>Dane kontaktowe RiskBite &nbsp;</p>
<p>&nbsp;</p>
<p>We wszystkich sprawach związanych z ochroną danych osobowych, w tym dotyczących realizacji praw związanych z przetwarzaniem danych można kontaktować się poprzez adres e-mail iod@riskbite.com lub pisemnie na adres: ul. Domaniewska 39A, 02-672 Warszawa.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>CELE I PODSTAWA PRAWNA PRZETWARZANIA DANYCH OSOBOWYCH</strong></p>
</td>
<td width="440">
<p>Pani/Pana dane osobowe będą przetwarzane przez RiskBite w celach następujących:</p>
<p>&nbsp;</p>
<p>a)&nbsp;&nbsp;&nbsp; w celu oceny zdolności kredytowej i ryzyka kredytowego, w tym z wykorzystaniem profilowania &ndash; na podstawie art. 6 ust. 1 lit. a) RODO oraz ustawy z dnia 12 maja 2011 roku o kredycie konsumenckim (tj. Dz.U. z 2019 r. poz. 1083);</p>
<p>&nbsp;</p>
<p>b)&nbsp;&nbsp;&nbsp; w celu przeprowadzenia wewnętrznych analiz, cyklicznego i bieżącego wzbogacania danych, budowy modeli i poprawy procesu oceny zdolności kredytowej, &ndash; na podstawie art. 6 ust. 1 lit. a) RODO;</p>
<p>&nbsp;</p>
<p>c)&nbsp;&nbsp;&nbsp;&nbsp; w celu wykonania obowiązk&oacute;w prawnych, w tym obowiązku identyfikacyjnego wynikającego z ustawy z dnia z dnia 1 marca 2018 r. o przeciwdziałaniu praniu pieniędzy oraz finansowaniu terroryzmu (tj. Dz.U. z 2020 r. poz. 971 z p&oacute;źń. zm.), obowiązku rozpatrzenia reklamacji wynikającego z ustawy z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego i o Rzeczniku Finansowym (tj. Dz.U. z 2019 r. poz. 2279) &ndash; na podstawie art. 6 ust. 1 lit. c) RODO;</p>
<p>&nbsp;</p>
<p>d)&nbsp;&nbsp;&nbsp; w celu rozpatrywania reklamacji, ochrony przed roszczeniami przez RiskBite na podstawie art. 6 ust. 1 lit. f) RODO;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>e)&nbsp;&nbsp;&nbsp; rozliczalności w zakresie przetwarzania danych osobowych na podstawie art. 6 ust. 1 lit. c) RODO.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>ŹR&Oacute;DŁO DANYCH OSOBOWYCH</strong></p>
</td>
<td width="440">
<p>RiskBite pozyskuje Pani/Pana dane osobowe bezpośredni od Pana Pani lub od instytucji finansowej, u kt&oacute;rej ubiega się Pan / Pani o udzielnie produktu finansowego.</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>RODZAJ DANYCH</strong></p>
</td>
<td width="440">
<p>Pani/Pana dane osobowe są przetwarzane w zakresie:</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pani/Pana dane identyfikacyjne: numer PESEL, seria i numer dowodu osobistego, stan cywilny oraz wykształcenie, obywatelstwo i kraj urodzenia;</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pani/Pana dane kontaktowe: adres zamieszkania, adres zameldowania, numer telefonu kom&oacute;rkowego oraz adres poczty elektronicznej;</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; informacje dotyczące dochodu - źr&oacute;dło dochodu, zaw&oacute;d wykonywany, dzień otrzymywania wynagrodzenia oraz miesięczną kwotę dochodu;</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pani/Pana wydatki: miesięczne kwoty rat kredyt&oacute;w i pożyczek oraz miesięczne wydatki poza kredytowe oraz obciążenia finansowe;</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; dane Pani/Pana pracodawcy: nazwę i adres pracodawcy, numer telefonu kontaktowego do pracodawcy, branża, w kt&oacute;rej działa pracodawca oraz okres zatrudnienia u danego pracodawcy;</p>
<p>&middot;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; inne informacje dotyczące Pani/Pana w tym, status mieszkaniowy, numer rachunku bankowego, liczba os&oacute;b w gospodarstwie domowym, informacja czy jest Pani/ Pan właścicielem samochodu;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>ODBIORCY DANYCH</strong></p>
</td>
<td width="440">
<p>Pani/Pana dane osobowe mogą być udostępniane podmiotom uprawnionym do ich otrzymania na podstawie Pani/Pana zgody w celu oceny zdolności kredytowej i analizy ryzyka kredytowego.</p>
<p>&nbsp;</p>
<p>RiskBite może r&oacute;wnież przekazywać dane osobowe podmiotom, kt&oacute;re przetwarzają te dane na jej zlecenie np. dostawcom usług IT, kancelariom prawnym, podmiotom świadczącym usługi księgowe, kadrowo-płacone, podatkowe, audytorskie, partnerom świadczących usługi wsparcia przy składaniu wniosku kredytowego, podejmowaniu decyzji o udzieleniu kredytu, pozyskiwaniu danych od podmiot&oacute;w trzecich (takich jak biura informacji gospodarczych, Biuro Informacji Kredytowej S.A. oraz podmioty należące do Platformy Wymiany Informacji Pożyczkowej).</p>
<p>&nbsp;</p>
<p>Wskazane podmioty przetwarzają dane osobowe z zachowaniem wszelkich wymog&oacute;w i standard&oacute;w ochrony danych osobowych.</p>
<p>Dane mogą być r&oacute;wnież przekazywane stosownym władzom i organom w zakresie i w sytuacjach określonych w przepisach prawa np. Prezes Urzędu Ochrony Danych Osobowych, prokuratura, policja.</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>PRZEKAZANIE DANYCH DO PAŃSTWA TRZECIEGO LUB ORGANIZACJI MIĘDZYNARODOWEJ</strong></p>
</td>
<td width="440">
<p>Pani/Pana dane osobowe nie będą przekazywane do państwa trzeciego lub organizacji międzynarodowej.</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>AUTOMATYCZNE PODEJMOWANIE DECYZJI W TYM PROFILOWANIE</strong></p>
</td>
<td width="440">
<p>Pani/Pana dane będą przetwarzane w spos&oacute;b zautomatyzowany, r&oacute;wnież w formie profilowania, polegającego na zautomatyzowanym podejmowaniu decyzji odnośnie zdolności kredytowej w oparciu o informacje przekazane przez Panią/Pana oraz o informacje pozyskane ze zbior&oacute;w danych.</p>
<p>&nbsp;</p>
<p>Wynik profilowania ma znaczenie dla decyzji w przedmiocie zawarcia umowy o udzielenie produktu finansowego, z zastrzeżeniem, że w każdym przypadku, to jest zar&oacute;wno w przypadku wydania pozytywnej decyzji kredytowej.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>Pani/Pana dane mogą dane być r&oacute;wnież przetwarzane w spos&oacute;b zautomatyzowany, w tym w formie profilowania w celu dokonania oceny ryzyka prania pieniędzy i finansowania terroryzmu. Dokonanie oceny może skutkować automatycznym zakwalifikowaniem do grupy ryzyka, w tym do grupy nieakceptowalnego ryzyka zagrożonej automatyczną blokadą i nienawiązaniem relacji gospodarczej albo niewykonaniem transakcji.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>OKRES PRZECHOWYWANIA DANYCH OSOBOWYCH</strong></p>
</td>
<td width="440">
<p>Pani/Pana dane osobowe będą przetwarzane:</p>
<p>&nbsp;</p>
<p>a)&nbsp;&nbsp;&nbsp; dla cel&oacute;w dokonywania oceny zdolności kredytowej i analizy ryzyka kredytowego, w tym profilowania &ndash; przez okres trwania Pani/Pana zobowiązania, a jeśli wynikiem oceny jest podjęcie decyzji o nie przyznaniu kredytu konsumenckiego &ndash; przez okres 3 lat od zebrania danych;</p>
<p>&nbsp;</p>
<p>b)&nbsp;&nbsp;&nbsp; dla cel&oacute;w stosowania środk&oacute;w bezpieczeństwa finansowego &ndash; przez okres 5 lat, licząc od dnia, w kt&oacute;rym zakończono stosunki gospodarcze z Panią/Panem lub w kt&oacute;rym przeprowadzono transakcje okazjonalne;</p>
<p>&nbsp;</p>
<p>c)&nbsp;&nbsp;&nbsp;&nbsp; dla cel&oacute;w prowadzenia obligatoryjnej sprawozdawczości finansowej, dane osobowe są przechowywane przez okres 5 lat liczonych od zakończenia roku obrachunkowego;</p>
<p>&nbsp;</p>
<p>d)&nbsp;&nbsp;&nbsp; dla cel&oacute;w rozpatrywania Pani/Pana reklamacji, obrony przed zgłoszonymi przez Panią/Pana roszczeniami, jakie mogą wyniknąć z zawartej umowy o kredyt konsumencki lub w zakresie przetwarzania Pani/Pana danych osobowych &ndash; do momentu przedawnienia Pani/Pana potencjalnych roszczeń względem RiskBite;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>e)&nbsp;&nbsp;&nbsp; do cel&oacute;w związanych z prowadzeniem postępowań sądowych &ndash; dane mogą być przetwarzane do 6 lat od dnia wydania prawomocnego orzeczenia kończącego postepowanie;</p>
<p>&nbsp;</p>
<p>f)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; dla cel&oacute;w wewnętrznych analiz, budowy modeli i poprawy procesu oceny zdolności kredytowej &ndash;przez okres wyrażenia zgody, nie dłużej niż przez 3 lata od dnia udostępnienia danych;</p>
<p>&nbsp;</p>
<p>g)&nbsp;&nbsp;&nbsp; dla cel&oacute;w archiwalnych - po wygaśnięciu danej relacji prawnej (czyli np. umowy) dane osobowe dotyczące są przetwarzane przez 6 lat, chyba że przepisy prawa przewidują kr&oacute;tszy okres.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>PRAWA PRZYSŁUGUJĄCE W ZWIĄZKU Z PRZETWARZANIEM DANYCH</strong></p>
</td>
<td width="440">
<p>Przysługuje Pani/Panu prawo dostępu do danych oraz prawo żądania ich sprostowania, jeżeli są nieprawidłowe, ich usunięcia lub ograniczenia ich przetwarzania.&nbsp;</p>
<p>&nbsp;</p>
<p>W&nbsp;zakresie, w jakim podstawą przetwarzania danych osobowych jest przesłanka prawnie uzasadnionego interesu administratora, przysługuje Pani/Panu prawo wniesienia sprzeciwu wobec przetwarzania danych osobowych.</p>
<p>&nbsp;</p>
<p>W zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest zgoda, ma Pani/Pan prawo wycofania zgody w każdym czasie. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania, kt&oacute;rego dokonano na podstawie zgody przed jej wycofaniem.</p>
<p>&nbsp;</p>
<p>Jeśli wyraziła/wyraził Pani/Pan zgodę na przesyłanie informacji handlowej drogą elektroniczną, przysługuje prawo cofnięcia wyrażonej zgody, na przykład poprzez wysłanie wiadomości e-mail na adres: zgody@riskbite.com.</p>
<p>&nbsp;</p>
<p>W zakresie, w jakim podstawą przetwarzania Pani/Pana danych osobowych jest art. 6 ust. 1 lit. a) lub art. 6 ust. 1 lit. b) RODO, a przetwarzanie odbywa się w spos&oacute;b zautomatyzowany, Przysługuje Pani/Panu także prawo do otrzymania od RiskBite danych osobowych, w&nbsp;ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego, może Pani/Pan r&oacute;wnież przesłać te dane innemu administratorowi danych. Może Pani/Pan r&oacute;wnież żądać, by przetwarzane w ten spos&oacute;b dane osobowe zostały prze&shy;słane przez RiskBite bezpośrednio innemu administratorowi, o ile jest to technicznie możliwe. Uprawnienie do przenoszenia danych nie dotyczy danych, kt&oacute;re stanowią tajemnicę przedsiębiorstwa, nie może niekorzystnie wpływać na prawa i wolności innych.</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>PRAWO WNIESIENIA SKARGI DO ORGANU NADZORCZEGO</strong></p>
</td>
<td width="440">
<p>Przysługuje Pani/Panu r&oacute;wnież prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych, jakim jest Prezes Urzędu Ochrony Danych Osobowych.</p>
</td>
</tr>
<tr>
<td width="160">
<p><strong>INFORMACJA O DOBROWOLNOŚCI LUB OBOWIĄZKU PODANIA DANYCH OSOBOWYCH</strong></p>
</td>
<td width="440">
<p>Podanie danych ma charakter dobrowolny.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>`;


const CONSENT_COOKIES = `<p style="text-align:center;">
<strong>Polityka Prywatności i Pliki Cookies</strong>
</p>
<p style="text-align:justify;">&nbsp;</p>
<p style="text-align:justify;">
<strong>1. Zakres Polityki</strong>
</p>
<p style="text-align:justify;">Przykładamy dużą wagę do ochrony Twojej prywatności. Zapewniamy, że traktujemy Twoje dane ze starannością i uwzględnieniem zobowiązań wynikających z obowiązujących przepisów dotyczących ochrony danych osobowych.</p>
<p style="text-align:justify;">Niniejsza polityka opisuje zakres oraz rodzaje danych jakie Minicredit Sp. z o.o. może od Ciebie zbierać lub jakie możesz przekazywać nam oraz zasady ich ochrony, ujawniania, przetwarzania, wykorzystywania i zbierania.</p>
<p style="text-align:justify;">Znajdziesz tu także informacje o uprawnieniach, które Ci przysługują w związku z przetwarzaniem Twoich danych osobowych, w szczególności prawie związanym z dostępem do danych, ich aktualizowania, a także podejmowania pewnych decyzji co do sposobu wykorzystania Twoich informacji.</p>
<p style="text-align:justify;">Niniejsza polityka obejmuje nasze procedury online, jak i offline dotyczące gromadzenia danych, w tym danych, jakie możemy&nbsp; zgromadzić za pośrednictwem naszych różnych kanałów, takich jak strona internetowa, korespondencja email, telefon, korespondencja listowna. Możemy również uzyskiwać dane o Tobie od stron trzecich.</p>
<p style="text-align:justify;">Polityka obowiązuje wszystkich Klientów Minicredit Sp. z o.o., a także wszystkich odwiedzających naszą stronę internetową.</p>
<p style="text-align:justify;">Postanowienia warunków świadczenia poszczególnych usług mogą opisywać w sposób odrębny zasady przetwarzania Twoich danych. Wówczas takie szczegółowe warunki mogą mieć nadrzędny lub uzupełniający charakter względem niniejszej Polityki.</p>
<p style="text-align:justify;">Nasze produkty i usługi mogą zawierać linki do stron internetowych innych spółek i oferowanych przez nie usług. Spółki te mogą mieć własną politykę prywatności, z którą należy się zapoznać. Nie ponosimy odpowiedzialności za praktyki dotyczące prywatności ani za produkty i usługi ww. stron trzecich.</p>
<p style="text-align:justify;">Niezależnie od postanowień niniejszej Polityki, w niektórych sytuacjach możemy wystąpić o Twoją wyraźną i dobrowolną zgodę na przetwarzanie Twoich danych osobowych, jeżeli zgoda taka jest wymagana na mocy prawa.</p>
<p style="text-align:justify;">
<strong>2. Dane osobowe</strong>
</p>
<p style="text-align:justify;">
<strong>2.1 Cel przetwarzania danych i ich wykorzystanie.</strong>
</p>
<p style="text-align:justify;">Twoje dane wykorzystujemy, aby świadczyć nasze usługi na najwyższym poziomie, poprawiać je, udoskonalać produkty oraz usługi, wysyłać powiadomienia, oferty i promocje. Wykorzystujemy je również w celu ochrony naszych praw i interesów oraz praw i interesów stron trzecich, a także do zachowania zgodności z przepisami prawa.</p>
<p style="text-align:justify;">
<strong>Informacje pozyskane od Ciebie wykorzystujemy do:</strong>
</p>
<ul>
<li style="text-align:justify;">Utworzenia Konta Klienta w serwisie minicredit.pl</li>
<li style="text-align:justify;">Zweryfikowania Twojej tożsamości</li>
<li style="text-align:justify;">Dokonania oceny zdolności kredytowej do udzielenia pożyczki oraz zdolności do spłaty pożyczki przed podpisaniem umowy</li>
<li style="text-align:justify;">Zawarcia i wykonania umowy pożyczki</li>
<li style="text-align:justify;">Wysyłania informacji handlowych lub nawiązania kontaktu telefonicznego w celu przedłożenia oferty w ramach marketingu</li>
<li style="text-align:justify;">Ochrony przed roszczeniami</li>
<li style="text-align:justify;">Windykacji należności</li>
<li style="text-align:justify;">Prowadzenia postępowań sądowych, arbitrażowych i mediacyjnych</li>
<li style="text-align:justify;">Wykrywania i zapobiegania oszustwom, praniu pieniędzy, finansowaniu terroryzmu i innej działalności przestępczej</li>
<li style="text-align:justify;">Zapewnienia i doskonalenia jakości usług</li>
<li style="text-align:justify;">Możliwości monitorowania Twojej aktywności w Serwisie</li>
<li style="text-align:justify;">Doskonalenia naszych produktów i usług poprzez identyfikację potrzeb Klientów i rozwijanie nowych rozwiązań</li>
<li style="text-align:justify;">Kontroli jakości rozmów audio , w tym zapewnienia najwyższej jakości obsługi klienta</li>
</ul>
<p style="text-align:justify;">
<strong>2.2 Podstawa przetwarzania danych osobowych.</strong>
</p>
<p style="text-align:justify;">Przede wszystkim Minicredit Sp. z o.o przetwarza Dane Osobowe Użytkowników w celu podjęcia niezbędnych działań przed zawarciem Umowy Pożyczki z Użytkownikiem, a następnie w celu realizacji Umowy Pożyczki, której stroną jest Użytkownik. Przetwarzanie, o którym mowa w niniejszym, jest realizowane na podstawie art. 6 ust. 1 lit. b) RODO.</p>
<p style="text-align:justify;">W związku z wynikającą z przepisów prawa koniecznością dokonywania przez Minicredit Sp. z o.o. oceną zdolności kredytowej Użytkowników. Użytkownik w trakcie wypełniania wniosku o pożyczkę proszony jest o wyrażenie zgody na weryfikację jego zdolności kredytowej w Krajowym Biurze Informacji Gospodarczej S.A.&nbsp;Przetwarzanie, o którym mowa w niniejszym ustępie, jest realizowane na podstawie art. 6 ust. 1 lit. c) RODO.</p>
<p style="text-align:justify;">Użytkownik jest również proszony o wyrażenie zgody na przekazywanie pozytywnych informacji do biur informacji gospodarczej. W tym zakresie Dane Osobowe Użytkownika przetwarzane są na podstawie art. 6 ust. 1 lit. a) RODO. Jednakże, negatywne informacje o Użytkowniku są przez Minicredit Sp. z o.o. przekazywane do biur informacji gospodarczej na podstawie prawnie uzasadnionego interesu Minicredit Sp. z o.o.. Minicredit Sp. z o.o. przetwarza więc Dane Osobowe w tym celu na podstawie art. 6 ust. 1 lit. f) RODO.</p>
<p style="text-align:justify;">W uzasadnionym interesie Minicredit Sp. z o.o. leży przeciwdziałanie ewentualnym wyłudzeniom, dlatego też w celu przeprowadzenia stosownej weryfikacji Użytkowników Minicredit Sp. z o.o. będzie przetwarzać Dane Osobowe Użytkowników w celu dokonania ich analizy oraz przekazywać Dane Osobowe do analizy do biura informacji gospodarczej oraz uczestników Platformy Wymiany Informacji Pożyczkowej w celu dokonania weryfikacji tożsamości Użytkownika Minicredit Sp. z o.o. również przetwarza otrzymane Dane Osobowe od usługodawców usług poczty elektronicznej, z której dany Użytkownik korzysta. Przetwarzanie, o którym mowa, jest realizowane na podstawie art. 6 ust. 1 lit. f) RODO.</p>
<p style="text-align:justify;">W celu weryfikacji tożsamości Użytkowników, Użytkownik, który wypełni wniosek o pożyczkę będzie również proszony o udzielenie odpowiednich zgód umożliwiających tę czynność przetwarzania, dokonywaną za pośrednictwem podmiotów trzecich: Transactionlink Sp. z o.o. Przetwarzanie to jest realizowane na podstawie art. 6 ust. 1 lit. a) RODO.</p>
<p style="text-align:justify;">Uczestnicy Platformy Wymiany Informacji Pożyczkowej wykazani są na stronie internetowej&nbsp;<a href="https://www.credit-check.pl/uczestnicy/">https://www.credit-check.pl/uczestnicy/</a>
</p>
<p style="text-align:justify;">W związku z dokonywaniem oceny zdolności kredytowej przez Uczestników Forum Wiarygodnej Wymiany Informacji (FWWI), Użytkownik, który wypełnia wniosek jest również proszony o udzielenie odpowiednich zgód umożliwiających przeprowadzenie ww. oceny. Przetwarzanie Danych Osobowych dokonywane jest na podstawie art. 6 ust. 1 lit. a) RODO.</p>
<p style="text-align:justify;">Uczestnicy Forum Wiarygodnej Wymiany Informacji wykazani są na stronie internetowej&nbsp;<a href="https://www.credit-check.pl/uczestnicy/">https://www.credit-check.pl/uczestnicy/</a>
</p>
<p style="text-align:justify;">W związku z dokonywaniem oceny zdolności kredytowej przez Minicredit Sp. z o.o. w ramach współpracy z podmiotami współpracującymi w ramach Systemu Wymiany Informacji, Użytkownik, który wypełnia wniosek jest również proszony o udzielenie odpowiednich zgód umożliwiających przeprowadzenie ww. oceny. Przetwarzanie Danych Osobowych dokonywane jest na podstawie art. 6 ust. 1 lit. a) RODO.</p>
<p style="text-align:justify;">Uczestnicy Systemu Wymiany Informacji wykazani są na stronie internetowej&nbsp;<a href="https://www.credit-check.pl/uczestnicy/">https://www.credit-check.pl/uczestnicy/</a>
</p>
<p style="text-align:justify;">W przypadku udzielenia zgody przez Użytkownika na skorzystanie z usług pośrednictwa kredytowego świadczonych przez Minicredit Sp. z o.o., Dane Osobowe Użytkownika będą przetwarzane przez Minicredit Sp. z o.o. w celu wykonania tych usług. Przetwarzanie to jest realizowane na podstawie art. 6 ust. 1 lit. b) RODO.</p>
<p style="text-align:justify;">W związku z wymogami ustawy o świadczeniu usług drogą elektroniczną oraz ustawy prawo telekomunikacyjne oraz gdy Użytkownik udzieli zgodę, na adres e-mail lub numer telefonu podane przez Użytkownika lub pozyskane za zgodą Użytkownika z innych źródeł, mogą być wysyłane informacje handlowe lub nawiązywany kontakt telefoniczny w celu przedłożenia oferty dla Użytkownika, względem działań podejmowanych przez Minicredit Sp. z o.o. w ramach jej marketingu bezpośredniego, również z wykorzystaniem automatycznych systemów wywołujących i telekomunikacyjnych urządzeń końcowych (jak w szczególności telefon, serwer, komputer). W zakresie prowadzenia marketingu bezpośredniego komunikacja może być również kierowana za pośrednictwem listu. W celu, o którym mowa w niniejszym ustępie, dane będą przetwarzane przez Minicredit Sp. z o.o. na podstawie art. 6 ust. 1 lit. f) RODO.</p>
<p style="text-align:justify;">Minicredit Sp. z o.o. będzie dokonywała przetwarzania pozyskanych Danych Osobowych od osób trzecich wyłącznie w celach udzielenia finansowania, potencjalnej windykacji i celach marketingowych względem Użytkowników Strony.</p>
<p style="text-align:justify;">W przypadku udzielenia zgody przez Użytkownika, Dane Osobowe Użytkownika mogą służyć do tworzenia jego profilu na podstawie dotychczasowej historii: jego aktywności w Serwisie, oceny zdolności kredytowej oraz korzystania przez Użytkownika z usług oferowanych przez Minicredit Sp. z o.o., a profil ten będzie wykorzystywany do analiz i przygotowania oferty produktowej. W celu, o którym mowa w niniejszym ustępie, dane te będą przetwarzane przez Minicredit Sp. z o.o. na podstawie art. 6 ust. 1 lit. a) RODO. Ponadto Minicredit Sp. z o.o. podejmuje decyzje w sposób zautomatyzowany w zakresie oceny zdolności kredytowej i przeciwdziałania wyłudzeniom. Analiza ta jest elementem weryfikacji złożonego wniosku o pożyczkę i ma wpływ na decyzję kredytową podejmowaną przez Minicredit Sp. z o.o.</p>
<p style="text-align:justify;">Dane Osobowe Użytkownika w zakresie jego aktywności w Serwisie mogą być monitorowane. W tym zakresie przetwarzanie będzie odbywać się na podstawie art. 6 ust. 1 lit. f) RODO.</p>
<p style="text-align:justify;">W przypadku udzielenia zgody przez Użytkownika, Dane Osobowe Użytkownika w zakresie imienia, nazwiska, adresu e-mail oraz numeru telefonu, mogą być udostępniane instytucjom pożyczkowym w rozumieniu ustawy o kredycie konsumenckim oraz bankom w rozumieniu ustawy Prawo bankowe jak i partnerom biznesowym współpracującym z Minicredit Sp. z o.o. w celu przedstawiania Użytkownikowi przez te podmioty informacji marketingowych lub handlowych na podany w formularzu zgłoszeniowym adres e-mail lub numer telefonu, w tym informacji wysyłanych za pośrednictwem telekomunikacyjnych urządzeń końcowych (np. komputer, serwer, telefon) oraz automatycznych systemów wywołujących dla celów marketingu bezpośredniego. W celu, o którym mowa w niniejszym ustępie, dane te będą przetwarzane przez Minicredit Sp. z o.o. na podstawie art. 6 ust. 1 lit. a) RODO.</p>
<p style="text-align:justify;">Minicredit Sp. z o.o. przetwarzać będzie również Dane Osobowe, w celu wykonania obowiązków prawnych, w tym w szczególności, wykonania zobowiązań wynikających z ustawy o rachunkowości oraz ustawy o przeciwdziałaniu praniu pieniędzy oraz finansowaniu terroryzmu. W celu, o którym mowa w niniejszym akapicie, dane te będą przetwarzane przez Minicredit Sp. z o.o. na podstawie art. 6 ust. 1 lit. c) RODO.</p>
<p style="text-align:justify;">
<strong>3. Uprawnienia Użytkowników dotyczące ich Danych Osobowych.</strong>
</p>
<p style="text-align:justify;">
<strong>3.1 Użytkownikowi przysługują następujące uprawnienia:</strong>
</p>
<p style="text-align:justify;">
<i>
<strong>prawo dostępu do treści danych</strong>
</i>&nbsp;- czyli prawo zwrócenia się do Minicredit Sp. z o.o. z zapytaniem, czy przetwarzamy Dane Osobowe Użytkownika, a także zażądanie informacji m.in. na temat celów przetwarzania Danych Osobowych oraz osób trzecich, którym Minicredit Sp. z o.o. przekazuje Dane Osobowe Użytkownika. Aby uzyskać dostęp do przechowywanych przez Minicredit Sp. z o.o. informacji, skontaktuj się z nami, korzystając z danych kontaktowych zamieszczonych w zakładce „Kontakt” na naszej Stronie.</p>
<p style="text-align:justify;">
<i>
<strong>prawo żądania sprostowania, ograniczenia lub usunięcia danych</strong>
</i>&nbsp;- Użytkownik posiadający u nas konto, może żądać sprostowania i aktualizacji nieprawidłowych lub niekompletnych Danych Osobowych. Użytkownik może również żądać usunięcia Danych Osobowych, jeżeli:</p>
<ol>
<li style="text-align:justify;">nie są one niezbędne do celów, dla których były zbierane i przetwarzane,</li>
<li style="text-align:justify;">została cofnięta zgoda na ich przetwarzanie,</li>
<li style="text-align:justify;">są przetwarzane niezgodnie z prawem, bądź</li>
<li style="text-align:justify;">konieczne jest ich usuniecie w celu wywiązania się z obowiązku prawnego. Ograniczenia przetwarzania Danych Osobowych Użytkownik może żądać, jeśli:</li>
</ol>
<ul style="list-style-type:disc;">
<li style="text-align:justify;">kwestionuje ich prawidłowość,</li>
<li style="text-align:justify;">kwestionuje zgodność ich przetwarzania z prawem,</li>
<li style="text-align:justify;">kwestionuje istnienie celu i potrzeby ich przetwarzania bądź</li>
<li style="text-align:justify;">wniósł sprzeciw względem ich przetwarzania.</li>
</ul>
<p style="text-align:justify;">W celu przekazania dyspozycji w zakresie aktualizacji Danych Osobowych, ograniczenia ich przetwarzania lub ich usunięcia, skontaktuj się z nami, korzystając z danych kontaktowych zamieszczonych w zakładce „Kontakt” na naszej Stronie;</p>
<p style="text-align:justify;">
<i>
<strong>prawo wniesienia sprzeciwu</strong>
</i>&nbsp;- Użytkownik ma prawo wnieść sprzeciw do Minicredit Sp. z o.o. w zakresie, w jakim podstawą przetwarzania Danych Osobowych jest przesłanka prawnie uzasadnionego interesu Minicredit Sp. z o.o., w tym profilowania (np. przesyłania spersonalizowanych ofert). Użytkownik ma również prawo sprzeciwić się wszelkim wynikom przetwarzania danych, które naruszają jego prawa i które są prowadzone wyłącznie za pomocą zautomatyzowanych systemów. W celu wniesienia sprzeciwu skontaktuj się z nami, korzystając z danych kontaktowych zamieszczonych w zakładce „Kontakt” na naszej Stronie;</p>
<p style="text-align:justify;">
<i>
<strong>prawo wycofania zgody</strong>
</i>&nbsp;- w zakresie, w jakim podstawą przetwarzania Danych Osobowych jest zgoda Użytkownika, Użytkownik ma prawo jej wycofania w dowolnym czasie. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. W celu wycofania zgody skontaktuj się z nami, korzystając z danych kontaktowych zamieszczonych w zakładce „Kontakt” na naszej Stronie;</p>
<p style="text-align:justify;">
<i>
<strong>prawo do przenoszenia danych</strong>
</i>&nbsp;- w zakresie, w jakim Dane Osobowe Użytkownika są przetwarzane w celu zawarcia i wykonywania umowy lub przetwarzane na podstawie zgody Użytkownika, Użytkownikowi przysługuje prawo do przenoszenia Danych Osobowych, tj. do otrzymania od Minicredit Sp. z o.o. Danych Osobowych, w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego. Na żądanie Użytkownika dane te mogą zostać przesłane innemu administratorowi danych. Uprawnienie do przenoszenia danych nie dotyczy danych, które stanowią tajemnicę przedsiębiorstwa. W celu skorzystania z prawa przenoszenia Danych Osobowych, skontaktuj się z nami, korzystając z danych kontaktowych zamieszczonych w zakładce „Kontakt” na naszej Stronie.</p>
<p style="text-align:justify;">
<i>
<strong>prawo wniesienia skargi do organu nadzorczego</strong>
</i>&nbsp;- Użytkownikowi przysługuje również prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną Danych Osobowych.</p>
<p style="text-align:justify;">Żądania w zakresie danych osobowych składane drogą mailową będą rozpatrywane, jeżeli zostaną skierowane z adresu email przypisanego do profilu Użytkownika, co stanowi środek bezpieczeństwa stosowany przez Minicredit Sp. z o.o.</p>
<p style="text-align:justify;">
<strong>4. Odbiorcy danych, komu przekazujemy dane osobowe.</strong>
</p>
<p style="text-align:justify;">
<strong>4.1 </strong>Dane Osobowe Użytkowników mogą być udostępniane następującym kategoriom odbiorców danych: podmiotom wchodzącym w skład grupy kapitałowej Minicredit Sp. z o.o., podmiotom świadczącym usługi związane z weryfikacją tożsamości i oceną zdolności kredytowej, biurom informacji gospodarczej, podmiotom świadczącym usługi operatora płatności internetowych, podmiotom świadczącym usługi bankowe, podmiotom świadczącym usługi doradcze, prawne, windykacyjne, marketingowe, analityczne, dostawcom usług pocztowych i kurierskich oraz dostawcom usług technologicznych i informatycznych działającym na rzecz Minicredit Sp. z o.o.</p>
<p style="text-align:justify;">
<strong>4.2 </strong>Dane Osobowe Użytkowników mogą być udostępniane podmiotom uprawnionym do ich żądania na mocy przepisów prawa, w tym w szczególności organom wymiaru sprawiedliwości lub Prezesowi Urzędu Ochrony Danych Osobowych.</p>
<p style="text-align:justify;">
<strong>5. Sposób zabezpieczenia Danych Osobowych.</strong>
</p>
<p style="text-align:justify;">Minicredit Sp. o.o. stosuje odpowiednie środki techniczne i organizacyjne niezbędne do zapewnienia poufności, integralności, rozliczalności i adekwatności danych, a także do zabezpieczenia danych przed nieuprawnionym wykorzystaniem lub przetworzeniem. Minicredit Sp. z o.o. stosuje również środki organizacyjne i techniczne zapobiegające pozyskiwaniu i modyfikowaniu przez osoby nieuprawnione Danych Osobowych podanych przez Użytkownika w Serwisie, a przede wszystkim szyfrowane połączenie SSL.</p>
<p style="text-align:justify;">Minicredit Sp. z o.o. wdrożył i utrzymuje system ochrony Danych Osobowych, mający na celu zapewnienie najwyższych standardów ochrony Danych Osobowych Użytkowników.</p>
<p style="text-align:justify;">
<strong>6. Czy przekazujemy Dane Osobowe poza Europejski Obszar Gospodarczy (EOG)?</strong>
</p>
<p style="text-align:justify;">Minicredit Sp. z o.o. nie przekazuje danych do Państw trzecich spoza EOG.</p>
<p style="text-align:justify;">
<strong>7. Pliki Cookies.</strong>
</p>
<p style="text-align:justify;">Minicredit Sp. z o.o prowadząc swoją działalność szanuje Twoją prywatność i dokładamy wszelkich starań w celu zagwarantowania Twych praw do zgodnego z prawem przetwarzania i ochrony Twych danych osobowych. Poniżej wyjaśniamy, jak korzystamy z plików cookie i innych technologii na naszej stronie internetowej.</p>
<p style="text-align:justify;">
<strong>7.1 Korzystanie z plików cookie</strong>
</p>
<p style="text-align:justify;">Wiele stron internetowych, w tym również i nasza zapisują na Twoim komputerze, a dokładniej w schowku konkretnej przeglądarki (Firefox, Internet Explorer, Chrome i inne) na Twoim koncie użytkownika komputera lub telefonu, z którego łączysz się z siecią, tzw. pliki cookie.</p>
<p style="text-align:justify;">Zazwyczaj pliki cookie są bardzo pożyteczne. Dzięki nim zapamiętywane są Twoje indywidualne ustawienia i dzięki nim możesz łatwo się zalogować do swojego konta.</p>
<p style="text-align:justify;">Autorzy stron internetowych wiedzą dzięki nim, jak wielu użytkowników do nich zagląda i co konkretnie czytają, a co obchodzą z daleka. Informacje zbierane przy użyciu plików cookie mogą też służyć do zbierania informacji o Tobie w celach handlowych. Np. jeżeli często wchodzisz na strony o pożyczkach, będzie wyświetlane Tobie więcej reklam firm pożyczkowych.</p>
<p style="text-align:justify;">Pliki cookie stosowane na naszej stronie internetowej nie przechowują danych pozwalających na bezpośrednią identyfikację. Dane uzyskane w ten sposób nie będą przesyłane stronom trzecim, poza wyjątkami wskazanymi w naszej Polityce.</p>
<p style="text-align:justify;">Żadne szczegółowe dane osobowe umożliwiające Twoją identyfikację nie będą przez nas udostępniane.</p>
<p style="text-align:justify;">
<strong>7.2 Cele stosowania plików cookies:</strong>
</p>
<ul style="list-style-type:disc;">
<li style="text-align:justify;">stosujemy pliki cookie w celu Twojej ochrony i zapobiegnięcia oszustwom;</li>
<li style="text-align:justify;">stosujemy pliki cookie w naszym formularzu rejestracyjnym i wniosku o pożyczkę on-line;</li>
<li style="text-align:justify;">stosujemy pliki cookie, aby dowiedzieć się, ilu użytkowników odwiedza naszą stronę internetową i zbadać w jaki sposób to robią – takie działanie pomaga nam poprawić jakość świadczonych usług, np. Google Analytics. Google Analytics stosuje pliki cookie do analizy ilości użytkowników odwiedzających naszą stronę internetową;</li>
<li style="text-align:justify;">wykorzystujemy pliki cookie do monitorowania i zarządzania przepływem danych na naszej stronie internetowej;</li>
<li style="text-align:justify;">wykorzystujemy pliki cookie w naszych kampaniach reklamowych. Pliki cookie pomagają nam poprawiać naszą stronę internetową oraz uatrakcyjnić naszą ofertę;</li>
</ul>
<p style="text-align:justify;">
<strong>7.3 Wykorzystujemy dwa rodzaje plików cookie:</strong>
</p>
<ul style="list-style-type:disc;">
<li style="text-align:justify;">
<strong>cookies sesyjne</strong>
</li>
</ul>
<p style="text-align:justify;">Są to tymczasowe pliki cookie aktywne tylko wtedy, gdy wchodzisz na stronę internetową (lub dokładniej, do czasu, aż nie opuścisz strony internetowej i nie zamkniesz przeglądarki). Powyższe pliki pozwalają na zapamiętanie stronie internetowej Twoich działań na poprzedniej stronie, eliminując konieczność ponownego wprowadzania informacji.</p>
<ul style="list-style-type:disc;">
<li style="text-align:justify;">
<strong>cookies trwałe</strong>
</li>
</ul>
<p style="text-align:justify;">
<strong>7.4 Zgoda na korzystanie z plików cookie</strong>
</p>
<p style="text-align:justify;">Trwałe pliki cookie pozostają na Twoim komputerze po opuszczeniu strony internetowej. Pomagają one w Twojej identyfikacji jako unikalnego gościa (zachowanie informacji w postaci losowo wygenerowanego numeru). Długość pozostania plików cookie na Twoim komputerze uzależniona jest od rodzaju takich plików.</p>
<p style="text-align:justify;">Zanim rozpoczniesz korzystać z naszej strony internetowej musimy otrzymać Twoją zgodę na korzystanie z plików cookie. Nasza strona zawiera wyskakujące okno informujące o korzystaniu z plików cookie i prośbę o zaakceptowanie ich wykorzystania poprzez kliknięcie słowa „AKCEPTUJĘ”. Jeśli nie wyrazisz zgody na korzystanie z plików cookie, ale w dalszym ciągu korzystasz ze strony internetowej, uznajemy to za Twoją zgodę na wykorzystywanie plików cookie.</p>
<p style="text-align:justify;">
<strong>7.5 Śledzenie</strong>
</p>
<p style="text-align:justify;">Niektóre informacje na Twój temat są gromadzone przez nas automatycznie. Gromadzimy je w celu ogólnego analizowania trendów i administrowania naszą stroną internetową, produktami i usługami.</p>
<p style="text-align:justify;">Śledząc strony internetowe odwiedzane przez Ciebie, nie gromadzimy danych osobowych o działaniach on-line przeprowadzanych przez Ciebie w danej chwili na stronach internetowych stron trzecich lub korzystanych przez Ciebie usługach on-line. Nie przetwarzamy ani nie współpracujemy z żadną przeglądarką internetową wykorzystującą sygnał “nie śledź” lub inne mechanizmy dające konsumentom prawo wyboru w zakresie gromadzenia informacji umożliwiających ujawnienie tożsamości dotyczących aktywności on-line w czasie i na stronach internetowych stron trzecich. Nie dajemy umocowania również stronom trzecim do gromadzenia informacji o Twoim zachowaniu na naszej stronie internetowej, które umożliwiałoby ujawnienie tożsamości dotyczących aktywności on-line pomiędzy innymi stronami internetowymi w czasie, gdy korzystasz z naszej strony internetowej.</p>
<p style="text-align:justify;">Natomiast współpracujemy ze stronami trzecimi w zakresie wyświetlania informacji na naszej stronie internetowej lub zarządzania naszymi reklamami na innych stronach internetowych. Nasz kontrahent może stosować pliki cookie lub podobne technologie w celu wyświetlania reklam opartych o Twoją aktywność w sieci i zainteresowania.</p>
<p style="text-align:justify;">
<strong>7.6 Usuwanie plików cookie</strong>
</p>
<p style="text-align:justify;">Jeżeli uważasz, że obecność plików cookie narusza Twoją prywatność, możesz w każdej chwili je wyłączyć albo dla konkretnej witryny albo w ogóle dla wszystkich połączeń z Twojej przeglądarki.</p>
<p style="text-align:justify;">Przykłady:</p>
<p style="text-align:justify;">Mozilla Firefox - W menu "Narzędzia" wybierz "Opcje" i w nich zakładkę "Prywatność". Przeglądarka daje możliwość zaznaczenia, że nie chcesz być śledzony w ogóle albo usunięcia pojedynczych ciasteczek poszczególnych witryn.</p>
<p style="text-align:justify;">Microsoft Internet Explorer - W menu "Narzędzia" wybierz "Opcje internetowe" i w nich zakładkę "Prywatność". Specjalnym suwakiem możesz regulować ogólny poziom prywatności albo przyciskiem "Witryny" zarządzać ustawieniami poszczególnych serwisów internetowych.</p>
<p style="text-align:justify;">Google Chrome - W menu ukrytym pod trzema poziomymi kreseczkami w prawym górnym rogu przeglądarki wybierz "Narzędzia" a potem "Wyczyść dane przeglądania...". Oprócz możliwości czyszczenia plików cookie, znajduje się tam link "Więcej informacji", który prowadzi do szczegółowego opisu funkcji prywatności przeglądarki.</p>
<p style="text-align:justify;">Opera - Przyciskiem "Opera" w lewym górnym rogu otwórz menu i wybierz w nim "Ustawienia" i dalej "Wyczyść historię przeglądania...". Oprócz możliwości skasowania już ustawionych plików cookie, jest tam też przycisk "Zarządzaj ciasteczkami..." prowadzący do bardziej zaawansowanych opcji dla poszczególnych witryn.</p>
<p style="text-align:justify;">Apple Safari - W menu "Safari" wybierz "Preferencje" i w nich zakładkę "Prywatność". Znajdziesz w niej liczne opcje dotyczące plików cookie. W telefonach komórkowych, tabletach i innych urządzeniach mobilnych każdy model telefonu może tę funkcję obsługiwać w inny sposób. Dlatego zachęcamy Cię do zapoznania się z opcjami prywatności w dokumentacji na stronie internetowej producenta Twojego urządzenia mobilnego.</p>
<p style="text-align:justify;">&nbsp;</p>
`;




const CONSENT_AGREEMENT = `
<div class=WordSection1>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-top:0cm;
text-align:center;line-height:150%'><b><span style='font-size:20.0pt;
line-height:150%'>UMOWA POŻYCZKI</span></b></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>zawarta pomiędzy:</span></p>

<p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
150%;background:white'><b><span style='font-size:10.0pt;line-height:150%;
color:black'>Minicredit spółka z ograniczoną odpowiedzialnością</span></b><span
style='font-size:10.0pt;line-height:150%;color:black'> z siedzibą w Warszawie
mieszczącą się pod adresem ul. Migdałowa 4, 02-796 Warszawa, wpisaną do
rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
Rejonowy dla m. st. Warszawy w Warszawie, </span><span style='font-size:10.0pt;
line-height:150%;color:black'>XIII</span><span style='font-size:10.0pt;
line-height:150%;color:black'> Wydział Gospodarczy KRS pod numerem KRS 0000371165,
NIP 5252494263, REGON 142694604, RIP000616 o kapitale zakładowym w wysokości 5
225 000,00 zł, zwaną dalej &quot;<b>Pożyczkodawcą</b>&quot;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>a, </span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>{KLIENT.IMIE} {KLIENT.NAZWISKO},</span><span style='font-size:10.0pt;
line-height:150%'> stały adres</span><span style='font-size:10.0pt;line-height:
150%'> zamieszkania: {KLIENT.ADRES_ZAMIESZKANIA}, legitymującym/legitymującą
się dowodem osobistym o serii i numerze {KLIENT.NUMER_DOKUMENTU_TOZSAMOSCI},
PESEL: {KLIENT.PESEL}, adres mailowy: {KLIENT.EMAIL}, zwanym/ą dalej „<b>Pożyczkobiorcą</b>”</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>celem uzgodnienia warunków udzielenia i spłaty kwoty pożyczki, o
następującym brzmieniu:</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§ 1. POŻYCZKA</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%;color:black'>1.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>Pożyczkodawca, </span><span
style='font-size:10.0pt;line-height:150%;color:black'>po uprzednim
przeprowadzeniu pozytywnej oceny zdolności kredytowej Pożyczkobiorcy, na
podstawie zapisów art. 9a ustawy z dnia 12 maja 2011r. o kredycie konsumenckim,
</span><span style='font-size:10.0pt;line-height:150%;color:black'>udziela
Pożyczkobiorcy Pożyczki w kwocie {m%POZYCZKA.KAPITAL} zł.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>1.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca zobowiązuje się do
zapłaty na rzecz Pożyczkodawcy Umownych Odsetek kapitałowych o zmiennej stopie
procentowej, w wysokości zmiennej Rocznej Stopy Oprocentowania, która na dzień
zawarcia Umowy wynosi</span><span style='font-size:10.0pt;line-height:150%'>&nbsp;{POZYCZKA.OPROCENTOWANIE_STOPA}%</span><span
style='font-size:10.0pt;line-height:150%'>, od kwoty Pożyczki, liczonych od Daty
zawarcia Umowy do Dnia Spłaty, które na dzień zawarcia Umowy wynoszą {m%POZYCZKA.OPROCENTOWANIE}
zł.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>1.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W związku z poniesieniem przez
Pożyczkodawcę kosztów przygotowania i </span><span style='font-size:10.0pt;
line-height:150%'>udzielania</span><span style='font-size:10.0pt;line-height:
150%'> Pożyczki, Pożyczkobiorca zobowiązuje się do zapłaty na rzecz
Pożyczkodawcy Prowizji w wysokości </span><span style='font-size:10.0pt;
line-height:150%'>{m%POZYCZKA.OPLATA_POCZATKOWA}</span><span style='font-size:
10.0pt;line-height:150%'> zł</span><span style='font-size:10.0pt;line-height:
150%'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>1.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca zobowiązuje się do
spłaty Pożyczki, powiększonej o kwotę Umownych odsetek kapitałowych o zmiennej
stopie procentowej oraz o kwotę Prowizji</span><span style='font-size:10.0pt;
line-height:150%'>,</span><span style='font-size:10.0pt;line-height:150%'> w
łącznej wysokości </span><span style='font-size:10.0pt;line-height:150%'>{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}</span><span
style='font-size:10.0pt;line-height:150%'> zł w ciągu </span><span
style='font-size:10.0pt;line-height:150%'>{POZYCZKA.LICZBA_DNI}</span><span
style='font-size:10.0pt;line-height:150%'> dni, w terminie do Dnia Spłaty tj.</span><span
style='font-size:10.0pt;line-height:150%'> </span><span style='font-size:10.0pt;
line-height:150%;color:black'>{POZYCZKA.DATA_SPLATY}r</span><span
style='font-size:10.0pt;line-height:150%'>.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>1.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Parametry udzielonej pożyczki</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> przedstawia Tabela nr 1 o nazwie Parametry pożyczki.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;text-align:justify;
line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<div align=center>

<table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0 width="100%"
 style='width:100.0%;border:solid windowtext 1.0pt'>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>1</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>Kwota Pożyczki:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='margin-bottom:0cm;margin-bottom:0cm;
  margin-top:0cm;text-align:right;line-height:150%'><span style='font-size:
  10.0pt;line-height:150%'>{m%POZYCZKA.KAPITAL} </span><span style='font-size:
  10.0pt;line-height:150%'>zł</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>2</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>Okres, na który została udzielona Pożyczka:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='margin-bottom:0cm;margin-bottom:0cm;
  margin-top:0cm;text-align:right;line-height:150%'><span style='font-size:
  10.0pt;line-height:150%'>{POZYCZKA.LICZBA_DNI} </span><span style='font-size:
  10.0pt;line-height:150%'>dni</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>3</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>Dzień spłaty:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='text-align:right'><span
  style='font-size:10.0pt;line-height:107%;color:black'>{POZYCZKA.DATA_SPLATY}r.</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>4</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><a name="_Hlk173852101"><span
  style='font-size:10.0pt;line-height:150%'>Stopa Umownych Odsetek kapitałowych</span></a><span
  style='font-size:10.0pt;line-height:150%'>:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='text-align:right'><span
  style='font-size:10.0pt;line-height:107%;color:black'>{POZYCZKA.OPROCENTOWANIE_STOPA}</span><span
  style='font-size:10.0pt;line-height:107%'>%</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>5</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>Kwota Umownych Odsetek kapitałowych:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='margin-bottom:0cm;margin-bottom:0cm;
  margin-top:0cm;text-align:right;line-height:150%'><span style='font-size:
  10.0pt;line-height:150%'>{m%POZYCZKA.OPROCENTOWANIE} zł</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>6</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>Prowizja:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='margin-bottom:0cm;margin-bottom:0cm;
  margin-top:0cm;text-align:right;line-height:150%'><span style='font-size:
  10.0pt;line-height:150%'>{m%POZYCZKA.OPLATA_POCZATKOWA}</span><span
  style='font-size:10.0pt;line-height:150%'> zł</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>7</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>Całkowity Koszt Pożyczki:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='margin-bottom:0cm;margin-bottom:0cm;
  margin-top:0cm;text-align:right;line-height:150%'><span style='font-size:
  10.0pt;line-height:150%'>{m%POZYCZKA.CALKOWITY_KOSZT_POZYCZKI}
  zł</span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>8</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>Całkowita Kwota do Spłaty:</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='margin-bottom:0cm;margin-bottom:0cm;
  margin-top:0cm;text-align:right;line-height:150%'><span style='font-size:
  10.0pt;line-height:150%'>{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}</span><span
  style='font-size:10.0pt;line-height:150%'> zł</span><span style='font-size:
  10.0pt;line-height:150%;background:yellow'> </span></p>
  </td>
 </tr>
 <tr>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>9</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:
  0cm;text-align:justify;line-height:150%'><span style='font-size:10.0pt;
  line-height:150%'>RRSO (w procentach):</span></p>
  </td>
  <td style='border:solid windowtext 1.0pt;padding:0cm 0cm 0cm 0cm'>
  <p class=MsoNormal align=right style='text-align:right'><span
  style='font-size:10.0pt;line-height:107%;color:black'>{POZYCZKA.RRSO} %</span></p>
  </td>
 </tr>
</table>

</div>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>Tabela</span><span style='font-size:10.0pt;line-height:150%'> nr 1
„Parametry pożyczki”</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:0cm;
margin-top:0cm;text-align:center;line-height:150%'><b><span style='font-size:
10.0pt;line-height:150%'>&nbsp;</span></b></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§ 2. DEFINICJE</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>2.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wyrażeniom użytym w Umowie, <a
name="_Hlk111650020">Regulaminie oraz innych dokumentach, stanowiących
załączniki do Umowy</a>, Strony nadają następujące brzmienie:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Ustawa o kredycie konsumenckim</span></b><span
style='font-size:10.0pt;line-height:150%'> – oznacza ustawę z dnia 12 maja 2011
r. o kredycie konsumenckim (Dz.U. z 2014 poz.1497).</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Osoba fizyczna</span></b><span
style='font-size:10.0pt;line-height:150%'> – konsument w rozumieniu przepisów
ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Użytkownik </span></b><span
style='font-size:10.0pt;line-height:150%'>– osoba fizyczna, która skutecznie
założyła Konto Użytkownika w Systemie teleinformatycznym Pożyczkodawcy.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>System teleinformatyczny</span></b><span
style='font-size:10.0pt;line-height:150%'> – zespół współpracujących ze sobą
urządzeń informatycznych i oprogramowania, zapewniający przetwarzanie i
przechowywanie, a także wysyłanie i odbieranie danych poprzez sieci
telekomunikacyjne za pomocą właściwego dla danego rodzaju sieci urządzenia końcowego
w rozumieniu Ustawy z dnia 16 lipca 2004 r. – Prawo telekomunikacyjne.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Konto Użytkownika </span></b><span
style='font-size:10.0pt;line-height:150%'>– wydzielona przestrzeń w Systemie teleinformatycznym
Pożyczkodawcy, z ograniczonym dostępem, zastrzeżonym dla innych Użytkowników,
do której Użytkownik posiada dostęp za pośrednictwem Strony Internetowej, po
prawidłowej identyfikacji adresu poczty elektronicznej i podaniu prawidłowego
hasła dostępu, umożliwiająca Użytkownikowi składanie Dyspozycji.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.6.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Dyspozycje </span></b><span
style='font-size:10.0pt;line-height:150%'>– oświadczenia woli składane przez
Użytkownika w Systemie Teleinformatycznym Pożyczkodawcy, na wydzielonym koncie
Użytkownika, dokumentowane przez Pożyczkodawcę w formie Logów.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Log </span></b><span
style='font-size:10.0pt;line-height:150%'>– zdarzenie, czynność odnotowana w
rejestrze zdarzeń lub dzienniku zdarzeń, prowadzonych w strukturach Systemu teleinformatycznego
Pożyczkodawcy.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>2.1.8.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%;color:black'>Kontrola Kredytowa </span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>–</span><b><span
style='font-size:10.0pt;line-height:150%;color:black'> </span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>proces oceny </span><span
style='font-size:10.0pt;line-height:150%;color:black'>jakościowej i ilościowej </span><span
style='font-size:10.0pt;line-height:150%;color:black'>zdolności kredytowej
Pożyczkobiorcy, weryfikacja i badanie możliwości spłaty Pożyczki</span><span
style='font-size:10.0pt;line-height:150%;color:black'> zgodnie z zapisami
ustawy z dnia 12 maja 2011r. o kredycie konsumenckim</span><span
style='font-size:10.0pt;line-height:150%;color:black'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>2.1.9.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%;color:black'>Ocena zdolności
kredytowej </span></b><span style='font-size:10.0pt;line-height:150%;
color:black'>–<b> </b>ocena dokonana przez Pożyczkodawcę w zakresie zdolności
do spłaty zaciągniętego kredytu wraz z odsetkami w terminach określonych w
umowie oceniona wedle rygorów objętych zapisami art. 9a ustawy z dnia 12 maja
2011r. o kredycie konsumenckim (Dz. U. z 2022 r. poz. 246, 2339 z późn. zm. –
tekst jednolity), w szczególności poprzez analizę danych udostępnianych przez
zaufanych dostawców gromadzących i przetwarzających dane niezbędne do takiej
oceny wskazanych w ustawie, jak również analizę danych objętych oświadczeniem
konsumenta w zakresie wymagalnych i zapadłych obciążających go zobowiązań,
gdzie zaległość w spłacie innego zobowiązania wynosi powyżej 6 miesięcy oraz
przeznaczenia finansowania udzielonego pożyczką. Pożyczkodawca dokonuje oceny
jakościowej i ilościowej zdolności kredytowej wobec udzielonego umową pożyczki
finansowania.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>2.1.10.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%;color:black'>Oświadczenie konsumenta </span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>–<b> </b>oświadczenie
świadomości i wiedzy konsumenta w zakresie posiadanych na dzień zawarcia umowy
pożyczki zaległych zobowiązań, których zaległości w ich spłacie wynoszą powyżej
6 miesięcy, a kredyt konsumencki nie jest przeznaczony na spłatę uprzednich
zaległości. Pożyczkodawca weryfikuje wskazane w oświadczeniu dane podane przez
konsumenta w toku oceny zdolności kredytowej, jednakże w zakresie oświadczenia
konsumenta związany jest danymi w nim zawartym. Konsument składając
oświadczenie jest w całości świadomy odpowiedzialności za złożenie
nieprawdziwych danych i doprowadzenie Pożyczkodawcy do udzielenia na ich
podstawie finansowania.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>2.1.11.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%;color:black'>Pożyczka</span></b><span
style='font-size:10.0pt;line-height:150%;color:black'> – kwota środków
pieniężnych przekazanych Pożyczkobiorcy przez Pożyczkodawcę na podstawie Umowy
Pożyczki</span><span style='font-size:10.0pt;line-height:150%;color:black'>,
która została udzielona po pozytywnej ocenie zdolności kredytowej
Pożyczkobiorcy</span><span style='font-size:10.0pt;line-height:150%;color:black'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><span class=MsoCommentReference><b><span style='font-size:
9.0pt;line-height:150%;color:black'>2.1.12.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span></b></span><span class=MsoCommentReference><b><span
style='font-size:10.0pt;line-height:150%;color:black'>Pożyczkobiorca</span></b></span><span
class=MsoCommentReference><span style='font-size:10.0pt;line-height:150%;
color:black'> </span></span><span class=MsoCommentReference><span
style='font-size:10.0pt;line-height:150%;color:black'>- osoba fizyczna
składająca Pożyczkodawcy wniosek o pożyczkę, który został zaakceptowany przez
Pożyczkodawcę, po przeprowadzeniu pozytywnej oceny zdolności kredytowej.</span></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>2.1.13.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
class=MsoCommentReference><b><span style='font-size:10.0pt;line-height:150%;
color:black'>Pożyczkodawca</span></b></span><span class=MsoCommentReference><span
style='font-size:10.0pt;line-height:150%;color:black'> – Minicredit spółka z
ograniczoną odpowiedzialnością </span></span><span style='font-size:10.0pt;
line-height:150%'>z siedzibą w Warszawie mieszczącą się pod adresem ul.
Migdałowa 4, 02-796 Warszawa, wpisana do rejestru przedsiębiorców Krajowego
Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st. Warszawy w
Warszawie, </span><span style='font-size:10.0pt;line-height:150%'>XIII</span><span
style='font-size:10.0pt;line-height:150%'> Wydział Gospodarczy KRS pod numerem
KRS 0000371165, NIP 5252494263, REGON 142694604, RIP000616 o kapitale
zakładowym w wysokości 5 225 000,00 zł<span class=MsoCommentReference><span
style='line-height:150%;color:black'>.</span></span></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.14.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Konto Pożyczkobiorcy </span></b><span
style='font-size:10.0pt;line-height:150%'>– indywidualny rachunek bankowy
Pożyczkobiorcy prowadzony w dowolnym banku na terenie Polski, na który
Pożyczkodawca przelewa Pożyczkę.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.15.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Prowizja </span></b><span
style='font-size:10.0pt;line-height:150%'>– oznacza koszt związany z
przygotowaniem oraz udzieleniem Pożyczki, który Pożyczkobiorca zobowiązany jest
uiścić w wysokości podanej w Umowie.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.16.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>RRSO </span></b><span
style='font-size:10.0pt;line-height:150%'>– oznacza Rzeczywistą Roczną Stopę
Oprocentowania, tj. Całkowity Koszt Pożyczki ponoszony przez Pożyczkobiorcę,
wyrażony jako wartość procentowa Pożyczki w stosunku rocznym, obliczona zgodnie
ze wzorem stanowiącym załącznik nr 4 do Ustawy oraz założeniami w nim
przedstawionymi. Podawane RRSO nie uwzględnia ewentualnego rabatu na prowizję
i/lub odsetki.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.17.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>RSO </span></b><span
style='font-size:10.0pt;line-height:150%'>– oznacza Roczną Stopę Oprocentowania
Pożyczki, która jest zmienna w okresie obowiązywania Umowy. Wysokość RSO
określa iloczyn liczby 1 oraz aktualnej stopy ustawowych odsetek maksymalnych
kapitałowych tj. dwukrotnej wysokości ustawowych odsetek kapitałowych (zgodnie
z art. 359 § 2(1) Kodeksu cywilnego). RSO na dzień zawarcia Umowy wynosi 17,50%
w skali roku. Zmiana stopy ustawowych odsetek kapitałowych następuje w
przypadku zmiany stopy referencyjnej Narodowego Banku Polskiego, odpowiednio do
zmiany tej stopy. W przypadku zmiany wysokości stopy ustawowych odsetek
maksymalnych kapitałowych, wysokość RSO Pożyczki ulega analogicznej zmianie. Informacja
o zmianie RSO i jej nowa wysokość zostanie przekazana Pożyczkobiorcy na adres
e-mail i na Profilu Klienta, na trwałym nośniku pozwalającym na jego zapisanie
lub wydrukowanie, lub za pośrednictwem poczty.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.18.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Odsetki umowne o zmiennej stopie
procentowej </span></b><span style='font-size:10.0pt;line-height:150%'>–
odsetki obliczone według RSO.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.19.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Strona Internetowa</span></b><span
style='font-size:10.0pt;line-height:150%'> – strona internetowa pod adresem </span><a
href="http://www.minicredit.pl"><span style='font-size:10.0pt;line-height:150%;
color:windowtext'>www.minicredit.pl</span></a></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.20.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Umowne Odsetki za opóźnienie </span></b><span
style='font-size:10.0pt;line-height:150%'>– w wysokości odsetek maksymalnych za
opóźnienie w rozumieniu art. 481 § 2(1) Kodeksu cywilnego, równe dwukrotności
sumy stopy referencyjnej Narodowego Banku Polskiego i 5,5 punktów procentowych,
należne Pożyczkodawcy w przypadku nieterminowej spłaty Pożyczki przez
Pożyczkobiorcę. Stopa procentowa odsetek maksymalnych za opóźnienie aktualna na
dzień zawarcia Umowy wynosi 22,50% w skali roku. Zmiana stopy Odsetek za
opóźnienie następuje w przypadku zmiany stopy referencyjnej Narodowego Banku
Polskiego, odpowiednio do zmiany tej stopy. W przypadku zmiany stopy odsetek
maksymalnych za opóźnienie Pożyczkodawca nalicza Odsetki za opóźnienie według
nowej stopy od dnia zmiany stopy referencyjnej Narodowego Banku Polskiego.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.21.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Data zawarcia umowy</span></b><span
style='font-size:10.0pt;line-height:150%'> – data złożenia przez Pożyczkodawcę Dyspozycji
wykonania wypłaty kwoty Pożyczki.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.22.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Dzień Spłaty</span></b><span
style='font-size:10.0pt;line-height:150%'> – dzień, w którym Pożyczkobiorca
jest zobowiązany spłacić Pożyczkę wraz z należnymi Pożyczkodawcy opłatami tj.
Prowizją oraz Umownymi odsetkami kapitałowymi.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.23.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Formularz Informacyjny </span></b><span
style='font-size:10.0pt;line-height:150%'>– oznacza formularz informacyjny
dotyczący kredytu konsumenckiego w rozumieniu Ustawy o kredycie konsumenckim,
zawierający dane dotyczące udzielonej Pożyczki przesyłany Pożyczkobiorcy na
trwałym nośniku w momencie składania wniosku o pożyczkę oraz po zawarciu Umowy
Pożyczki.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.24.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Konto bankowe do spłaty – </span></b><span
style='font-size:10.0pt;line-height:150%'>rachunek bankowy Pożyczkodawcy
znajdujący się w Umowie.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.25.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Całkowita Kwota do spłaty </span></b><span
style='font-size:10.0pt;line-height:150%'>– oznacza sumę Całkowitej Kwoty
Pożyczki oraz Całkowitego Kosztu Pożyczki.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.26.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Całkowity Koszt Pożyczki </span></b><span
style='font-size:10.0pt;line-height:150%'>–<b> </b>oznacza wszelkie koszty,
jakie Pożyczkobiorca jest zobowiązany ponieść w związku z udzieloną Pożyczką w
wysokości wskazanej w Warunkach Pożyczki, ustalone zgodnie z założeniami
przyjętymi dla obliczenia RRSO.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.27.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Formularz Internetowy</span></b><span
style='font-size:10.0pt;line-height:150%'> – formalna część wniosku o
udzielenie Pożyczki złożona Pożyczkodawcy przez Pożyczkobiorcę. </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.28.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Regulamin </span></b><span
style='font-size:10.0pt;line-height:150%'>– Regulamin świadczenia usług
elektronicznych.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>2.1.29.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><b><span
style='font-size:10.0pt;line-height:150%'>Trwały nośnik </span></b><span
style='font-size:10.0pt;line-height:150%'>– materiały czy narzędzia (np.
papier, płyta CD/DVD, czy mail) umożliwiające przechowywanie informacji w
sposób, umożliwiający dostęp do nich przez okres, w jakim informacje te będą
przetwarzane. Trwały nośnik pozwala na odtworzenie informacji w niezmienionej
postaci tj. bez ingerencji podmiotu, który był ich twórcą.</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;line-height:150%'><b><span
style='font-size:10.0pt;line-height:150%'>2.2.     </span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku, sprzeczności
jakichkolwiek postanowień Regulaminu lub innych dokumentów, stanowiących
załączniki do Umowy, z niniejszą umową, każdorazowo pierwszeństwo mają zapisy
umowy pożyczki zawartej z Użytkownikiem. </span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§ 3. KONTO UŻYTKOWNIKA</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>3.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca oświadcza, iż jest
Użytkownikiem i posiada dostęp do aktywnego Konta Użytkownika, przypisanego do
Pożyczkobiorcy, założonego w Systemie teleinformatycznym Pożyczkodawcy, pod
loginem </span><span style='font-size:10.0pt;line-height:150%'>{KLIENT.EMAIL}</span><span
style='font-size:10.0pt;line-height:150%'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>3.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Zasady utworzenia Konta Użytkownika w
Systemie teleinformatycznym Pożyczkodawcy szczegółowo zostały opisane w
Regulaminie świadczenia usług elektronicznych i stanowią integralną cześć
Umowy.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;line-height:150%'><span
style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;text-align:center;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>§ 4.
OŚWIADCZENIA POŻYCZKOBIORCY</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>4.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca oświadcza, iż przed
złożeniem Dyspozycji zawarcia niniejszej </span><span style='font-size:10.0pt;
line-height:150%'>umowy</span><span style='font-size:10.0pt;line-height:150%'>:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>4.1.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Zapoznał się z treścią Umowy oraz
oświadcza, iż treść Umowy jest dla niego całkowicie zrozumiała i ją w pełni
akceptuje;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>4.1.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Treść Umowy jest zgodna z wnioskiem o
udzielenie pożyczki złożonym przez Pożyczkobiorcę za pośrednictwem Portalu
Internetowego Pożyczkodawcy lub stanowi maksymalną kwotę pożyczki w całości
zaakceptowaną przez Pożyczkobiorcę w ramach wnioskowania o udzielenie pożyczki;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>4.1.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Otrzymał Formularz informacyjny na Trwałym
nośniku</span><span style='font-size:10.0pt;line-height:150%'>, a</span><span
style='font-size:10.0pt;line-height:150%'> pośrednictwem poczty elektronicznej,
na wskazany w Koncie Użytkownika adres mailowy</span><span style='font-size:
10.0pt;line-height:150%'>;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>4.1.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>Potwierdza w całości
swoje dane osobowe wskazane w Formularzu informacyjnym</span><span
style='font-size:10.0pt;line-height:150%;color:black'> oraz</span><span
style='font-size:10.0pt;line-height:150%;color:black'> </span><span
style='font-size:10.0pt;line-height:150%;color:black'>złożył oświadczenia w
toku badania oceny zdolności kredytowej, pozwalające na pełną jej ocenę na
potrzeby udzielenia pożyczki;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>4.1.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>Nie posiada żadnych
zaległych zobowiązań, których zaległości w ich spłacie wynosi powyżej 6
miesięcy oraz udzielona pożyczka nie była przeznaczona na spłatę uprzedniej
zaległości. <br>
Poprzez zaległe zobowiązania rozumieć należy, wszelkie zobowiązania, których
termin zapłaty minął i nie zostały zapłacone do dnia zawarcia umowy pożyczki,
przy czym zaległość wynosi powyżej 6 miesięcy w terminie ich zapłaty licząc od
dnia zawarcia przedmiotowej umowy;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%;color:black'>4.1.6.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>Rozumie</span><span
style='font-size:10.0pt;line-height:150%;color:black'> i akceptuje wszelkie
informacje, wskazane w Formularzu I</span><span style='font-size:10.0pt;
line-height:150%;color:black'>nformacyjnym</span><span style='font-size:10.0pt;
line-height:150%;color:black'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>4.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca potwierdza, że jest
konsumentem w rozumieniu Ustawy o kredycie konsumenckim i zawiera Umowę, w celu
niezwiązanym z działalnością gospodarczą.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>4.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca oświadcza, że w dacie
zawarcia niniejszej Umowy:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>4.3.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Posiada stałe miejsce zamieszkania na
terenie Polski, numer PESEL oraz polski dowód osobisty;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>4.3.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Posiada pełną zdolność do czynności
prawnych;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>4.3.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Posiada zdolność do spłaty zobowiązań
względem Pożyczkodawcy, powstałych na skutek zaciągnięcia pożyczki;</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>4.3.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Zawarcie Umowy</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> nie następuje z pokrzywdzeniem któregokolwiek z Wierzycieli Pożyczkobiorcy.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;line-height:150%'><b><span
style='font-size:10.0pt;line-height:150%'>&nbsp;</span></b></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§ 5. OŚWIADCZENIA POŻYCZKODAWCY</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>5.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkodawca oświadcza, iż:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>5.1.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Jest podmiotem prowadzącym
działalność gospodarczą, polegającą na udzielaniu pożyczek;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>5.1.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Jest Instytucją Pożyczkową w
rozumieniu Ustawy o kredycie konsumenckim, zgłoszoną do rejestru prowadzonego
przez Komisję Nadzoru Finansowego.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>5.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Ponadto Pożyczkodawca oświadcza, iż:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>5.2.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Posiada środki finansowe,
umożliwiające mu realizacje niniejszej umowy;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>5.2.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Nie jest niewypłacalny w rozumieniu
ustawy prawo upadłościowe i naprawcze;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>5.2.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Zawarcie Umowy</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> nie następuje z pokrzywdzeniem któregokolwiek z Wierzycieli
Pożyczkobiorcy.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>5.2.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%;color:black'>Dokonał bezpośrednio
przed zawarciem przedmiotowej umowy oceny jakościowej i ilościowej zdolności
kredytowej Pożyczkodawcy, w szczególności dokonał weryfikacji zaległych zobowiązań,
których zaległości w ich spłacie wynoszą powyżej 6 miesięcy, wypełniając w
całości obowiązek nałożony art. 9a ustawy z dnia 12 maja 2011r. o kredycie
konsumenckim.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;text-align:justify;
line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><a name="_Hlk111636018"><b><span
style='font-size:10.0pt;line-height:150%'>§ 6. WNIOSEK O UDZIELENIE POŻYCZKI</span></b></a></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>6.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Proces przygotowania i udzielania
Pożyczki</span><span style='font-size:10.0pt;line-height:150%'>,</span><span
style='font-size:10.0pt;line-height:150%'> każdorazowo inicjowany jest przez
Pożyczkobiorcę, poprzez złożenie wniosku o udzielenie Pożyczki</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> za pośrednictwem Systemu teleinformatycznego Pożyczkodawcy</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> udostępnionego na Stronie Internetowej, zwany dalej
Wnioskiem o Pożyczkę, na której Pożyczkobiorca ma przypisane indywidulane,
zweryfikowane Konto Użytkownika, zwanego dalej Wniosku o Pożyczkę. </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>6.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wniosek o Pożyczkę składany jest
elektronicznie poprzez uzupełnienie Formularza Internetowego, udostępnionego
Użytkownikowi poprzez Konto <span style='color:black'>Użytkownika.</span></span><span
style='font-size:10.0pt;line-height:150%;color:black'> Nadto wszelkie
oświadczenia złożone we wniosku o udzielenie pożyczki złożone są poprzez
uzupełnienie formularza internetowego, o czym konsument został poinformowany i
wnosi wobec tego zastrzeżeń.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>6.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkodawca może odstąpić od
obowiązku wypełnienia Formularza Internetowego w przypadku <span
style='color:black'>drugiej i następnej Pożyczki udzielanej na zasadach
opisanych w Umowie i Regulaminie</span></span><span style='font-size:10.0pt;
line-height:150%;color:black'>, jednakże każdorazowo zobowiązany jest do
uzupełnienia Formularza w zakresie objętym badaniem zdolności kredytowej</span><span
style='font-size:10.0pt;line-height:150%'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>6.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>We Wniosku o Pożyczkę Użytkownik
określa parametry umowy pożyczki, o </span><span style='font-size:10.0pt;
line-height:150%'>jakiej wnioskowanie o</span><span style='font-size:10.0pt;
line-height:150%'> udzielenie wnosi.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>6.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Proces składania Wniosku o pożyczkę
kończy, złożenie przez Pożyczkobiorcę Dyspozycji, zatwierdzającej kwotę
przyznanej Pożyczki, w Systemie teleinformatycznym Pożyczkodawcy albo odmowa
udzielenia Pożyczki.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;text-align:justify;
line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><a name="_Hlk111636450"></a><a
name="_Hlk111636675"><b><span style='font-size:10.0pt;line-height:150%'>§ 7.
KONTROLA KREDYTOWA</span></b></a></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca upoważnia
Pożyczkodawcę do przeprowadzenia Kontroli kredytowej</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> w celu ustalenia zdolności Pożyczkobiorcy do spłaty Pożyczki</span><span
style='font-size:10.0pt;line-height:150%'> oraz</span><span style='font-size:
10.0pt;line-height:150%'> analizy potrzeb konsumenta pod kątem adekwatności
produktu o który wnioskuje.</span><span style='font-size:10.0pt;line-height:
150%;color:#7030A0'> </span><span style='font-size:10.0pt;line-height:150%;
color:black'>Kontrola kredytowa jest przeprowadzona zgodnie w wymogami ustawy z
dnia 12 maja 2011r. ze zm. o kredycie konsumenckim.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Kontrola kredytowa inicjowana jest w
chwili złożenia przez Pożyczkobiorcę Dyspozycji zawarcia umowy <span
style='color:black'>pożyczki</span></span><span style='font-size:10.0pt;
line-height:150%;color:black'>,</span><span style='font-size:10.0pt;line-height:
150%;color:black'> poprzez wypełnienie i przesłanie za pomocą Konta Użytkownika
Wniosku o Pożyczkę</span><span style='font-size:10.0pt;line-height:150%;
color:black'> zawierającego oświadczenia Pożyczkobiorcy złożone przez niego
osobiście.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Kontrola kredytowa obejmuje również
weryfikację prawdziwości informacji podanych przez Pożyczkobiorcę w Formularzu
Internetowym</span><span style='font-size:10.0pt;line-height:150%'>, <span
style='color:black'>obejmującego fakt istnienia zaległości w spłacie innych
zobowiązań pieniężnych wynoszących powyżej 6 miesięcy od dnia zawarcia umowy
pożyczki</span></span><span style='font-size:10.0pt;line-height:150%;
color:black'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W celu weryfikacji prawdziwości
informacji podanych przez Pożyczkobiorcę w Formularzu Internetowym Pożyczkodawca
może uzależnić dalsze prowadzenie Kontroli Kredytowej od przedłożenia przez
Pożyczkobiorcę Pożyczkodawcy dodatkowych dokumentów, których kopie
Pożyczkobiorca przekazuje w formie elektronicznej, korzystając w tym celu z
Konta Użytkownika lub adresu email: info@minicredit.pl.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W szczególności Pożyczkodawca może
żądać przedłożenia, następujących dokumentów: a) kopia dowodu osobistego </span><span
style='font-size:10.0pt;line-height:150%'>– </span><span style='font-size:10.0pt;
line-height:150%'>obie strony</span><span style='font-size:10.0pt;line-height:
150%'>,</span><span style='font-size:10.0pt;line-height:150%'> prawo jazdy lub
paszport</span><span style='font-size:10.0pt;line-height:150%'>, b</span><span
style='font-size:10.0pt;line-height:150%'>) potwierdzenie numeru rachunku
bankowego, np. pismo z banku, dowód wypłaty z rachunku bankowego, wpłaty na
rachunek bankowy</span><span style='font-size:10.0pt;line-height:150%'>, c</span><span
style='font-size:10.0pt;line-height:150%'>) kopia wyciągu bankowego za ostatni
miesiąc kalendarzowy, a w przypadku, gdy na wyciągu bankowym nie jest wskazany
adres, rachunek za media (faktura VAT) wystawiony nie dawniej niż 3 miesiące
przed datą złożenia przez Pożyczkobiorcę Wniosku o Pożyczkę</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> zawierający adres Pożyczkobiorcy.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.6.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku, gdy Pożyczkobiorca jest
osobą fizyczną prowadzącą działalność gospodarczą, Pożyczkodawca może również
zażądać przedłożenia dodatkowych dokumentów na przykład KPIR z trzech ostatnich
miesięcy.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wynik kontroli kredytowej w
szczególności zależy od: historii kredytowej Pożyczkobiorcy, wieku
Pożyczkobiorcy, dochodów uzyskiwanych przez Pożyczkobiorcę, zobowiązań
Pożyczkobiorcy widniejących w bazach danych biur </span><span style='font-size:
10.0pt;line-height:150%'>informacji gospodarczej</span><span style='font-size:
10.0pt;line-height:150%'>.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.8.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca przyjmuje do
wiadomości, że wniosek o pożyczkę może zostać odrzucony, a Pożyczkobiorcy nie
zostanie udzielona Pożyczka, również z następujących powodów:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Niezgodności danych zawartych we
wniosku o pożyczkę z danymi w treści dokumentów przedstawionych przez
Pożyczkobiorcę; </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wygaśnięcia dokumentu tożsamości lub
braku w dokumentach wszystkich wymaganych informacji;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Zobowiązania ze wcześniejszej
Pożyczki nie były przez Pożyczkobiorcę spłacane terminowo; </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Adres podany przez Pożyczkobiorcę</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> jako jego adres zamieszkania został wcześniej zgłoszony,
jako adres zamieszkania innego Pożyczkobiorcy;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Numer telefonu podany przez
Pożyczkobiorcę został wcześniej zgłoszony</span><span style='font-size:10.0pt;
line-height:150%'>,</span><span style='font-size:10.0pt;line-height:150%'> jako
numer telefonu innego Pożyczkobiorcy;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.6.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Adres email podany przez
Pożyczkobiorcę został wcześniej zgłoszony, jak adres email innego
Pożyczkobiorcy; </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca</span><span
style='font-size:10.0pt;line-height:150%'> w przypadku poprzedniej pożyczki
odstąpił od umowy pożyczki;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.8.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Weryfikacja telefoniczna
Pożyczkobiorcy przebiegła negatywnie;</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.8.9.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca</span><span
style='font-size:10.0pt;line-height:150%'> ogłosił upadłość konsumencką lub
pozostaje w trakcie postępowania upadłościowego</span><span style='font-size:
10.0pt;line-height:150%'>.</span><span style='font-size:10.0pt;line-height:
150%'> </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.9.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkodawca oceni zdolność
kredytową Pożyczkobiorcy na podstawie informacji, zależnie od okoliczności,
uzyskanych od Pożyczkobiorcy oraz jeżeli będzie to konieczne, na podstawie
sprawdzenia odpowiedniej bazy danych. W przypadku odrzucenia wniosku na podstawie
sprawdzenia bazy danych, Pożyczkodawca poinformuje Pożyczkobiorcę niezwłocznie</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> bezpłatnie</span><span style='font-size:10.0pt;line-height:
150%'>,</span><span style='font-size:10.0pt;line-height:150%'> o wynikach
takiego sprawdzenia określając bazę danych, która została sprawdzona.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.10.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Po wydaniu pozytywnej decyzji w
sprawie udzielenia Pożyczki, Pożyczkodawca udostępni na trwałym nośniku Umowę
Pożyczki, Formularz Informacyjny oraz Formularz Odstąpienia (w formie plików
PDF umożliwiających ich zapisanie na komputerze Pożyczkobiorcy). Wymienione
dokumenty </span><span style='font-size:10.0pt;line-height:150%'>będą</span><span
style='font-size:10.0pt;line-height:150%'> wysłane w formie plików PDF na adres
mailowy Pożyczkobiorcy, wskazany przez Pożyczkobiorcę w Koncie Użytkownika oraz
będą widoczne po zalogowaniu się przez Pożyczkobiorcę na Koncie Użytkownika na
Stronie Internetowej (w formie plików umożliwiających zapis na komputerze
Pożyczkobiorcy).</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>7.11.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Na wypadek gdyby Pożyczkodawca podjął
decyzję o konieczności dodatkowej Kontroli Kredytowej w zakresie sprawdzenia
baz danych Pożyczkobiorca udziela Pożyczkodawcy następujących zgód:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.11.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Na podstawie art. 24 ust. 1 ustawy z
dnia 9 kwietnia 2010 roku o udostępnianiu informacji gospodarczych i wymianie
danych gospodarczych, upoważniam Minicredit Sp. z o.o. do wystąpienia do
Krajowego Biura Informacji Gospodarczej S.A. z siedzibą w Krakowie, ul.
Lublańska 34, 31 – 476 Kraków, zwanego dalej KBIG, o ujawnienie informacji
gospodarczych dotyczących moich zobowiązań oraz upoważniam KBIG do ujawnienia
Minicredit Sp. z o.o. tych informacji.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>7.11.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Na podstawie art. 18 ust. 1 pkt 2
ustawy z dnia 9 kwietnia 2010 roku o udostępnianiu informacji gospodarczych i
wymianie danych gospodarczych, udzielam zgody Minicredit Sp. z o.o. na
przekazanie do Krajowego Biura Informacji Gospodarczej S.A. z siedzibą w
Krakowie, ul. Lublańska 34, 31 – 476 Kraków informacji gospodarczych o
wywiązywaniu się ze wszelkich zobowiązań pieniężnych, zarówno istniejących w
chwili udzielenia zgody, jak również mogących powstać w przyszłości, a
powstałych w związku z niniejszą umową o kredyt konsumencki zawartą z
Pożyczkodawcą.&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;text-align:justify;
line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§ 8. WARUNKI UDZIELENIA I SPŁATY POŻYCZKI</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczka zostanie udzielona w
polskich złotych. W przypadku zmiany waluty obowiązującej w Polsce,
Pożyczkodawca udzieli Pożyczki w aktualnej walucie.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkodawca wypłaca pożyczkę
Pożyczkobiorcy przelewając pożyczkę na Konto Pożyczkobiorcy podane przez
Pożyczkobiorcę podczas rejestracji Wniosku o pożyczkę. </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczka zostanie spłacona przez
Pożyczkobiorcę jednorazowo w Dniu Spłaty tj. w terminie i na warunkach
określonych niniejszą Umową.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca dokona spłaty Pożyczki
na </span><span style='font-size:10.0pt;line-height:150%'>rachunek bankowy
Pożyczkodawcy numer</span><span style='font-size:10.0pt;line-height:150%'> </span><span
style='font-size:10.0pt;line-height:150%'>{b%POZYCZKA.NUMER_SUBKONTA} </span><span
style='font-size:10.0pt;line-height:150%'>lub za pośrednictwem szybkiego
przelewu Przelewy24.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Strony Umowy ustalają, iż co najmniej
3 dni przed Datą Spłaty Pożyczkodawca może rozpocząć działania mające na celu
przypomnienie o zbliżającym się terminie zapłaty. </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.6.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku niedokonania przez
Pożyczkobiorcę spłaty Całkowitej Kwoty do spłaty w Dniu spłaty, Pożyczkodawca
wyśle Pożyczkobiorcy zawiadomienie o istniejącym zadłużeniu w dowolnej formie
określonej niniejszą Umową.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Zawiadomienia są wysyłane do
Pożyczkobiorcy w formie wiadomości tekstowych SMS, za pośrednictwem poczty
elektronicznej oraz za pośrednictwem poczty zwykłej lub poleconej.
Zawiadomienia są wysyłane na numer telefonu i adres poczty </span><span
style='font-size:10.0pt;line-height:150%'>elektronicznej</span><span
style='font-size:10.0pt;line-height:150%'> oraz adres zamieszkania lub adres
korespondencyjny wskazane przez Pożyczkobiorcę na Koncie Użytkownika.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.8.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku niedokonania przez
Pożyczkobiorcę spłaty Pożyczki w Dniu Spłaty, Pożyczkodawca może korzystać z
usług podmiotów specjalizujących się w windykacji należności, na co
Pożyczkobiorca wyraża zgodę. </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.9.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Strony niniejszej umowy nie
przewidują możliwości przedłużenia terminu spłaty Całkowitej kwoty do spłaty,
odnowienia Pożyczki ani oferowania Pożyczkobiorcy nowej pożyczki, w przypadku
niedokonania spłaty Całkowitej kwoty do spłaty.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.10.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku niedokonania przez
Pożyczkobiorcę spłaty Całkowitej kwoty do spłaty w Dniu Spłaty, Pożyczkodawca
może dochodzić spłaty Całkowitej kwoty do spłaty wraz z wszystkimi innymi
wymagalnymi należnościami na drodze postępowania sądowego. Na podstawie
prawomocnego wyroku zasądzającego Całkowitej kwoty do spłaty wraz z innymi
wymagalnymi należnościami, Pożyczkobiorca może być obciążony kosztami procesu
na podstawie powszechnie obowiązującego prawa.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.11.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkodawca jest uprawniony do
dokonania cesji wierzytelności, w tym niewymagalnych, wynikających z tytułu
Umowy Pożyczki, na rzecz osób trzecich bez zgody Klienta. Klient zostanie
powiadomiony o dokonaniu cesji.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.12.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Otrzymywane środki pieniężne będą
zaliczane przez Pożyczkodawcę według następującej kolejności: koszty związane z
postępowaniem sądowym i egzekucyjnym, jeśli takie powstały zgodnie z Umową
Pożyczki; Odsetki za opóźnienie, jeśli takie powstały zgodnie z Umową; Odsetki
kapitałowe; Prowizja administracyjna</span><span style='font-size:10.0pt;
line-height:150%'>,</span><span style='font-size:10.0pt;line-height:150%'>
Prowizja przygotowawcza, kwota Pożyczki.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.13.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca ma możliwość spłaty
części lub całości kwoty Pożyczki przed Dniem Spłaty bez ponoszenia z tego
tytułu dodatkowych opłat.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.14.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku spłaty całości lub części
Pożyczki przed Dniem Spłaty Pożyczkobiorca jest zobowiązany dokonać spłaty
takiej kwoty Pożyczki wraz z odpowiednimi opłatami obliczonymi proporcjonalnie
do spłacanej kwoty oraz do daty wcześniejszej spłaty.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.15.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Roszczenia Pożyczkobiorcy, które
powstają </span><span style='font-size:10.0pt;line-height:150%'>wskutek</span><span
style='font-size:10.0pt;line-height:150%'> częściowej przedterminowej spłaty
Pożyczki, będą ulegały potrąceniu z roszczeniami Pożyczkodawcy o spłatę
pozostałej części Pożyczki niezwłocznie po powstaniu tychże roszczeń i bez
konieczności składania w tym przedmiocie jakichkolwiek oświadczeń przez strony.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.16.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> gdy po całkowitej wcześniejszej spłacie Pożyczki i innych
wymagalnych zobowiązań Pożyczkobiorcy wobec Pożyczkodawcy, pozostaną środki
podlegające zwrotowi Pożyczkobiorcy, Pożyczkodawca dokona rozliczenia tych
środków w terminie 14 dni od dnia dokonania wcześniejszej spłaty Pożyczki.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.17.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku nieterminowej spłaty
przez Pożyczkobiorcę Całkowitej kwoty do spłaty w Dniu Spłaty Pożyczkodawca ma
prawo naliczyć Umowne Odsetki za opóźnienie oraz prowadzić czynności
upominawcze i windykacyjne.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-27.2pt;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>8.18.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku spełnienia warunków
określonych w ustawie z dnia 9 kwietnia 2010 r. o udostępnianiu informacji
gospodarczych i wymianie danych gospodarczych (Dz. U. z 2010 r., Nr 81, poz.
530 z późn. zm.), Pożyczkodawca jest uprawniony do przekazania informacji o
zaległych należnościach Pożyczkodawcy wobec Pożyczkobiorcy do Biur Informacji
Gospodarczych.</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-top:0cm;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>&nbsp;</span></b></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:0cm;
margin-top:0cm;text-align:center;line-height:150%'><b><span style='font-size:
10.0pt;line-height:150%'>§ 9. ZAWARCIE UMOWY POŻYCZKI</span></b></p>

<p class=MsoNormal style='margin-bottom:0cm;text-align:justify;line-height:
150%'><span style='font-size:10.0pt;line-height:150%'>Strony niniejszej umowy ustalają,
iż oświadczenia woli potwierdzające zawarcie niniejszej umowy pożyczki złożone
zostały w następujący sposób:</span></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>9.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Za Pożyczkobiorcę: w chwili złożenia
Dyspozycji, zatwierdzającej kwotę przyznanej Pożyczki, tj. dokonując czynności
akceptacji kwoty przyznanej pożyczki, za pośrednictwem Sytemu
Teleinformatycznego Pożyczkodawcy, w którym Pożyczkobiorca posiada aktywne Konto
Użytkownika.</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>9.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Za Pożyczkodawcę: w chwili złożenia
przez Pożyczkodawcę Dyspozycji wykonania wypłaty kwoty Pożyczki.</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-top:0cm;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>&nbsp;</span></b></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§ 10. ODSTĄPIENIE OD UMOWY POŻYCZKI</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>10.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca ma prawo odstąpić od
Umowy Pożyczki w ciągu 14 dni od daty jej zawarcia.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>10.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkobiorca wykonuje prawo do
odstąpienia poprzez przesłanie na adres korespondencyjny Pożyczkodawcy (ul. Migdałowa
4, 02-795&nbsp;Warszawa) pisemnego oświadczenia o odstąpieniu lub zeskanowanego
oświadczenia opatrzonego czytelnym podpisem Pożyczkobiorcy zawierającym imię i
nazwisko na adres poczty elektronicznej zamieszczony na Stronie Internetowej
(info@minicredit.pl). Wzór Formularza Odstąpienia jest dostępny po zalogowaniu
się na Stronie Internetowej, jak również zostaje przesłany Pożyczkobiorcy po
każdorazowym zawarciu Umowy Pożyczki (w formie pliku PDF umożliwiającego
zapisanie na komputerze Pożyczkobiorcy). Nie wyłącza to prawa do odstąpienia od
umowy w przypadku nie budzącego wątpliwości oświadczenia woli złożonego przez
Pożyczkobiorcę Pożyczkodawcy w innej formie.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>10.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W razie skorzystania z odstąpienia od
umowy, Pożyczkobiorca jest zobowiązany zwrócić Pożyczkodawcy kwotę wypłaconej
Pożyczki, powiększonej o kwotę odsetek umownych, w wysokości Stopy Umownych
Odsetek kapitałowych, za każdy dzień opóźnienia w zwrocie kwoty wypłaconej
Pożyczki, liczony od daty udzielenia pożyczki. </span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>10.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Zwrot powinien nastąpić na Konto
bankowe do spłaty&nbsp;niezwłocznie, jednak nie później niż w terminie 30 dni
od dnia złożenia oświadczenia o odstąpieniu. </span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>10.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W razie opóźnienia w zwrocie,
wypłacona Pożyczkobiorcy kwota Pożyczki staje się zadłużeniem przeterminowanym,
od którego pobierane są odsetki maksymalne za opóźnienie w wysokości równej
dwukrotności sumy aktualnej stopy referencyjnej Narodowego Banku Polskiego i
5,5 punktów procentowych (w stosunku rocznym), począwszy od 31 dnia po dniu
złożenia oświadczenia o odstąpieniu do dnia spłaty. Wysokość odsetek
maksymalnych za opóźnienie może ulegać zmianie na zasadach określonych w 2.1.20.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;text-align:justify;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></b></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§11. PROCEDURA REKLAMACJI</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>11.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W razie powzięcia przez
Pożyczkobiorcę zastrzeżeń dotyczących usług świadczonych przez Pożyczkodawcę
lub w razie stwierdzenia przez niego niewywiązywania się przez Pożyczkodawcę z
przyjętych zobowiązań lub postępowania niezgodnego z przepisami prawa, może on
niezależenie od uprawnień przysługujących mu na podstawie przepisów prawa
skierować do Pożyczkodawcy Reklamację.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>11.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Reklamacja może być złożona przez
Pożyczkobiorcę:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>11.2.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>w formie pisemnej – osobiście w
siedzibie albo przesyłką pocztową na adres&nbsp;Pożyczkodawcy: ul. Migdałowa 4,
02-796 Warszawa.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>11.2.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>ustnie – telefonicznie pod numerem +48&nbsp;888&nbsp;444&nbsp;852.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>11.2.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>w formie elektronicznej – na adres e
- mail: info@minicredit.pl</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>11.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkodawca rozpatruje Reklamację
niezwłocznie, nie później niż w terminie 30 dni od daty otrzymania Reklamacji.
W szczególnie skomplikowanych przypadkach, uniemożliwiających rozpatrzenie
reklamacji i udzielenie odpowiedzi w terminie 30 dni, Pożyczkodawca w
informacji przekazywanej Pożyczkobiorcy, który wystąpił z reklamacją wyjaśni
przyczynę opóźnienia</span><span style='font-size:10.0pt;line-height:150%'>,</span><span
style='font-size:10.0pt;line-height:150%'> wskazując okoliczności, które muszą
zostać ustalone dla rozpatrzenia sprawy oraz określi przewidywany termin
rozpatrzenia reklamacji i udzielenia odpowiedzi, nieprzekraczający 60 dni od
dnia otrzymania reklamacji.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>11.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>O wyniku postępowania reklamacyjnego
Pożyczkodawca powiadomi Pożyczkobiorcę przesyłką listową na adres pocztowy
podany podczas rejestracji, a w przypadku jego braku, na inny adres pocztowy,
podany w korespondencji. Odpowiedź na reklamację zostanie dostarczona pocztą
elektroniczną na adres e-mail Pożyczkobiorcy wyłącznie na jego wniosek.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>11.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku nieuwzględnienia
roszczenia wynikającego z Reklamacji, Pożyczkobiorca może:</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>11.5.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wystąpić z wnioskiem o rozpatrzenie
sprawy do Rzecznika Finansowego, zgodnie z ustawą z dnia 5 sierpnia 2015 r. o
rozpatrywaniu reklamacji przez podmioty rynku finansowego i o Rzeczniku
Finansowym (Dz. U. 2015, poz. 1348</span><span style='font-size:10.0pt;
line-height:150%'>).</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:2.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:9.0pt;line-height:150%'>11.5.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wystąpić z powództwem do sądu
powszechnego ze wskazaniem podmiotu, który powinien być pozwany (Pożyczkodawca)
i sądu miejscowo właściwego do rozpoznania sprawy</span><span style='font-size:
10.0pt;line-height:150%'>.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;text-align:justify;
line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:8.0pt;
text-align:center;line-height:150%'><b><span style='font-size:10.0pt;
line-height:150%'>§12. POSTANOWIENIA KOŃCOWE</span></b></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.1.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W przypadku</span><span
style='font-size:10.0pt;line-height:150%'> </span><span style='font-size:10.0pt;
line-height:150%'>podania przez Pożyczkobiorcę nieprawdziwych informacji i
danych niezbędnych do jego właściwej weryfikacji i oceny zdolności kredytowej,
Pożyczkodawca ma prawo wypowiedzieć Umowę Pożyczki ze skutkiem natychmiastowym.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wypowiedzenie Umowy nie wpływa na
obowiązek spłaty zobowiązań Pożyczkobiorcy względem Pożyczkodawcy</span><span
style='font-size:10.0pt;line-height:150%'>,</span><span style='font-size:10.0pt;
line-height:150%'> istniejących w chwili dokonania wypowiedzenia.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Jeżeli Pożyczkodawca nie wykonał lub
nienależycie wykonał zobowiązanie wobec Pożyczkobiorcy, a żądanie przez
Pożyczkobiorcę wykonania tego zobowiązania nie było skuteczne, Pożyczkobiorcy
przysługuje prawo dochodzenia swoich roszczeń o wykonanie tego zobowiązania od
Pożyczkodawcy</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Prawem właściwym dla Umowy jest prawo
polskie.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.5.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Prawa i obowiązki Pożyczkobiorcy
wynikające z Umowy Pożyczki nie mogą zostać przeniesione na jakąkolwiek osobę
trzecią bez uprzedniej pisemnej zgody Pożyczkodawcy.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.6.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Pożyczkodawca jest uprawniony do
dokonania cesji wierzytelności w tym niewymagalnych, wynikających z tytułu
Umowy na rzecz osób trzecich. Pożyczkobiorca zostanie o tym fakcie
powiadomiony.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Wszelkie spory pomiędzy Stronami będą
rozwiązywane w pierwszej kolejności polubownie. W przypadku gdy Strony nie będą
w stanie rozwiązać sporu polubownie, zostanie poddany on pod rozstrzygnięcie
właściwemu sądowi powszechnemu.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.8.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Podmiotem uprawnionym, właściwym do
pozasądowego rozstrzygania sporu wynikającego z Umowy pomiędzy Pożyczkobiorcą a
Pożyczkodawcą jest Rzecznik Finansowy. Kontakt do Rzecznika Finansowego oraz
szczegółowe informacje dotyczące postępowania dostępne są na stronie
internetowej&nbsp;</span><a href="http://www.rf.gov.pl/"><span
style='font-size:10.0pt;line-height:150%;color:windowtext'>www.rf.gov.pl</span></a><span
style='font-size:10.0pt;line-height:150%'>. W celu rozstrzygnięcia sporu
pomiędzy Pożyczkodawcą a Pożyczkobiorcą istnieje także możliwość skorzystania z
platformy internetowej ODR, dostępnej pod adresem:&nbsp;</span><a
href="http://ec.europa.eu/odr/"><span style='font-size:10.0pt;line-height:150%;
color:windowtext'>http://ec.europa.eu/odr/</span></a><span style='font-size:
10.0pt;line-height:150%'>. Platforma ODR ułatwia pozasądowe rozstrzyganie przez
</span><span style='font-size:10.0pt;line-height:150%'>Internet</span><span
style='font-size:10.0pt;line-height:150%'> sporów między konsumentami i
przedsiębiorcami.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.9.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W okresie obowiązywania Umowy
Pożyczkodawca zamierza się porozumiewać z Pożyczkobiorcą w języku polskim.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.10.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>W sprawach nieuregulowanych w Umowie
mają zastosowanie postanowienia, Kodeksu cywilnego oraz inne właściwe
powszechnie obowiązujące przepisy prawa.</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.11.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Organem właściwym w sprawach ochrony
konsumentów jest Prezes Urzędu Ochrony Konkurencji i Konsumentów (Plac
Powstańców Warszawy 1, 00-950 Warszawa).</span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:1.0cm;text-align:justify;text-indent:-1.0cm;
line-height:150%'><b><span style='font-size:10.0pt;line-height:150%'>12.12.<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></b><span
style='font-size:10.0pt;line-height:150%'>Umowa została sporządzona w dwóch
jednobrzmiących egzemplarzach, po jednym dla każdej ze Stron.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-top:0cm;text-align:justify;
line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<span style='font-size:10.0pt;line-height:150%;font-family:"Calibri",sans-serif'><br
clear=all style='page-break-before:always'>
</span>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>Załącznik nr 1</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>…………………………………………………..</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>…………………………………………………..</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>…………………………………………………..</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>Imię, Nazwisko i adres Pożyczkobiorcy</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:0cm;
margin-top:0cm;text-align:center;line-height:150%'><b><span style='font-size:
10.0pt;line-height:150%'>WZÓR OŚWIADCZENIA O ODSTĄPIENIU OD UMOWY POŻYCZKI</span></b></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>Oświadczam, że zgodnie z art. 58 w zw. z art. 53 ustawy z dnia 12 maja
2011 r. o kredycie konsumenckim (Dz. U. Nr 126, poz. 715 z późn. zm.) odstępuję
od Umowy Pożyczki nr _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ z&nbsp;dnia
_ _ _ _ _ _ _ _ _ _ _ _ _ _.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>Jednocześnie oświadczam, że jestem świadomy/świadoma konieczności
spłacenia wszelkich kwot otrzymanych przeze mnie od Pożyczkodawcy i zobowiązuję
się dokonać ich przelewu wraz z odsetkami niezwłocznie, a w żadnym przypadku
nie później niż 30 dni od daty odstąpienia, na rachunek bankowy do spłaty
podany w umowie pożyczki.</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>………………………………………………………………………………..</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>Podpis Pożyczkobiorcy</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:0cm;margin-top:0cm;
text-align:justify;line-height:150%'><span style='font-size:10.0pt;line-height:
150%'>&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:0cm;margin-bottom:8.0pt;text-align:
justify;line-height:150%'><span style='font-size:10.0pt;line-height:150%'>&nbsp;</span></p>

</div>
`;




const to_remove_CONSENT_AGREEMENT = `<p style="text-align: center;"><strong>UMOWA POŻYCZKI</strong></p>
<p>zawarta pomiędzy:</p>
<p><strong>Minicredit sp&oacute;łka z ograniczoną odpowiedzialnością</strong> z siedzibą w Warszawie mieszcząca się pod adresem ul. Migdałowa 4, 02-796 Warszawa, wpisaną do rejestru przedsiębiorc&oacute;w Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st. Warszawy w Warszawie, XII Wydział Gospodarczy KRS pod numerem KRS 0000371165, NIP 5252494263, REGON 142694604, RIP: RIP000616, o kapitale zakładowym w wysokości 5 225 000,00 ZŁ, zwaną dalej "<strong>Pożyczkodawcą</strong>"</p>
<p>a,</p>
<p>{KLIENT.IMIE}&nbsp;&nbsp;{KLIENT.NAZWISKO}, stały adres zamieszkania: {KLIENT.ADRES_ZAMIESZKANIA}, legitymującym/legitymującą się dowodem osobistym o serii i numerze {KLIENT.NUMER_DOKUMENTU_TOZSAMOSCI}, PESEL: {KLIENT.PESEL}, adres mailowy: {KLIENT.EMAIL}, zwanym/ą dalej &bdquo;<strong>Pożyczkobiorcą</strong>&rdquo;</p>
<p>&nbsp;</p>
<p>celem uzgodnienia warunk&oacute;w udzielenia i spłaty kwoty pożyczki, o następującym brzmieniu:</p>
<p>&nbsp;</p>
<ul>
<li><strong> 1. POŻYCZKA</strong></li>
<li>Pożyczkodawca udziela Pożyczkobiorcy Pożyczki w kwocie {m%POZYCZKA.KAPITAL} zł.</li>
<li>Pożyczkobiorca zobowiązuje się do zapłaty na rzecz Pożyczkodawcy Umownych Odsetek kapitałowych o zmiennej stopie procentowej, w wysokości zmiennej Rocznej Stopy Oprocentowania, kt&oacute;ra na dzień zawarcia Umowy wynosi&nbsp;{POZYCZKA.OPROCENTOWANIE_STOPA}%, od kwoty Pożyczki, liczonych od Daty zawarcia Umowy do Dnia Spłaty, kt&oacute;re na dzień zawarcia Umowy wynoszą {m%POZYCZKA.OPROCENTOWANIE} zł.</li>
<li>W związku z poniesieniem przez Pożyczkodawcę koszt&oacute;w przygotowania i udzielania Pożyczki, Pożyczkobiorca zobowiązuje się do zapłaty na rzecz Pożyczkodawcy Prowizji w wysokości {m%POZYCZKA.OPLATA_POCZATKOWA} zł.</li>
<li>Pożyczkobiorca zobowiązuje się do spłaty Pożyczki, powiększonej o kwotę Umownych odsetek kapitałowych o zmiennej stopie procentowej oraz o kwotę Prowizji, w łącznej wysokości {m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY} zł w ciągu {POZYCZKA.LICZBA_DNI} dni, w terminie do Dnia Spłaty tj.&nbsp; {POZYCZKA.DATA_SPLATY}r.</li>
<li>Parametry udzielonej pożyczki, przedstawia Tabela nr 1 o nazwie Parametry pożyczki.</li>
</ul>
<p>&nbsp;</p>
<table width="100%">
<tbody>
<tr>
<td>
<p>1</p>
</td>
<td>
<p>Kwota Pożyczki:</p>
</td>
<td>
<p>{m%POZYCZKA.KAPITAL} zł</p>
</td>
</tr>
<tr>
<td>
<p>2</p>
</td>
<td>
<p>Okres, na kt&oacute;ry została udzielona Pożyczka:</p>
</td>
<td>
<p>{POZYCZKA.LICZBA_DNI} dni</p>
</td>
</tr>
<tr>
<td>
<p>3</p>
</td>
<td>
<p>Dzień spłaty:</p>
</td>
<td>
<p>{POZYCZKA.DATA_SPLATY}r.</p>
</td>
</tr>
<tr>
<td>
<p>4</p>
</td>
<td>
<p>Stopa Umownych Odsetek kapitałowych:</p>
</td>
<td>
<p>{POZYCZKA.OPROCENTOWANIE_STOPA}%</p>
</td>
</tr>
<tr>
<td>
<p>4</p>
</td>
<td>
<p>Kwota Umownych Odsetek kapitałowych:</p>
</td>
<td>
<p>{m%POZYCZKA.OPROCENTOWANIE} zł</p>
</td>
</tr>
<tr>
<td>
<p>5</p>
</td>
<td>
<p>Prowizja:</p>
</td>
<td>
<p>{m%POZYCZKA.OPLATA_POCZATKOWA} zł</p>
</td>
</tr>
<tr>
<td>
<p>7</p>
</td>
<td>
<p>Całkowity Koszt Pożyczki:</p>
</td>
<td>
<p>{m%POZYCZKA.CALKOWITY_KOSZT_POZYCZKI} zł</p>
</td>
</tr>
<tr>
<td>
<p>8</p>
</td>
<td>
<p>Całkowita Kwota do Spłaty:</p>
</td>
<td>
<p>{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY} zł</p>
</td>
</tr>
<tr>
<td>
<p>9</p>
</td>
<td>
<p>RRSO (w procentach):</p>
</td>
<td>
<p>{POZYCZKA.RRSO} %</p>
</td>
</tr>
</tbody>
</table>
<p>Tebela nr 1 &bdquo;Parametry pożyczki&rdquo;</p>
<p><strong>&nbsp;</strong></p>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong> 2. DEFINICJE</strong></li>
<li>Wyrażeniom użytym w Umowie, Regulaminie oraz innych dokumentach, stanowiących załączniki do Umowy, Strony nadają następujące brzmienie:
<ul>
<li><strong>Ustawa o kredycie konsumenckim</strong> &ndash; oznacza ustawę z dnia 12 maja 2011 r. o kredycie konsumenckim (Dz.U. z 2014 poz.1497).</li>
<li><strong>Osoba fizyczna</strong> &ndash; konsument w rozumieniu przepis&oacute;w ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny.</li>
<li><strong>Użytkownik </strong>&ndash; osoba fizyczna, kt&oacute;ra skutecznie założyła Konto Użytkownika w Systemie teleinformatycznym Pożyczkodawcy.</li>
<li><strong>System teleinformatyczny</strong> &ndash; zesp&oacute;ł wsp&oacute;łpracujących ze sobą urządzeń informatycznych i oprogramowania, zapewniający przetwarzanie i przechowywanie, a także wysyłanie i odbieranie danych poprzez sieci telekomunikacyjne za pomocą właściwego dla danego rodzaju sieci urządzenia końcowego w rozumieniu Ustawy z dnia 16 lipca 2004 r. &ndash; Prawo telekomunikacyjne,</li>
<li><strong>Konto Użytkownika </strong>&ndash; wydzielona przestrzeń w Systemie teleinformatycznym Pożyczkodawcy, z ograniczonym dostępem, zastrzeżonym dla innych Użytkownik&oacute;w, do kt&oacute;rej Użytkownik posiada dostęp za pośrednictwem Strony Internetowej, po prawidłowej identyfikacji adresu poczty elektronicznej i podaniu prawidłowego hasła dostępu, umożliwiająca Użytkownikowi składanie Dyspozycji.</li>
<li><strong>Dyspozycje </strong>&ndash; oświadczenia woli składane przez Użytkownika w Systemie Teleinformatycznym Pożyczkodawcy, na wydzielonym koncie Użytkownika, dokumentowane przez Pożyczkodawcę w formie Log&oacute;w.</li>
<li><strong>Log </strong>&ndash; zdarzenie, czynność odnotowana w rejestrze zdarzeń lub dzienniku zdarzeń, prowadzonych w strukturach Systemu teleinformatycznego Pożyczkodawcy.</li>
<li><strong>Kontrola Kredytowa</strong> &ndash; proces oceny zdolności kredytowej Pożyczkobiorcy, weryfikacja i badanie możliwości spłaty Pożyczki.</li>
<li><strong>Pożyczka</strong> &ndash; kwota środk&oacute;w pieniężnych przekazanych Pożyczkobiorcy przez Pożyczkodawcę na podstawie Umowy Pożyczki.</li>
<li><strong>Konto Pożyczkobiorcy </strong>&ndash; indywidualny rachunek bankowy Pożyczkobiorcy prowadzony w dowolnym banku na terenie Polski, na kt&oacute;ry Pożyczkodawca przelewa Pożyczkę.</li>
<li><strong>Prowizja </strong>&ndash; oznacza koszt związany z przygotowaniem oraz udzieleniem Pożyczki, kt&oacute;ry Pożyczkobiorca zobowiązany jest uiścić w wysokości podanej w Umowie.</li>
<li><strong>RRSO </strong>&ndash; oznacza Rzeczywistą Roczną Stopę Oprocentowania, tj. Całkowity Koszt Pożyczki ponoszony przez Pożyczkobiorcę, wyrażony jako wartość procentowa Pożyczki w stosunku rocznym, obliczona zgodnie ze wzorem stanowiącym załącznik nr 4 do Ustawy oraz założeniami w nim przedstawionymi. Podawane RRSO nie uwzględnia ewentualnego rabatu na prowizję i/lub odsetki.</li>
<li><strong>RSO </strong>&ndash; oznacza Roczną Stopę Oprocentowania Pożyczki, kt&oacute;ra jest zmienna w okresie obowiązywania Umowy. Wysokość RSO określa iloczyn liczby 1 oraz aktualnej stopy ustawowych odsetek maksymalnych kapitałowych tj. dwukrotnej wysokości ustawowych odsetek kapitałowych (zgodnie z art. 359 &sect; 2(1) Kodeksu cywilnego). RSO na dzień zawarcia Umowy wynosi 20% w skali roku. Zmiana stopy ustawowych odsetek kapitałowych następuje w przypadku zmiany stopy referencyjnej Narodowego Banku Polskiego, odpowiednio do zmiany tej stopy. W przypadku zmiany wysokości stopy ustawowych odsetek maksymalnych kapitałowych, wysokość RSO Pożyczki ulega analogicznej zmianie. Informacja o zmianie RSO i jej nowa wysokość zostanie przekazana Pożyczkobiorcy na adres e-mail i na Profilu Klienta, na trwałym nośniku pozwalającym na jego zapisanie lub wydrukowanie, lub za pośrednictwem poczty.</li>
<li><strong>Odsetki umowne o zmiennej stopie procentowej &ndash;</strong> odsetki obliczone według RSO</li>
<li><strong>Strona Internetowa</strong> &ndash; strona internetowa pod adresem <a href="http://www.minicredit.pl">minicredit.pl</a></li>
<li><strong>Umowne Odsetki za op&oacute;źnienie </strong>&ndash; w wysokości odsetek maksymalnych za op&oacute;źnienie w rozumieniu art. 481 &sect; 2(1) Kodeksu cywilnego, r&oacute;wne dwukrotności sumy stopy referencyjnej Narodowego Banku Polskiego i 5,5 punkt&oacute;w procentowych, należne Pożyczkodawcy w przypadku nieterminowej spłaty Pożyczki przez Pożyczkobiorcę. Stopa procentowa odsetek maksymalnych za op&oacute;źnienie aktualna na dzień zawarcia Umowy wynosi 24% w skali roku. Zmiana stopy Odsetek za op&oacute;źnienie następuje w przypadku zmiany stopy referencyjnej Narodowego Banku Polskiego, odpowiednio do zmiany tej stopy. W przypadku zmiany stopy odsetek maksymalnych za op&oacute;źnienie Pożyczkodawca nalicza Odsetki za op&oacute;źnienie według nowej stopy od dnia zmiany stopy referencyjnej Narodowego Banku Polskiego.</li>
<li><strong>Data zawarcia umowy</strong> &ndash; data złożenia przez Pożyczkodawcę Dyspozycji wykonania wypłaty kwoty Pożyczki.</li>
<li><strong>Dzień Spłaty</strong> &ndash; dzień, w kt&oacute;rym Pożyczkobiorca jest zobowiązany spłacić Pożyczkę wraz z należnymi Pożyczkodawcy opłatami tj. Prowizją oraz Umownymi odsetkami kapitałowymi.</li>
<li><strong>Formularz Informacyjny </strong>&ndash; oznacza formularz informacyjny dotyczący kredytu konsumenckiego w rozumieniu Ustawy o kredycie konsumenckim, zawierający dane dotyczące udzielonej Pożyczki przesyłany Pożyczkobiorcy na trwałym nośniku w momencie składania wniosku o pożyczkę oraz po zawarciu Umowy Pożyczki.</li>
<li><strong>Konto bankowe do spłaty &ndash; </strong>rachunek bankowy Pożyczkodawcy znajdujący się w spisie rachunk&oacute;w bankowych na stronie internetowej oraz w Umowie.</li>
<li><strong>Całkowita Kwota do spłaty </strong>&ndash; oznacza sumę Całkowitej Kwoty Pożyczki oraz Całkowitego Kosztu Pożyczki.</li>
<li><strong>Całkowity Koszt Pożyczki </strong>&ndash; oznacza wszelkie koszty, jakie Pożyczkobiorca jest zobowiązany ponieść w związku z udzieloną Pożyczką w wysokości wskazanej w Warunkach Pożyczki, ustalone zgodnie z założeniami przyjętymi dla obliczenia RRSO.</li>
<li><strong>Formularz Internetowy</strong> &ndash; formalna część wniosku o udzielenie Pożyczki złożona Pożyczkodawcy przez Pożyczkobiorcę.</li>
<li><strong>Regulamin </strong>&ndash; Regulamin świadczenia usług elektronicznych.</li>
<li><strong>Trwały nośnik </strong>&ndash; materiały czy narzędzia (np. papier, płyta CD/DVD, czy mail) umożliwiające przechowywanie informacji w spos&oacute;b, umożliwiający dostęp do nich przez okres, w jakim informacje te będą przetwarzane. Trwały nośnik pozwala na odtworzenie informacji w niezmienionej postaci tj. bez ingerencji podmiotu, kt&oacute;ry był ich tw&oacute;rcą.</li>
</ul>
</li>
</ul>
<p><strong>2.2.&nbsp;&nbsp;&nbsp;&nbsp; </strong>W przypadku, sprzeczności jakichkolwiek postanowień Regulaminu lub innych dokument&oacute;w, stanowiących załączniki do Umowy, z niniejszą umową, każdorazowo pierwszeństwo mają zapisy umowy pożyczki zawartej z Użytkownikiem.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ul>
<li><strong> 3. KONTO UŻYTKOWNIKA</strong></li>
</ul>
<ul>
<li>Pożyczkobiorca oświadcza, iż jest Użytkownikiem i posiada dostęp do aktywnego Konta Użytkownika, przypisanego do Pożyczkobiorcy, założonego w Systemie teleinformatycznym Pożyczkodawcy, pod loginem {KLIENT.EMAIL}.</li>
<li>Zasady utworzenia Konta Użytkownika w Systemie teleinformatycznym Pożyczkodawcy szczeg&oacute;łowo zostały opisane w Regulaminie świadczenia usług elektronicznych i stanowią integralną cześć Umowy.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ul>
<li><strong> 4. OŚWIADCZENIA POŻYCZKOBIORCY</strong></li>
<li>Pożyczkobiorca oświadcza, iż przed złożeniem Dyspozycji zawarcia niniejszej umowy:</li>
<li>zapoznał się z treścią Umowy oraz oświadcza, iż treść Umowy jest dla niego całkowicie zrozumiała i ją w pełni akceptuje;</li>
<li><em>treść Umowy jest zgodna z wnioskiem o udzielenie pożyczki złożonym przez Pożyczkobiorcę za pośrednictwem Portalu Internetowego Pożyczkodawcy lub stanowi maksymalną kwotę pożyczki w całości zaakceptowaną przez Pożyczkobiorcę w ramach wnioskowania o udzielenie pożyczki;</em></li>
<li>otrzymał Formularz informacyjny na Trwałym nośniku, a pośrednictwem poczty elektronicznej, na wskazany w Koncie Użytkownika adres mailowy.</li>
<li>potwierdza w całości swoje dane osobowe wskazane w Formularzu informacyjnym;</li>
<li>rozumie i akceptuje wszelkie informacje, wskazane w Formularzu informacyjnym.</li>
<li>Pożyczkobiorca potwierdza, że jest konsumentem w rozumieniu Ustawy o kredycie konsumenckim i zawiera Umowę, w celu niezwiązanym z działalnością gospodarczą.</li>
<li>Pożyczkobiorca oświadcza, że w dacie zawarcia niniejszej Umowy:</li>
<li>posiada stałe miejsce zamieszkania na terenie Polski, numer PESEL oraz polski dow&oacute;d osobisty;</li>
<li>posiada pełną zdolność do czynności prawnych;</li>
<li>posiada zdolność do spłaty zobowiązań względem Pożyczkodawcy, powstałych na skutek zaciągnięcia pożyczki;</li>
<li>zawarcie Umowy, nie następuje z pokrzywdzeniem kt&oacute;regokolwiek z Wierzycieli Pożyczkobiorcy.</li>
</ul>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong> 5. OŚWIADCZENIA POŻYCZKODAWCY</strong></li>
<li>Pożyczkodawca oświadcza, iż:</li>
<li>jest podmiotem prowadzącym działalność gospodarczą, polegającą na udzielaniu pożyczek;</li>
<li>jest Instytucją Pożyczkową w rozumieniu Ustawy o kredycie konsumenckim, zgłoszoną do rejestru prowadzonego przez Komisję Nadzoru Finansowego.</li>
<li>Ponadto Pożyczkodawca oświadcza, iż:</li>
<li>posiada środki finansowe, umożliwiające mu realizacje niniejszej umowy;</li>
<li>nie jest niewypłacalny w rozumieniu ustawy prawo upadłościowe i naprawcze;</li>
<li>zawarcie Umowy, nie następuje z pokrzywdzeniem kt&oacute;regokolwiek z Wierzycieli Pożyczkobiorcy.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ul>
<li><strong> 6. WNIOSEK O UDZIELENIE POŻYCZKI</strong></li>
<li>Proces przygotowania i udzielania Pożyczki, każdorazowo inicjowany jest przez Pożyczkobiorcę, poprzez złożenie wniosku o udzielenie Pożyczki, za pośrednictwem Systemu teleinformatycznego Pożyczkodawcy, udostępnionego na Stronie Internetowej, zwany dalej Wnioskiem o Pożyczkę, na kt&oacute;rej Pożyczkobiorca ma przypisane indywidulane, zweryfikowane Konto Użytkownika, zwanego dalej Wniosku o Pożyczkę.</li>
<li>Wniosek o Pożyczkę składany jest elektronicznie poprzez uzupełnienie Formularza Internetowego, udostępnionego Użytkownikowi poprzez Konto Użytkownika.</li>
<li>Pożyczkodawca może odstąpić od obowiązku wypełnienia Formularza Internetowego w przypadku drugiej i następnej Pożyczki udzielanej na zasadach opisanych w Umowie i Regulaminie.</li>
<li>We Wniosku o Pożyczkę Użytkownik określa parametry umowy pożyczki, o jakiej wnioskowanie o udzielenie wnosi.</li>
<li>Proces składania Wniosku o pożyczkę kończy, złożenie przez Pożyczkobiorcę Dyspozycji, zatwierdzającej kwotę przyznanej Pożyczki, w Systemie teleinformatycznym Pożyczkodawcy albo odmowa udzielenia Pożyczki.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ul>
<li><strong> 7. KONTROLA KREDYTOWA</strong></li>
<li>Pożyczkobiorca upoważnia Pożyczkodawcę do przeprowadzenia Kontroli kredytowej, w celu ustalenia zdolności Pożyczkobiorcy do spłaty Pożyczki oraz analizy potrzeb konsumenta pod kątem adekwatności produktu o kt&oacute;ry wnioskuje.</li>
<li>Kontrola kredytowa inicjowana jest w chwili złożenia przez Pożyczkobiorcę Dyspozycji zawarcia umowy pożyczki, poprzez wypełnienie i przesłanie za pomocą Konta Użytkownika Wniosku o Pożyczkę.</li>
<li>Kontrola kredytowa obejmuje r&oacute;wnież weryfikację prawdziwości informacji podanych przez Pożyczkobiorcę w Formularzu Internetowym.</li>
<li>W celu weryfikacji prawdziwości informacji podanych przez Pożyczkobiorcę w Formularzu Internetowym Pożyczkodawca może uzależnić dalsze prowadzenie Kontroli Kredytowej od przedłożenia przez Pożyczkobiorcę Pożyczkodawcy dodatkowych dokument&oacute;w, kt&oacute;rych kopie Pożyczkobiorca przekazuje w formie elektronicznej, korzystając w tym celu z Konta Użytkownika lub adresu email: info@minicredit.pl.</li>
<li>W szczeg&oacute;lności Pożyczkodawca może żądać przedłożenia, następujących dokument&oacute;w: a) kopia dowodu osobistego &ndash; obie strony, prawo jazdy lub paszport, b) potwierdzenie numeru rachunku bankowego, np. pismo z banku, dow&oacute;d wypłaty z rachunku bankowego, wpłaty na rachunek bankowy, c) kopia wyciągu bankowego za ostatni miesiąc kalendarzowy, a w przypadku, gdy na wyciągu bankowym nie jest wskazany adres, rachunek za media (faktura VAT) wystawiony nie dawniej niż 3 miesiące przed datą złożenia przez Pożyczkobiorcę Wniosku o Pożyczkę, zawierający adres Pożyczkobiorcy.</li>
<li>W przypadku, gdy Pożyczkobiorca jest osobą fizyczną prowadzącą działalność gospodarczą, Pożyczkodawca może r&oacute;wnież zażądać przedłożenia dodatkowych dokument&oacute;w na przykład KPIR z trzech ostatnich miesięcy.</li>
<li>Wynik kontroli kredytowej w szczeg&oacute;lności zależy od: historii kredytowej Pożyczkobiorcy, wieku Pożyczkobiorcy, dochod&oacute;w uzyskiwanych przez Pożyczkobiorcę, zobowiązań Pożyczkobiorcy widniejących w bazach danych biur informacji gospodarczej.</li>
<li>Pożyczkobiorca przyjmuje do wiadomości, że wniosek o pożyczkę może zostać odrzucony, a Pożyczkobiorcy nie zostanie udzielona Pożyczka, r&oacute;wnież z następujących powod&oacute;w:
<ul>
<li>niezgodności danych zawartych we wniosku o pożyczkę z danymi w treści dokument&oacute;w przedstawionych przez Pożyczkobiorcę,</li>
<li>wygaśnięcia dokumentu tożsamości lub braku w dokumentach wszystkich wymaganych informacji</li>
<li>zobowiązania ze wcześniejszej Pożyczka nie były przez Pożyczkobiorcę spłacane terminowo.</li>
<li>adres podany przez Pożyczkobiorcę, jako jego adres zamieszkania został wcześniej zgłoszony, jako adres zamieszkania innego Pożyczkobiorcy.</li>
<li>numer telefonu podany przez Pożyczkobiorcę został wcześniej zgłoszony, jako numer telefonu innego Pożyczkobiorcy.</li>
<li>Adres email podany przez Pożyczkobiorcę został wcześniej zgłoszony, jak adres email innego Pożyczkobiorcy.</li>
<li>Pożyczkobiorca w przypadku poprzedniej pożyczki odstąpił od umowy pożyczki.</li>
<li>Weryfikacja telefoniczna Pożyczkobiorcy przebiegła negatywnie.</li>
<li>Pożyczkobiorca ogłosił upadłość konsumencką lub pozostaje w trakcie postępowania upadłościowego.</li>
</ul>
</li>
<li>Pożyczkodawca oceni zdolność kredytową Pożyczkobiorcy na podstawie informacji, zależnie od okoliczności, uzyskanych od Pożyczkobiorcy oraz jeżeli będzie to konieczne, na podstawie sprawdzenia odpowiedniej bazy danych. W przypadku odrzucenia wniosku na podstawie sprawdzenia bazy danych, Pożyczkodawca poinformuje Pożyczkobiorcę niezwłocznie, bezpłatnie, o wynikach takiego sprawdzenia określając bazę danych, kt&oacute;ra została sprawdzona.</li>
<li>Po wydaniu pozytywnej decyzji w sprawie udzielenia Pożyczki, Pożyczkodawca udostępni na trwałym nośniku Umowę Pożyczki, Formularz Informacyjny oraz Formularz Odstąpienia (w formie plik&oacute;w PDF umożliwiających ich zapisanie na komputerze Pożyczkobiorcy). Wymienione dokumenty będą wysłane w formie plik&oacute;w PDF na adres mailowy Pożyczkobiorcy, wskazany przez Pożyczkobiorcę w Koncie Użytkownika oraz będą widoczne po zalogowaniu się przez Pożyczkobiorcę na Koncie Użytkownika na Stronie Internetowej (w formie plik&oacute;w umożliwiających zapis na komputerze Pożyczkobiorcy).</li>
<li>Na wypadek gdyby Pożyczkodawca podjął decyzję o konieczności dodatkowej Kontroli Kredytowej w zakresie sprawdzenia baz danych Pożyczkobiorca udziela Pożyczkodawcy następujących zg&oacute;d:</li>
<li>Na podstawie art. 24 ust. 1 ustawy z dnia 9 kwietnia 2010 roku o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych, upoważniam Minicredit Sp. z o.o. do wystąpienia do Krajowego Biura Informacji Gospodarczej S.A. z siedzibą w Krakowie, ul. Lublańska 38, 31 &ndash; 476 Krak&oacute;w, zwanego dalej KBIG, o ujawnienie informacji gospodarczych dotyczących moich zobowiązań oraz upoważniam KBIG do ujawnienia Minicredit Sp. z o.o. tych informacji.</li>
<li>Na podstawie art. 18 ust. 1 pkt 2 ustawy z dnia 9 kwietnia 2010 roku o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych, udzielam zgody Minicredit Sp. z o.o. na przekazanie do Krajowego Biura Informacji Gospodarczej S.A. z siedzibą w Krakowie, ul. Lublańska 38, 31 &ndash; 476 Krak&oacute;w informacji gospodarczych o wywiązywaniu się ze wszelkich zobowiązań pieniężnych, zar&oacute;wno istniejących w chwili udzielenia zgody, jak r&oacute;wnież mogących powstać w przyszłości, a powstałych w związku z niniejszą umową o kredyt konsumencki zawartą z Pożyczkodawcą.&nbsp;</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ul>
<li><strong> 8. WARUNKI UDZIELENIA I SPŁATY POŻYCZKI</strong></li>
<li>Pożyczka zostanie udzielona w polskich złotych. W przypadku zmiany waluty obowiązującej w Polsce, Pożyczkodawca udzieli Pożyczki w aktualnej walucie.</li>
<li>Pożyczkodawca wypłaca pożyczkę Pożyczkobiorcy przelewając pożyczkę na Konto Pożyczkobiorcy podane przez Pożyczkobiorcę podczas rejestracji Wniosku o pożyczkę.</li>
<li>Pożyczka zostanie spłacona przez Pożyczkobiorcę jednorazowo w Dniu Spłaty tj. w terminie i na warunkach określonych niniejszą Umową.</li>
<li>Pożyczkobiorca dokona spłaty Pożyczki na rachunek bankowy Pożyczkodawcy numer {b%POZYCZKA.NUMER_SUBKONTA} lub za pośrednictwem szybkiego przelewu Przelewy24.</li>
<li>Strony Umowy ustalają, iż co najmniej 3 dni przed Datą Spłaty Pożyczkodawca może rozpocząć działania mające na celu przypomnienie o zbliżającym się terminie zapłaty.</li>
<li>W przypadku niedokonania przez Pożyczkobiorcę spłaty Całkowitej Kwoty do spłaty w Dniu spłaty, Pożyczkodawca wyśle Pożyczkobiorcy zawiadomienie o istniejącym zadłużeniu w dowolnej formie określonej niniejszą Umową.</li>
<li>Zawiadomienia są wysyłane do Pożyczkobiorcy w formie wiadomości tekstowych SMS, za pośrednictwem poczty elektronicznej oraz za pośrednictwem poczty zwykłej lub poleconej. Zawiadomienia są wysyłane na numer telefonu i adres poczty telefonicznej oraz adres zamieszkania lub adres korespondencyjny wskazane przez Pożyczkobiorcę na Koncie Użytkownika.</li>
<li>W przypadku niedokonania przez Pożyczkobiorcę spłaty Pożyczki w Dniu Spłaty, Pożyczkodawca może korzystać z usług podmiot&oacute;w specjalizujących się w windykacji należności, na co Pożyczkobiorca wyraża zgodę.</li>
<li>Strony niniejszej umowy nie przewidują możliwości przedłużenia terminu spłaty Całkowitej kwoty do spłaty, odnowienia Pożyczki ani oferowania Pożyczkobiorcy nowej pożyczki, w przypadku niedokonania spłaty Całkowitej kwoty do spłaty.</li>
<li>W przypadku niedokonania przez Pożyczkobiorcę spłaty Całkowitej kwoty do spłaty w Dniu Spłaty, Pożyczkodawca może dochodzić spłaty Całkowitej kwoty do spłaty wraz z wszystkimi innymi wymagalnymi należnościami na drodze postępowania sądowego. Na podstawie prawomocnego wyroku zasądzającego Całkowitej kwoty do spłaty wraz z innymi wymagalnymi należnościami, Pożyczkobiorca może być obciążony kosztami procesu na podstawie powszechnie obowiązującego prawa.</li>
<li>Pożyczkodawca jest uprawniony do dokonania cesji wierzytelności, w tym niewymagalnych, wynikających z tytułu Umowy Pożyczki, na rzecz os&oacute;b trzecich bez zgody Klienta. Klient zostanie powiadomiony o dokonaniu cesji.</li>
<li>Otrzymywane środki pieniężne będą zaliczane przez Pożyczkodawcę według następującej kolejności: koszty związane z postępowaniem sądowym i egzekucyjnym, jeśli takie powstały zgodnie z Umową Pożyczki; Odsetki za op&oacute;źnienie, jeśli takie powstały zgodnie z Umową; Odsetki kapitałowe; Prowizja administracyjna, Prowizja przygotowawcza, kwota Pożyczki.</li>
<li>Pożyczkobiorca ma możliwość spłaty części lub całości kwoty Pożyczki przed Dniem Spłaty bez ponoszenia z tego tytułu dodatkowych opłat.</li>
<li>W przypadku spłaty całości lub części Pożyczki przed Dniem Spłaty Pożyczkobiorca jest zobowiązany dokonać spłaty takiej kwoty Pożyczki wraz z odpowiednimi opłatami obliczonymi proporcjonalnie do spłacanej kwoty oraz do daty wcześniejszej spłaty.</li>
<li>Roszczenia Pożyczkobiorcy, kt&oacute;re powstają wskutek częściowej przedterminowej spłaty Pożyczki, będą ulegały potrąceniu z roszczeniami Pożyczkodawcy o spłatę pozostałej części Pożyczki niezwłocznie po powstaniu tychże roszczeń i bez konieczności składania w tym przedmiocie jakichkolwiek oświadczeń przez strony.</li>
<li>W przypadku, gdy po całkowitej wcześniejszej spłacie Pożyczki i innych wymagalnych zobowiązań Pożyczkobiorcy wobec Pożyczkodawcy, pozostaną środki podlegające zwrotowi Pożyczkobiorcy, Pożyczkodawca dokona rozliczenia tych środk&oacute;w w terminie 14 dni od dnia dokonania wcześniejszej spłaty Pożyczki.</li>
<li>W przypadku nieterminowej spłaty przez Pożyczkobiorcę Całkowitej kwoty do spłaty w Dniu Spłaty Pożyczkodawca ma prawo naliczyć Umowne Odsetki za op&oacute;źnienie oraz prowadzić czynności upominawcze i windykacyjne.</li>
<li>W przypadku spełnienia warunk&oacute;w określonych w ustawie z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych (Dz. U. z 2010 r., Nr 81, poz. 530 z p&oacute;źn. zm.), Pożyczkodawca jest uprawniony do przekazania informacji o zaległych należnościach Pożyczkodawcy wobec Pożyczkobiorcy do Biur Informacji Gospodarczych.</li>
</ul>
<p><strong>&nbsp;</strong></p>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong> 9. ZAWARCIE UMOWY POŻYCZKI</strong></li>
</ul>
<p>Strony niniejszej umowy ustalają, iż oświadczenia woli potwierdzające zawarcie niniejszej umowy pożyczki złożone zostały w następujący spos&oacute;b:</p>
<ul>
<li>Za Pożyczkobiorcę: w chwili złożenia Dyspozycji, zatwierdzającej kwotę przyznanej Pożyczki, tj. dokonując czynności akceptacji kwoty przyznanej pożyczki, za pośrednictwem Sytemu Teleinformatycznego Pożyczkodawcy, w kt&oacute;rym Pożyczkobiorca posiada aktywne Konto Użytkownika.</li>
<li>Za Pożyczkodawcę: w chwili złożenia przez Pożyczkodawcę Dyspozycji wykonania wypłaty kwoty Pożyczki.</li>
</ul>
<p><strong>&nbsp;</strong></p>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong> 10. ODSTĄPIENIE OD UMOWY POŻYCZKI</strong></li>
<li>Pożyczkobiorca ma prawo odstąpić od Umowy Pożyczki w ciągu 14 dni od daty jej zawarcia.</li>
<li>Pożyczkobiorca wykonuje prawo do odstąpienia poprzez przesłanie na adres korespondencyjny Pożyczkodawcy (ul. Migdałowa 4, 02-795&nbsp;Warszawa) pisemnego oświadczenia o odstąpieniu lub zeskanowanego oświadczenia opatrzonego czytelnym podpisem Pożyczkobiorcy zawierającym imię i nazwisko na adres poczty elektronicznej zamieszczony na Stronie Internetowej (info@minicredit.pl). Wz&oacute;r Formularza Odstąpienia jest dostępny po zalogowaniu się na Stronie Internetowej, jak r&oacute;wnież zostaje przesłany Pożyczkobiorcy po każdorazowym zawarciu Umowy Pożyczki (w formie pliku PDF umożliwiającego zapisanie na komputerze Pożyczkobiorcy). Nie wyłącza to prawa do odstąpienia od umowy w przypadku nie budzącego wątpliwości oświadczenia woli złożonego przez Pożyczkobiorcę Pożyczkodawcy w innej formie.</li>
<li>W razie skorzystania z odstąpienia od umowy, Pożyczkobiorca jest zobowiązany zwr&oacute;cić Pożyczkodawcy kwotę wypłaconej Pożyczki. Zwrot powinien nastąpić na Konto bankowe do spłaty&nbsp;niezwłocznie, jednak nie p&oacute;źniej niż w terminie 30 dni od dnia złożenia oświadczenia o odstąpieniu. W razie op&oacute;źnienia w zwrocie, wypłacona Pożyczkobiorcy kwota Pożyczki staje się zadłużeniem przeterminowanym, od kt&oacute;rego pobierane są odsetki maksymalne za op&oacute;źnienie w wysokości r&oacute;wnej dwukrotności sumy aktualnej stopy referencyjnej Narodowego Banku Polskiego i 5,5 punkt&oacute;w procentowych (w stosunku rocznym), począwszy od 31. dnia po dniu złożenia oświadczenia o odstąpieniu do dnia spłaty. Wysokość odsetek maksymalnych za op&oacute;źnienie może ulegać zmianie na zasadach określonych w &sect; 15 ust. 1 Umowy.</li>
</ul>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>11. PROCEDURA REKLAMACJI</strong></li>
<li>W razie powzięcia przez Pożyczkobiorcę zastrzeżeń dotyczących usług świadczonych przez Pożyczkodawcę lub w razie stwierdzenia przez niego niewywiązywania się przez Pożyczkodawcę z przyjętych zobowiązań lub postępowania niezgodnego z przepisami prawa, może on niezależenie od uprawnień przysługujących mu na podstawie przepis&oacute;w prawa skierować do Pożyczkodawcy Reklamację.</li>
<li>Reklamacja może być złożona przez Pożyczkobiorcę:</li>
<li>w formie pisemnej &ndash; osobiście w siedzibie albo przesyłką pocztową na adres&nbsp;Pożyczkodawcy: ul. Migdałowa 4, 02-796 Warszawa</li>
<li>ustnie &ndash; telefonicznie pod numerem +48&nbsp;888&nbsp;444 852</li>
<li>w formie elektronicznej &ndash; na adres e - mail: info@minicredit.pl</li>
<li>Pożyczkodawca rozpatruje Reklamację niezwłocznie, nie p&oacute;źniej niż w terminie 30 dni od daty otrzymania Reklamacji. W szczeg&oacute;lnie skomplikowanych przypadkach, uniemożliwiających rozpatrzenie reklamacji i udzielenie odpowiedzi w terminie 30 dni, Pożyczkodawca w informacji przekazywanej Pożyczkobiorcy, kt&oacute;ry wystąpił z reklamacją wyjaśni przyczynę op&oacute;źnienia, wskazując okoliczności, kt&oacute;re muszą zostać ustalone dla rozpatrzenia sprawy oraz określi przewidywany termin rozpatrzenia reklamacji i udzielenia odpowiedzi, nieprzekraczający 60 dni od dnia otrzymania reklamacji.</li>
<li>O wyniku postępowania reklamacyjnego Pożyczkodawca powiadomi Pożyczkobiorcę przesyłką listową na adres pocztowy podany podczas rejestracji, a w przypadku jego braku, na inny adres pocztowy, podany w korespondencji. Odpowiedź na reklamację zostanie dostarczona pocztą elektroniczną na adres e-mail Pożyczkobiorcy wyłącznie na jego wniosek.</li>
<li>W przypadku nieuwzględnienia roszczenia wynikającego z Reklamacji, Pożyczkobiorca może:</li>
<li>wystąpić z wnioskiem o rozpatrzenie sprawy do Rzecznika Finansowego, zgodnie z ustawą z dnia 5 sierpnia 2015 r. o rozpatrywaniu reklamacji przez podmioty rynku finansowego i o Rzeczniku Finansowym (Dz. U. 2015, poz. 1348),</li>
<li>Wystąpić z pow&oacute;dztwem do sądu powszechnego ze wskazaniem podmiotu, kt&oacute;ry powinien być pozwany (Pożyczkodawca) i sądu miejscowo właściwego do rozpoznania sprawy.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>12. POSTANOWIENIA KOŃCOWE</strong></li>
<li>W przypadku podania przez Pożyczkobiorcę nieprawdziwych informacji i danych niezbędnych do jego właściwej weryfikacji i oceny zdolności kredytowej, Pożyczkodawca ma prawo wypowiedzieć Umowę Pożyczki ze skutkiem natychmiastowym.</li>
<li>Wypowiedzenie Umowy nie wpływa na obowiązek spłaty zobowiązań Pożyczkobiorcy względem Pożyczkodawcy, istniejących w chwili dokonania wypowiedzenia.</li>
<li>Jeżeli Pożyczkodawca nie wykonał lub nienależycie wykonał zobowiązanie wobec Pożyczkobiorcy, a żądanie przez Pożyczkobiorcę wykonania tego zobowiązania nie było skuteczne, Pożyczkobiorcy przysługuje prawo dochodzenia swoich roszczeń o wykonanie tego zobowiązania od Pożyczkodawcy</li>
<li>Prawem właściwym dla Umowy jest prawo polskie.</li>
<li>Prawa i obowiązki Pożyczkobiorcy wynikające z Umowy Pożyczki nie mogą zostać przeniesione na jakąkolwiek osobę trzecią bez uprzedniej pisemnej zgody Pożyczkodawcy.</li>
<li>Pożyczkodawca jest uprawniony do dokonania cesji wierzytelności w tym niewymagalnych, wynikających z tytułu Umowy na rzecz os&oacute;b trzecich. Pożyczkobiorca zostanie o tym fakcie powiadomiony.</li>
<li>Wszelkie spory pomiędzy Stronami będą rozwiązywane w pierwszej kolejności polubownie. W przypadku gdy Strony nie będą w stanie rozwiązać sporu polubownie, zostanie poddany on pod rozstrzygnięcie właściwemu sądowi powszechnemu.</li>
<li>Podmiotem uprawnionym, właściwym do pozasądowego rozstrzygania sporu wynikającego z Umowy pomiędzy Pożyczkobiorcą a Pożyczkodawcą jest Rzecznik Finansowy. Kontakt do Rzecznika Finansowego oraz szczeg&oacute;łowe informacje dotyczące postępowania dostępne są na stronie internetowej&nbsp;<a href="http://www.rf.gov.pl/">rf.gov.pl</a>. W celu rozstrzygnięcia sporu pomiędzy Pożyczkodawcą a Pożyczkobiorcą istnieje także możliwość skorzystania z platformy internetowej ODR, dostępnej pod adresem:&nbsp;<a href="http://ec.europa.eu/odr/">http://ec.europa.eu/odr/</a>. Platforma ODR ułatwia pozasądowe rozstrzyganie przez internet spor&oacute;w między konsumentami i przedsiębiorcami.</li>
<li>W okresie obowiązywania Umowy Pożyczkodawca zamierza się porozumiewać z Pożyczkobiorcą w języku polskim.</li>
<li>W sprawach nieuregulowanych w Umowie mają zastosowanie postanowienia, Kodeksu cywilnego oraz inne właściwe powszechnie obowiązujące przepisy prawa.</li>
<li>Organem właściwym w sprawach ochrony konsument&oacute;w jest Prezes Urzędu Ochrony Konkurencji i Konsument&oacute;w (Plac Powstańc&oacute;w Warszawy 1, 00-950 Warszawa).</li>
<li>Umowa została sporządzona w dw&oacute;ch jednobrzmiących egzemplarzach, po jednym dla każdej ze Stron.</li>
</ul>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>Załącznik nr 1</p>
<p>&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</p>
<p>&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;.</p>
<p>Imię, Nazwisko i adres Pożyczkobiorcy</p>
<p><strong>WZ&Oacute;R OŚWIADCZENIA O ODSTĄPIENIU OD UMOWY POZYCZKI</strong></p>
<p>&nbsp;</p>
<p>&nbsp;Oświadczam, że zgodnie z art. 58 w zw. z art.&nbsp; 53 ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim (Dz. U. Nr 126, poz. 715 z p&oacute;źn. zm.) odstępuję od Umowy Pożyczki nr _ _ _ _ _ _ _ _ _ _ _ _ _ _ _&nbsp; z&nbsp;dnia _ _ _ _ _ _ _ _ _ _ _ _ _ _.</p>
<p>&nbsp;</p>
<p>Jednocześnie oświadczam, że jestem świadomy/świadoma konieczności spłacenia wszelkich kwot otrzymanych przeze mnie od Pożyczkodawcy i zobowiązuję się dokonać ich przelewu niezwłocznie, a w żadnym przypadku nie p&oacute;źniej niż 30 dni od daty odstąpienia, na następujący rachunek bankowy:</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</p>
<p>Podpis Pożyczkobiorcy</p>`;






export {CONSENT_PEP as pep, CONSENT_INFO_CLAUSE as clause, CONSENT_RULES as rules, CONSENT_MARKETING as marketing, CONSENT_PHONE as phone, CONSENT_INFO_FORM as info_form, CONSENT_PWIP as pwip, CONSENT_CRIF as crif,
CONSENT_PASSTHRU as passthru, CONSENT_BIK as bik, CONSENT_BIK2 as bik2, CONSENT_RBOX as rbox, CONSENT_COOKIES as cookies, CONSENT_AGREEMENT as agreement}



// WEBPACK FOOTER //
// ./src/modal_details.js